/* eslint-disable */
!(function (e, t) {
  'object' == typeof exports && 'undefined' != typeof module
    ? t(exports)
    : 'function' == typeof define && define.amd
    ? define(['exports'], t)
    : t(((e = 'undefined' != typeof globalThis ? globalThis : e || self).mobiscroll = {}));
})(this, function (e) {
  'use strict';
  var t = function (e, n) {
    return (
      (t =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (e, t) {
            e.__proto__ = t;
          }) ||
        function (e, t) {
          for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }),
      t(e, n)
    );
  };
  function n(e, n) {
    if ('function' != typeof n && null !== n)
      throw new TypeError('Class extends value ' + String(n) + ' is not a constructor or null');
    function a() {
      this.constructor = e;
    }
    t(e, n), (e.prototype = null === n ? Object.create(n) : ((a.prototype = n.prototype), new a()));
  }
  var a = function () {
    return (
      (a =
        Object.assign ||
        function (e) {
          for (var t, n = 1, a = arguments.length; n < a; n++)
            for (var i in (t = arguments[n])) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
          return e;
        }),
      a.apply(this, arguments)
    );
  };
  function i(e, t) {
    var n = {};
    for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (n[a] = e[a]);
    if (null != e && 'function' == typeof Object.getOwnPropertySymbols) {
      var i = 0;
      for (a = Object.getOwnPropertySymbols(e); i < a.length; i++)
        t.indexOf(a[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[i]) && (n[a[i]] = e[a[i]]);
    }
    return n;
  }
  var s,
    r,
    o = (function () {
      function e() {
        (this.nr = 0), (this.keys = 1), (this.subscribers = {});
      }
      return (
        (e.prototype.subscribe = function (e) {
          var t = this.keys++;
          return (this.subscribers[t] = e), this.nr++, t;
        }),
        (e.prototype.unsubscribe = function (e) {
          this.nr--, delete this.subscribers[e];
        }),
        (e.prototype.next = function (e) {
          for (var t = this.subscribers, n = 0, a = Object.keys(t); n < a.length; n++) {
            var i = a[n];
            t[i] && t[i](e);
          }
        }),
        e
      );
    })(),
    l = [],
    c = !1,
    h = 'undefined' != typeof window,
    u = h && window.matchMedia && window.matchMedia('(prefers-color-scheme:dark)'),
    d = h ? navigator.userAgent : '',
    _ = h ? navigator.platform : '',
    p = h ? navigator.maxTouchPoints : 0,
    m = d && d.match(/Android|iPhone|iPad|iPod|Windows Phone|Windows|MSIE/i),
    f = d && /Safari/.test(d);
  /Android/i.test(m)
    ? ((s = 'android'),
      (r = d.match(/Android\s+([\d.]+)/i)),
      (c = !0),
      r && (l = r[0].replace('Android ', '').split('.')))
    : /iPhone|iPad|iPod/i.test(m) || /iPhone|iPad|iPod/i.test(_) || ('MacIntel' === _ && p > 1)
    ? ((s = 'ios'),
      (r = d.match(/OS\s+([\d_]+)/i)),
      (c = !0),
      r && (l = r[0].replace(/_/g, '.').replace('OS ', '').split('.')))
    : /Windows Phone/i.test(m)
    ? ((s = 'wp'), (c = !0))
    : /Windows|MSIE/i.test(m) && (s = 'windows');
  var v = +l[0],
    g = +l[1],
    y = {},
    b = {},
    x = {},
    C = {},
    w = new o();
  function T() {
    var e = '',
      t = '',
      n = '';
    for (var a in ((t = 'android' === s ? 'material' : 'wp' === s || 'windows' === s ? 'windows' : 'ios'), x)) {
      if (x[a].baseTheme === t && !1 !== x[a].auto && a !== t + '-dark') {
        e = a;
        break;
      }
      a === t ? (e = a) : n || (n = a);
    }
    return e || n;
  }
  function k(e, t, n) {
    var i = x[t];
    (x[e] = a({}, i, { auto: n, baseTheme: t })), (C.theme = T());
  }
  var S = { majorVersion: v, minorVersion: g, name: s },
    D =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"/></svg>',
    I =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"/></svg>',
    M =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"/></svg>',
    E =
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 217.9L383 345c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.3-24.6 0-34L273 167c-9.1-9.1-23.7-9.3-33.1-.7L95 310.9c-4.7 4.7-7 10.9-7 17s2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l127.1-127z"/></svg>',
    O =
      '<svg xmlns="http://www.w3.org/2000/svg" height="17" viewBox="0 0 17 17" width="17"><path d="M8.5 0a8.5 8.5 0 110 17 8.5 8.5 0 010-17zm3.364 5.005a.7.7 0 00-.99 0l-2.44 2.44-2.439-2.44-.087-.074a.7.7 0 00-.903 1.064l2.44 2.439-2.44 2.44-.074.087a.7.7 0 001.064.903l2.439-2.441 2.44 2.441.087.074a.7.7 0 00.903-1.064l-2.441-2.44 2.441-2.439.074-.087a.7.7 0 00-.074-.903z" fill="currentColor" fill-rule="evenodd"/></svg>',
    V = { clearIcon: O, labelStyle: 'inline' };
  (x.ios = {
    Calendar: { nextIconH: M, nextIconV: I, prevIconH: D, prevIconV: E },
    Checkbox: { position: 'end' },
    Datepicker: { clearIcon: O, display: 'bottom' },
    Dropdown: V,
    Eventcalendar: { chevronIconDown: I, nextIconH: M, nextIconV: I, prevIconH: D, prevIconV: E },
    Input: V,
    Radio: { position: 'end' },
    Scroller: { display: 'bottom', itemHeight: 34, minWheelWidth: 55, rows: 5, scroll3d: !0 },
    SegmentedGroup: { drag: !0 },
    Select: { clearIcon: O },
    Textarea: V,
  }),
    k('ios-dark', 'ios'),
    (C.theme = T());
  var N = void 0,
    P = q(3),
    L = q(4),
    H = q(7);
  function R(e, t, n) {
    return Math.max(t, Math.min(e, n));
  }
  function z(e) {
    return Array.isArray(e);
  }
  function Y(e) {
    return e - parseFloat(e) >= 0;
  }
  function A(e) {
    return 'number' == typeof e;
  }
  function F(e) {
    return 'string' == typeof e;
  }
  function W(e) {
    return e === N || null === e || '' === e;
  }
  function U(e) {
    return void 0 === e;
  }
  function j(e) {
    return 'object' == typeof e;
  }
  function B(e) {
    return null !== e && e !== N && '' + e != 'false';
  }
  function q(e) {
    return Array.apply(0, Array(Math.max(0, e)));
  }
  function X(e) {
    return e !== N ? e + (Y(e) ? 'px' : '') : '';
  }
  function K() {}
  function G(e, t) {
    void 0 === t && (t = 2);
    for (var n = e + ''; n.length < t; ) n = '0' + n;
    return n;
  }
  function J(e) {
    return Math.round(e);
  }
  function Z(e, t) {
    return $(e / t) * t;
  }
  function $(e) {
    return Math.floor(e);
  }
  function Q(e, t) {
    var n;
    return (
      void 0 === t && (t = 100),
      function () {
        for (var a = [], i = 0; i < arguments.length; i++) a[i] = arguments[i];
        clearTimeout(n),
          (n = setTimeout(function () {
            e.apply(void 0, a);
          }, t));
      }
    );
  }
  function ee(e, t) {
    e._cdr ? setTimeout(t) : t();
  }
  function te(e, t) {
    return ne(e, t);
  }
  function ne(e, t, n) {
    for (var a = e.length, i = 0; i < a; i++) {
      var s = e[i];
      if (t(s, i)) return n ? i : s;
    }
    return n ? -1 : N;
  }
  function ae(e, t) {
    return z(e) ? e.map(t) : t(e, 0, [e]);
  }
  q(24);
  var ie = h ? document : N,
    se = h ? window : N,
    re = ['Webkit', 'Moz'],
    oe = ie && ie.createElement('div').style,
    le = ie && ie.createElement('canvas'),
    ce = le && le.getContext && le.getContext('2d', { willReadFrequently: !0 }),
    he = se && se.CSS,
    ue = he && he.supports,
    de = {},
    _e =
      (se && se.requestAnimationFrame) ||
      function (e) {
        return setTimeout(e, 20);
      },
    pe =
      (se && se.cancelAnimationFrame) ||
      function (e) {
        clearTimeout(e);
      },
    me = oe && oe.animationName !== N,
    fe = 'ios' === s && !f,
    ve = fe && se && se.webkit && se.webkit.messageHandlers,
    ge = (oe && oe.touchAction === N) || (fe && !ve),
    ye = (function () {
      if (!oe || oe.transform !== N) return '';
      for (var e = 0, t = re; e < t.length; e++) {
        var n = t[e];
        if (oe[n + 'Transform'] !== N) return n;
      }
      return '';
    })(),
    be = ye ? '-' + ye.toLowerCase() + '-' : '',
    xe = ue && ue('(transform-style: preserve-3d)');
  function Ce(e, t, n, a) {
    e && e.addEventListener(t, n, a);
  }
  function we(e, t, n, a) {
    e && e.removeEventListener(t, n, a);
  }
  function Te(e) {
    return h ? (e && e.ownerDocument ? e.ownerDocument : ie) : N;
  }
  function ke(e, t) {
    return parseFloat(getComputedStyle(e)[t] || '0');
  }
  function Se(e) {
    return e.scrollLeft !== N ? e.scrollLeft : e.pageXOffset;
  }
  function De(e) {
    return e.scrollTop !== N ? e.scrollTop : e.pageYOffset;
  }
  function Ie(e) {
    return h ? (e && e.ownerDocument && e.ownerDocument.defaultView ? e.ownerDocument.defaultView : se) : N;
  }
  function Me(e, t) {
    var n = getComputedStyle(e),
      a = (ye ? n[ye + 'Transform'] : n.transform).split(')')[0].split(', ');
    return +(t ? a[13] || a[5] : a[12] || a[4]) || 0;
  }
  function Ee(e) {
    if (!ce || !e) return '#000';
    if (de[e]) return de[e];
    (ce.fillStyle = e), ce.fillRect(0, 0, 1, 1);
    var t = ce.getImageData(0, 0, 1, 1),
      n = t ? t.data : [0, 0, 0],
      a = 0.299 * +n[0] + 0.587 * +n[1] + 0.114 * +n[2] < 130 ? '#fff' : '#000';
    return (de[e] = a), a;
  }
  function Oe(e, t, n, a, i, s, r) {
    var o,
      l,
      c = Math.min(1, (+new Date() - t) / 468),
      h = 0.5 * (1 - Math.cos(Math.PI * c));
    i !== N && ((o = J(n + (i - n) * h)), (e.scrollLeft = o)),
      s !== N && ((l = J(a + (s - a) * h)), (e.scrollTop = l)),
      o !== i || l !== s
        ? _e(function () {
            Oe(e, t, n, a, i, s, r);
          })
        : r && r();
  }
  function Ve(e, t, n, a, i, s) {
    t !== N && (t = Math.max(0, J(t))),
      n !== N && (n = Math.max(0, J(n))),
      i && t !== N && (t = -t),
      a
        ? Oe(e, +new Date(), e.scrollLeft, e.scrollTop, t, n, s)
        : (t !== N && (e.scrollLeft = t), n !== N && (e.scrollTop = n), s && s());
  }
  function Ne(e) {
    var t = e.getBoundingClientRect(),
      n = { left: t.left, top: t.top },
      a = Ie(e);
    return a !== N && ((n.top += De(a)), (n.left += Se(a))), n;
  }
  function Pe(e, t) {
    var n = e && (e.matches || e.msMatchesSelector);
    return n && n.call(e, t);
  }
  function Le(e, t, n) {
    for (; e && !Pe(e, t); ) {
      if (e === n || e.nodeType === e.DOCUMENT_NODE) return null;
      e = e.parentNode;
    }
    return e;
  }
  function He(e, t, n) {
    var a;
    try {
      a = new CustomEvent(t, { bubbles: !0, cancelable: !0, detail: n });
    } catch (e) {
      (a = document.createEvent('Event')).initEvent(t, !0, !0), (a.detail = n);
    }
    e.dispatchEvent(a);
  }
  function Re(e, t) {
    for (var n = 0; n < e.length; n++) t(e[n], n);
  }
  ue && (ue('position', 'sticky') || ue('position', '-webkit-sticky'));
  var ze = {},
    Ye = [],
    Ae = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
  function Fe(e, t) {
    for (var n in t) e[n] = t[n];
    return e;
  }
  function We(e) {
    var t = e.parentNode;
    t && t.removeChild(e);
  }
  var Ue = {
    _catchError: function (e, t) {
      for (var n, a, i; (t = t._parent); )
        if ((n = t._component) && !n._processingException)
          try {
            if (
              ((a = n.constructor) &&
                null != a.getDerivedStateFromError &&
                (n.setState(a.getDerivedStateFromError(e)), (i = n._dirty)),
              null != n.componentDidCatch && (n.componentDidCatch(e), (i = n._dirty)),
              i)
            )
              return (n._pendingError = n);
          } catch (t) {
            e = t;
          }
      throw e;
    },
    _vnodeId: 0,
  };
  function je(e, t, n) {
    var a,
      i,
      s,
      r = {};
    for (s in t) 'key' == s ? (a = t[s]) : 'ref' == s ? (i = t[s]) : (r[s] = t[s]);
    if (arguments.length > 3) for (n = [n], s = 3; s < arguments.length; s++) n.push(arguments[s]);
    if ((null != n && (r.children = n), 'function' == typeof e && null != e.defaultProps))
      for (s in e.defaultProps) void 0 === r[s] && (r[s] = e.defaultProps[s]);
    return Be(e, r, a, i, null);
  }
  function Be(e, t, n, a, i) {
    var s = {
      type: e,
      props: t,
      key: n,
      ref: a,
      _children: null,
      _parent: null,
      _depth: 0,
      _dom: null,
      _nextDom: void 0,
      _component: null,
      _hydrating: null,
      constructor: void 0,
      _original: null == i ? ++Ue._vnodeId : i,
    };
    return null != Ue.vnode && Ue.vnode(s), s;
  }
  function qe(e) {
    return e.children;
  }
  function Xe(e, t) {
    (this.props = e), (this.context = t);
  }
  function Ke(e, t) {
    if (null == t) return e._parent ? Ke(e._parent, e._parent._children.indexOf(e) + 1) : null;
    for (var n; t < e._children.length; t++) if (null != (n = e._children[t]) && null != n._dom) return n._dom;
    return 'function' == typeof e.type ? Ke(e) : null;
  }
  function Ge(e) {
    var t = e._vnode,
      n = t._dom,
      a = e._parentDom;
    if (a) {
      var i = [],
        s = Fe({}, t);
      (s._original = t._original + 1),
        ct(
          a,
          t,
          s,
          e._globalContext,
          void 0 !== a.ownerSVGElement,
          null != t._hydrating ? [n] : null,
          i,
          null == n ? Ke(t) : n,
          t._hydrating,
        ),
        ht(i, t),
        t._dom != n && Je(t);
    }
  }
  function Je(e) {
    if (null != (e = e._parent) && null != e._component) {
      e._dom = e._component.base = null;
      for (var t = 0; t < e._children.length; t++) {
        var n = e._children[t];
        if (null != n && null != n._dom) {
          e._dom = e._component.base = n._dom;
          break;
        }
      }
      return Je(e);
    }
  }
  (Xe.prototype.setState = function (e, t) {
    var n;
    (n =
      null != this._nextState && this._nextState !== this.state
        ? this._nextState
        : (this._nextState = Fe({}, this.state))),
      'function' == typeof e && (e = e(Fe({}, n), this.props)),
      e && Fe(n, e),
      null != e && this._vnode && (t && this._renderCallbacks.push(t), et(this));
  }),
    (Xe.prototype.forceUpdate = function (e) {
      this._vnode && ((this._force = !0), e && this._renderCallbacks.push(e), et(this));
    }),
    (Xe.prototype.render = qe);
  var Ze,
    $e = [],
    Qe = 'function' == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout;
  function et(e) {
    ((!e._dirty && (e._dirty = !0) && $e.push(e) && !tt._rerenderCount++) || Ze !== Ue.debounceRendering) &&
      ((Ze = Ue.debounceRendering) || Qe)(tt);
  }
  function tt() {
    for (var e; (tt._rerenderCount = $e.length); )
      (e = $e.sort(function (e, t) {
        return e._vnode._depth - t._vnode._depth;
      })),
        ($e = []),
        e.some(function (e) {
          e._dirty && Ge(e);
        });
  }
  function nt(e, t, n, a, i, s, r, o, l, c) {
    var h,
      u,
      d,
      _,
      p,
      m,
      f,
      v = (a && a._children) || Ye,
      g = v.length;
    for (n._children = [], h = 0; h < t.length; h++)
      if (
        null !=
        (_ =
          null == (_ = t[h]) || 'boolean' == typeof _
            ? (n._children[h] = null)
            : 'string' == typeof _ || 'number' == typeof _ || 'bigint' == typeof _
            ? (n._children[h] = Be(null, _, null, null, _))
            : Array.isArray(_)
            ? (n._children[h] = Be(qe, { children: _ }, null, null, null))
            : _._depth > 0
            ? (n._children[h] = Be(_.type, _.props, _.key, null, _._original))
            : (n._children[h] = _))
      ) {
        if (
          ((_._parent = n),
          (_._depth = n._depth + 1),
          null === (d = v[h]) || (d && _.key == d.key && _.type === d.type))
        )
          v[h] = void 0;
        else
          for (u = 0; u < g; u++) {
            if ((d = v[u]) && _.key == d.key && _.type === d.type) {
              v[u] = void 0;
              break;
            }
            d = null;
          }
        ct(e, _, (d = d || ze), i, s, r, o, l, c),
          (p = _._dom),
          (u = _.ref) &&
            d.ref != u &&
            (f || (f = []), d.ref && f.push(d.ref, null, _), f.push(u, _._component || p, _)),
          null != p
            ? (null == m && (m = p),
              'function' == typeof _.type && null != _._children && _._children === d._children
                ? (_._nextDom = l = at(_, l, e))
                : (l = it(e, _, d, v, p, l)),
              c || 'option' !== n.type ? 'function' == typeof n.type && (n._nextDom = l) : (e.value = ''))
            : l && d._dom == l && l.parentNode != e && (l = Ke(d));
      }
    for (n._dom = m, h = g; h--; )
      null != v[h] &&
        ('function' == typeof n.type && null != v[h]._dom && v[h]._dom == n._nextDom && (n._nextDom = Ke(a, h + 1)),
        dt(v[h], v[h]));
    if (f) for (h = 0; h < f.length; h++) ut(f[h], f[++h], f[++h]);
  }
  function at(e, t, n) {
    for (var a = 0; a < e._children.length; a++) {
      var i = e._children[a];
      i && ((i._parent = e), (t = 'function' == typeof i.type ? at(i, t, n) : it(n, i, i, e._children, i._dom, t)));
    }
    return t;
  }
  function it(e, t, n, a, i, s) {
    var r;
    if (void 0 !== t._nextDom) (r = t._nextDom), (t._nextDom = void 0);
    else if (null == n || i != s || null == i.parentNode)
      e: if (null == s || s.parentNode !== e) e.appendChild(i), (r = null);
      else {
        for (var o = s, l = 0; (o = o.nextSibling) && l < a.length; l += 2) if (o == i) break e;
        e.insertBefore(i, s), (r = s);
      }
    return (s = void 0 !== r ? r : i.nextSibling);
  }
  function st(e, t, n) {
    '-' === t[0]
      ? e.setProperty(t, n)
      : null == n
      ? (e[t] = '')
      : 'number' != typeof n || Ae.test(t)
      ? (e[t] = n)
      : (e[t] = n + 'px');
  }
  function rt(e, t, n, a, i) {
    var s;
    e: if ('style' === t)
      if ('string' == typeof n) e.style.cssText = n;
      else {
        if (('string' == typeof a && (e.style.cssText = a = ''), a)) for (t in a) (n && t in n) || st(e.style, t, '');
        if (n) for (t in n) (a && n[t] === a[t]) || st(e.style, t, n[t]);
      }
    else if ('o' === t[0] && 'n' === t[1])
      if (
        ((s = t !== (t = t.replace(/Capture$/, ''))),
        (t = t.toLowerCase() in e ? t.toLowerCase().slice(2) : t.slice(2)),
        e._listeners || (e._listeners = {}),
        (e._listeners[t + s] = n),
        n)
      ) {
        if (!a) {
          var r = s ? lt : ot;
          e.addEventListener(t, r, s);
        }
      } else {
        var o = s ? lt : ot;
        e.removeEventListener(t, o, s);
      }
    else if ('dangerouslySetInnerHTML' !== t) {
      if (i) t = t.replace(/xlink[H:h]/, 'h').replace(/sName$/, 's');
      else if ('href' !== t && 'list' !== t && 'form' !== t && 'tabIndex' !== t && 'download' !== t && t in e)
        try {
          e[t] = null == n ? '' : n;
          break e;
        } catch (e) {}
      'function' == typeof n ||
        (null != n && (!1 !== n || ('a' === t[0] && 'r' === t[1])) ? e.setAttribute(t, n) : e.removeAttribute(t));
    }
  }
  function ot(e) {
    this._listeners[e.type + !1](Ue.event ? Ue.event(e) : e);
  }
  function lt(e) {
    this._listeners[e.type + !0](Ue.event ? Ue.event(e) : e);
  }
  function ct(e, t, n, a, i, s, r, o, l) {
    var c,
      h = t.type;
    if (void 0 !== t.constructor) return null;
    null != n._hydrating && ((l = n._hydrating), (o = t._dom = n._dom), (t._hydrating = null), (s = [o])),
      (c = Ue._diff) && c(t);
    try {
      e: if ('function' == typeof h) {
        var u,
          d,
          _,
          p,
          m,
          f,
          v = t.props,
          g = (c = h.contextType) && a[c._id],
          y = c ? (g ? g.props.value : c._defaultValue) : a;
        if (
          (n._component
            ? (f = (u = t._component = n._component)._processingException = u._pendingError)
            : ('prototype' in h && h.prototype.render
                ? (t._component = u = new h(v, y))
                : ((t._component = u = new Xe(v, y)), (u.constructor = h), (u.render = _t)),
              g && g.sub(u),
              (u.props = v),
              u.state || (u.state = {}),
              (u.context = y),
              (u._globalContext = a),
              (d = u._dirty = !0),
              (u._renderCallbacks = [])),
          null == u._nextState && (u._nextState = u.state),
          null != h.getDerivedStateFromProps &&
            (u._nextState == u.state && (u._nextState = Fe({}, u._nextState)),
            Fe(u._nextState, h.getDerivedStateFromProps(v, u._nextState))),
          (_ = u.props),
          (p = u.state),
          d)
        )
          null == h.getDerivedStateFromProps && null != u.componentWillMount && u.componentWillMount(),
            null != u.componentDidMount && u._renderCallbacks.push(u.componentDidMount);
        else {
          if (
            (null == h.getDerivedStateFromProps &&
              v !== _ &&
              null != u.componentWillReceiveProps &&
              u.componentWillReceiveProps(v, y),
            (!u._force && null != u.shouldComponentUpdate && !1 === u.shouldComponentUpdate(v, u._nextState, y)) ||
              t._original === n._original)
          ) {
            (u.props = v),
              (u.state = u._nextState),
              t._original !== n._original && (u._dirty = !1),
              (u._vnode = t),
              (t._dom = n._dom),
              (t._children = n._children),
              t._children.forEach(function (e) {
                e && (e._parent = t);
              }),
              u._renderCallbacks.length && r.push(u);
            break e;
          }
          null != u.componentWillUpdate && u.componentWillUpdate(v, u._nextState, y),
            null != u.componentDidUpdate &&
              u._renderCallbacks.push(function () {
                u.componentDidUpdate(_, p, m);
              });
        }
        (u.context = y),
          (u.props = v),
          (u.state = u._nextState),
          (c = Ue._render) && c(t),
          (u._dirty = !1),
          (u._vnode = t),
          (u._parentDom = e),
          (c = u.render(u.props, u.state, u.context)),
          (u.state = u._nextState),
          null != u.getChildContext && (a = Fe(Fe({}, a), u.getChildContext())),
          d || null == u.getSnapshotBeforeUpdate || (m = u.getSnapshotBeforeUpdate(_, p));
        var b = null != c && c.type === qe && null == c.key ? c.props.children : c;
        nt(e, Array.isArray(b) ? b : [b], t, n, a, i, s, r, o, l),
          (u.base = t._dom),
          (t._hydrating = null),
          u._renderCallbacks.length && r.push(u),
          f && (u._pendingError = u._processingException = null),
          (u._force = !1);
      } else
        null == s && t._original === n._original
          ? ((t._children = n._children), (t._dom = n._dom))
          : (t._dom = (function (e, t, n, a, i, s, r, o) {
              var l = n.props,
                c = t.props,
                h = t.type,
                u = 0;
              'svg' === h && (i = !0);
              if (null != s)
                for (; u < s.length; u++) {
                  var d = s[u];
                  if (d && (d === e || (h ? d.localName == h : 3 == d.nodeType))) {
                    (e = d), (s[u] = null);
                    break;
                  }
                }
              if (null == e) {
                if (null === h) return document.createTextNode(c);
                (e = i
                  ? document.createElementNS('http://www.w3.org/2000/svg', h)
                  : document.createElement(h, c.is && c)),
                  (s = null),
                  (o = !1);
              }
              if (null === h) l === c || (o && e.data === c) || (e.data = c);
              else {
                s = s && Ye.slice.call(e.childNodes);
                var _ = (l = n.props || ze).dangerouslySetInnerHTML,
                  p = c.dangerouslySetInnerHTML;
                if (
                  (o ||
                    (null != s && (l = {}),
                    (p || _) &&
                      ((p && ((_ && p.__html == _.__html) || p.__html === e.innerHTML)) ||
                        (e.innerHTML = (p && p.__html) || ''))),
                  (function (e, t, n, a, i) {
                    var s;
                    for (s in n) 'children' === s || 'key' === s || s in t || rt(e, s, null, n[s], a);
                    for (s in t)
                      (i && 'function' != typeof t[s]) ||
                        'children' === s ||
                        'key' === s ||
                        'value' === s ||
                        'checked' === s ||
                        n[s] === t[s] ||
                        rt(e, s, t[s], n[s], a);
                  })(e, c, l, i, o),
                  p)
                )
                  t._children = [];
                else if (
                  ((u = t.props.children),
                  nt(e, Array.isArray(u) ? u : [u], t, n, a, i && 'foreignObject' !== h, s, r, e.firstChild, o),
                  null != s)
                )
                  for (u = s.length; u--; ) null != s[u] && We(s[u]);
                o ||
                  ('value' in c &&
                    void 0 !== (u = c.value) &&
                    (u !== e.value || ('progress' === h && !u)) &&
                    rt(e, 'value', u, l.value, !1),
                  'checked' in c &&
                    void 0 !== (u = c.checked) &&
                    u !== e.checked &&
                    rt(e, 'checked', u, l.checked, !1));
              }
              return e;
            })(n._dom, t, n, a, i, s, r, l));
      (c = Ue.diffed) && c(t);
    } catch (e) {
      (t._original = null),
        (l || null != s) && ((t._dom = o), (t._hydrating = !!l), (s[s.indexOf(o)] = null)),
        Ue._catchError(e, t, n);
    }
  }
  function ht(e, t) {
    Ue._commit && Ue._commit(t, e),
      e.some(function (t) {
        try {
          (e = t._renderCallbacks),
            (t._renderCallbacks = []),
            e.some(function (e) {
              e.call(t);
            });
        } catch (e) {
          Ue._catchError(e, t._vnode);
        }
      });
  }
  function ut(e, t, n) {
    try {
      'function' == typeof e ? e(t) : (e.current = t);
    } catch (e) {
      Ue._catchError(e, n);
    }
  }
  function dt(e, t, n) {
    var a, i;
    if (
      (Ue.unmount && Ue.unmount(e),
      (a = e.ref) && ((a.current && a.current !== e._dom) || ut(a, null, t)),
      n || 'function' == typeof e.type || (n = null != (i = e._dom)),
      (e._dom = e._nextDom = void 0),
      null != (a = e._component))
    ) {
      if (a.componentWillUnmount)
        try {
          a.componentWillUnmount();
        } catch (e) {
          Ue._catchError(e, t);
        }
      a.base = a._parentDom = null;
    }
    if ((a = e._children)) for (var s = 0; s < a.length; s++) a[s] && dt(a[s], t, n);
    null != i && We(i);
  }
  function _t(e, t, n) {
    return this.constructor(e, n);
  }
  function pt(e, t, n) {
    Ue._root && Ue._root(e, t);
    var a = 'function' == typeof n,
      i = a ? null : (n && n._children) || t._children,
      s = [];
    ct(
      t,
      (e = ((!a && n) || t)._children = je(qe, null, [e])),
      i || ze,
      ze,
      void 0 !== t.ownerSVGElement,
      !a && n ? [n] : i ? null : t.firstChild ? Ye.slice.call(t.childNodes) : null,
      s,
      !a && n ? n : i ? i._dom : t.firstChild,
      a,
    ),
      ht(s, e);
  }
  tt._rerenderCount = 0;
  var mt = 0;
  function ft(e, t) {
    var n = {
      _id: (t = '__cC' + mt++),
      _defaultValue: e,
      Consumer: function (e, t) {
        return e.children(t);
      },
      Provider: function (e) {
        if (!this.getChildContext) {
          var n = [],
            a = {};
          (a[t] = this),
            (this.getChildContext = function () {
              return a;
            }),
            (this.shouldComponentUpdate = function (e) {
              this.props.value !== e.value && n.some(et);
            }),
            (this.sub = function (e) {
              n.push(e);
              var t = e.componentWillUnmount;
              e.componentWillUnmount = function () {
                n.splice(n.indexOf(e), 1), t && t.call(e);
              };
            });
        }
        return e.children;
      },
    };
    return (n.Provider._contextRef = n.Consumer.contextType = n);
  }
  var vt = (function (e) {
    function t() {
      return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
      n(t, e),
      (t.prototype.render = function () {}),
      (t.prototype.shouldComponentUpdate = function (e, t) {
        return gt(e, this.props) || gt(t, this.state);
      }),
      t
    );
  })(Xe);
  function gt(e, t) {
    for (var n in e) if (e[n] !== t[n]) return !0;
    for (var n in t) if (!(n in e)) return !0;
    return !1;
  }
  Ue.vnode = function (e) {
    var t = e.props,
      n = {};
    if (F(e.type)) {
      for (var a in t) {
        var i = t[a];
        /^onAni/.test(a) ? (a = a.toLowerCase()) : /ondoubleclick/i.test(a) && (a = 'ondblclick'), (n[a] = i);
      }
      e.props = n;
    }
  };
  var yt = {},
    bt = 0;
  function xt(e, t, n, a, i) {
    Pe(e, t)
      ? e.__mbscFormInst || Ct(n, e, i, a, !0)
      : Re(e.querySelectorAll(t), function (e) {
          e.__mbscFormInst || Ct(n, e, i, a, !0);
        });
  }
  function Ct(e, t, n, i, s) {
    var r,
      o,
      l = [],
      c = [],
      h = {},
      u = i || {},
      d = u.renderToParent ? t.parentNode : t,
      _ = d.parentNode,
      p = u.useOwnChildren ? t : d,
      m = t.getAttribute('class'),
      f = t.value,
      v = a({ className: d.getAttribute('class') }, t.dataset, n, {
        ref: function (e) {
          o = e;
        },
      });
    u.readProps &&
      u.readProps.forEach(function (e) {
        var n = t[e];
        n !== N && (v[e] = n);
      }),
      u.readAttrs &&
        u.readAttrs.forEach(function (e) {
          var n = t.getAttribute(e);
          null !== n && (v[e] = n);
        });
    var g = u.slots;
    if (g)
      for (var y = 0, b = Object.keys(g); y < b.length; y++) {
        var x = b[y],
          C = g[x],
          w = d.querySelector('[mbsc-' + C + ']');
        w && ((h[x] = w), w.parentNode.removeChild(w), (v[x] = je('span', { className: 'mbsc-slot-' + C })));
      }
    if (
      (u.hasChildren &&
        (Re(p.childNodes, function (e) {
          e !== t &&
            8 !== e.nodeType &&
            (3 !== e.nodeType || (3 === e.nodeType && /\S/.test(e.nodeValue))) &&
            l.push(e),
            c.push(e);
        }),
        Re(l, function (e) {
          p.removeChild(e);
        }),
        l.length && (v.hasChildren = !0)),
      t.id || (t.id = 'mbsc-control-' + bt++),
      u.before && u.before(t, v, l),
      pt(je(e, v), _, d),
      m &&
        u.renderToParent &&
        (r = t.classList).add.apply(
          r,
          m
            .replace(/^\s+|\s+$/g, '')
            .replace(/\s+|^\s|\s$/g, ' ')
            .split(' '),
        ),
      u.hasChildren)
    ) {
      var T = '.' + u.parentClass,
        k = Pe(d, T) ? d : d.querySelector(T);
      k &&
        Re(l, function (e) {
          k.appendChild(e);
        });
    }
    if ((u.hasValue && (t.value = f), g))
      for (
        var S = function (e) {
            var t = g[e],
              n = h[e];
            Re(d.querySelectorAll('.mbsc-slot-' + t), function (e, t) {
              var a = t > 0 ? n.cloneNode(!0) : n;
              e.appendChild(a);
            });
          },
          D = 0,
          I = Object.keys(h);
        D < I.length;
        D++
      ) {
        S((x = I[D]));
      }
    return (
      (o.destroy = function () {
        var e = d.parentNode,
          n = ie.createComment('');
        e.insertBefore(n, d),
          pt(null, d),
          delete t.__mbscInst,
          delete t.__mbscFormInst,
          (d.innerHTML = ''),
          d.setAttribute('class', v.className),
          e.replaceChild(d, n),
          u.hasChildren &&
            Re(c, function (e) {
              p.appendChild(e);
            }),
          u.renderToParent && t.setAttribute('class', m || '');
      }),
      s ? (t.__mbscInst || (t.__mbscInst = o), (t.__mbscFormInst = o)) : (t.__mbscInst = o),
      o
    );
  }
  function wt(e) {
    yt[e._name] = e;
  }
  function Tt(e, t) {
    if (e)
      for (var n = 0, a = Object.keys(yt); n < a.length; n++) {
        var i = a[n],
          s = yt[i];
        xt(e, s._selector, s, s._renderOpt, t);
      }
  }
  function kt(e, t) {
    return function (n, a) {
      var i = {};
      if (F(n)) {
        var s,
          r = ie.querySelectorAll(n);
        return (
          Re(r, function (n) {
            var r = Ct(e, n, a, t);
            (i[n.id] = r), s || (s = r);
          }),
          1 === r.length ? s : i
        );
      }
      return Ct(e, n, a, t);
    };
  }
  function St(e) {
    return e < -1e-7 ? Math.ceil(e - 1e-7) : Math.floor(e + 1e-7);
  }
  function Dt(e, t, n) {
    var a,
      i,
      s = [0, 0, 0];
    a =
      e > 1582 || (1582 === e && t > 10) || (1582 === e && 10 === t && n > 14)
        ? St((1461 * (e + 4800 + St((t - 14) / 12))) / 4) +
          St((367 * (t - 2 - 12 * St((t - 14) / 12))) / 12) -
          St((3 * St((e + 4900 + St((t - 14) / 12)) / 100)) / 4) +
          n -
          32075
        : 367 * e - St((7 * (e + 5001 + St((t - 9) / 7))) / 4) + St((275 * t) / 9) + n + 1729777;
    var r = St(((i = a - 1948440 + 10632) - 1) / 10631),
      o = St((10985 - (i = i - 10631 * r + 354)) / 5316) * St((50 * i) / 17719) + St(i / 5670) * St((43 * i) / 15238);
    return (
      (i = i - St((30 - o) / 15) * St((17719 * o) / 50) - St(o / 16) * St((15238 * o) / 43) + 29),
      (t = St((24 * i) / 709)),
      (n = i - St((709 * t) / 24)),
      (e = 30 * r + o - 30),
      (s[2] = n),
      (s[1] = t),
      (s[0] = e),
      s
    );
  }
  h &&
    (ie.addEventListener('DOMContentLoaded', function () {
      Tt(ie);
    }),
    ie.addEventListener('mbsc-enhance', function (e) {
      Tt(e.target);
    }));
  var It = {
      getYear: function (e) {
        return Dt(e.getFullYear(), e.getMonth() + 1, e.getDate())[0];
      },
      getMonth: function (e) {
        return --Dt(e.getFullYear(), e.getMonth() + 1, e.getDate())[1];
      },
      getDay: function (e) {
        return Dt(e.getFullYear(), e.getMonth() + 1, e.getDate())[2];
      },
      getDate: function (e, t, n, a, i, s, r) {
        t < 0 && ((e += Math.floor(t / 12)), (t = t % 12 ? 12 + (t % 12) : 0)),
          t > 11 && ((e += Math.floor(t / 12)), (t %= 12));
        var o = (function (e, t, n) {
          var a,
            i,
            s,
            r,
            o,
            l = new Array(3),
            c = St((11 * e + 3) / 30) + 354 * e + 30 * t - St((t - 1) / 2) + n + 1948440 - 385;
          return (
            c > 2299160
              ? ((s = St((4 * (a = c + 68569)) / 146097)),
                (a -= St((146097 * s + 3) / 4)),
                (r = St((4e3 * (a + 1)) / 1461001)),
                (a = a - St((1461 * r) / 4) + 31),
                (i = St((80 * a) / 2447)),
                (n = a - St((2447 * i) / 80)),
                (t = i + 2 - 12 * (a = St(i / 11))),
                (e = 100 * (s - 49) + r + a))
              : ((o = St(((i = c + 1402) - 1) / 1461)),
                (s = St(((a = i - 1461 * o) - 1) / 365) - St(a / 1461)),
                (i = St((80 * (r = a - 365 * s + 30)) / 2447)),
                (n = r - St((2447 * i) / 80)),
                (t = i + 2 - 12 * (r = St(i / 11))),
                (e = 4 * o + s + r - 4716)),
            (l[2] = n),
            (l[1] = t),
            (l[0] = e),
            l
          );
        })(e, +t + 1, n);
        return new Date(o[0], o[1] - 1, o[2], a || 0, i || 0, s || 0, r || 0);
      },
      getMaxDayOfMonth: function (e, t) {
        t < 0 && ((e += Math.floor(t / 12)), (t = t % 12 ? 12 + (t % 12) : 0)),
          t > 11 && ((e += Math.floor(t / 12)), (t %= 12));
        return [30, 29, 30, 29, 30, 29, 30, 29, 30, 29, 30, 29][t] + (11 === t && (11 * e + 14) % 30 < 11 ? 1 : 0);
      },
    },
    Mt = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
    Et = [31, 31, 31, 31, 31, 31, 30, 30, 30, 30, 30, 29];
  function Ot(e, t, n) {
    var a,
      i = e - 1600,
      s = t - 1,
      r = n - 1,
      o = 365 * i + $((i + 3) / 4) - $((i + 99) / 100) + $((i + 399) / 400);
    for (a = 0; a < s; ++a) o += Mt[a];
    s > 1 && ((i % 4 == 0 && i % 100 != 0) || i % 400 == 0) && ++o;
    var l = (o += r) - 79,
      c = 979 + 33 * $(l / 12053) + 4 * $((l %= 12053) / 1461);
    for ((l %= 1461) >= 366 && ((c += $((l - 1) / 365)), (l = (l - 1) % 365)), a = 0; a < 11 && l >= Et[a]; ++a)
      l -= Et[a];
    return [c, a + 1, l + 1];
  }
  var Vt = {
      getYear: function (e) {
        return Ot(e.getFullYear(), e.getMonth() + 1, e.getDate())[0];
      },
      getMonth: function (e) {
        return --Ot(e.getFullYear(), e.getMonth() + 1, e.getDate())[1];
      },
      getDay: function (e) {
        return Ot(e.getFullYear(), e.getMonth() + 1, e.getDate())[2];
      },
      getDate: function (e, t, n, a, i, s, r) {
        t < 0 && ((e += $(t / 12)), (t = t % 12 ? 12 + (t % 12) : 0)), t > 11 && ((e += $(t / 12)), (t %= 12));
        var o = (function (e, t, n) {
          var a,
            i = e - 979,
            s = t - 1,
            r = n - 1,
            o = 365 * i + 8 * $(i / 33) + $(((i % 33) + 3) / 4);
          for (a = 0; a < s; ++a) o += Et[a];
          var l = (o += r) + 79,
            c = 1600 + 400 * $(l / 146097),
            h = !0;
          for (
            (l %= 146097) >= 36525 && ((c += 100 * $(--l / 36524)), (l %= 36524) >= 365 ? l++ : (h = !1)),
              c += 4 * $(l / 1461),
              (l %= 1461) >= 366 && ((h = !1), (c += $(--l / 365)), (l %= 365)),
              a = 0;
            l >= Mt[a] + (1 === a && h ? 1 : 0);
            a++
          )
            l -= Mt[a] + (1 === a && h ? 1 : 0);
          return [c, a + 1, l + 1];
        })(e, +t + 1, n);
        return new Date(o[0], o[1] - 1, o[2], a || 0, i || 0, s || 0, r || 0);
      },
      getMaxDayOfMonth: function (e, t) {
        var n,
          a,
          i,
          s = 31;
        for (
          t < 0 && ((e += $(t / 12)), (t = t % 12 ? 12 + (t % 12) : 0)), t > 11 && ((e += $(t / 12)), (t %= 12));
          (a = t + 1),
            (i = s),
            ((n = e) < 0 ||
              n > 32767 ||
              a < 1 ||
              a > 12 ||
              i < 1 ||
              i > Et[a - 1] + (12 === a && ((n - 979) % 33) % 4 == 0 ? 1 : 0)) &&
              s > 29;

        )
          s--;
        return s;
      },
    },
    Nt = {},
    Pt = { en: Nt },
    Lt = new Date(1970, 0, 1);
  function Ht(e) {
    return !!e._mbsc;
  }
  var Rt = {
      amText: 'am',
      dateFormat: 'MM/DD/YYYY',
      dateFormatLong: 'D DDD MMM YYYY',
      dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      daySuffix: '',
      firstDay: 0,
      fromText: 'Start',
      getDate: Zt,
      monthNames: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      monthSuffix: '',
      pmText: 'pm',
      separator: ' ',
      shortYearCutoff: '+10',
      timeFormat: 'h:mm A',
      toText: 'End',
      todayText: 'Today',
      weekText: 'Week {count}',
      yearSuffix: '',
      getMonth: function (e) {
        return e.getMonth();
      },
      getDay: function (e) {
        return e.getDate();
      },
      getYear: function (e) {
        return e.getFullYear();
      },
      getMaxDayOfMonth: function (e, t) {
        return 32 - new Date(e, t, 32, 12).getDate();
      },
      getWeekNumber: function (e) {
        var t = new Date(+e);
        t.setHours(0, 0, 0), t.setDate(t.getDate() + 4 - (t.getDay() || 7));
        var n = new Date(t.getFullYear(), 0, 1);
        return Math.ceil(((t - n) / 864e5 + 1) / 7);
      },
    },
    zt =
      /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[T\s](\d{2}):?(\d{2})(?::?(\d{2})(?:\.(\d{3}))?)?((Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/,
    Yt = /^((\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
  function At(e, t, n) {
    var a,
      i,
      s = { y: 1, m: 2, d: 3, h: 4, i: 5, s: 6, u: 7, tz: 8 };
    if (n)
      for (var r = 0, o = Object.keys(s); r < o.length; r++) (i = e[s[(a = o[r])] - t]) && (n[a] = 'tz' === a ? i : 1);
  }
  function Ft(e, t) {
    var n = tn(e, t);
    return n.setHours(0, 0, 0, 0), n;
  }
  function Wt(e, t) {
    var n = tn(e, t);
    return n.setHours(23, 59, 59, 999), n;
  }
  function Ut(e, t, n, a, i) {
    return ((!t && !i) || e.exclusiveEndDates) && n && a && n < a ? tn(t ? N : e, +a - 1) : a;
  }
  function jt(e) {
    return e.getFullYear() + '-' + G(e.getMonth() + 1) + '-' + G(e.getDate());
  }
  function Bt(e, t) {
    return Ht(e) && !t
      ? e.createDate(e.getFullYear(), e.getMonth(), e.getDate())
      : Zt(e.getFullYear(), e.getMonth(), e.getDate());
  }
  function qt(e) {
    return Date.UTC(e.getFullYear(), e.getMonth(), e.getDate());
  }
  function Xt(e, t) {
    return J((qt(t) - qt(e)) / 864e5);
  }
  function Kt(e, t, n) {
    var a = e.getFullYear(),
      i = e.getMonth(),
      s = e.getDay(),
      r = n === N ? t.firstDay : n;
    return new Date(a, i, r - (r - s > 0 ? 7 : 0) - s + e.getDate());
  }
  function Gt(e, t) {
    return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
  }
  function Jt(e, t, n) {
    return n.getYear(e) === n.getYear(t) && n.getMonth(e) === n.getMonth(t);
  }
  function Zt(e, t, n, a, i, s, r) {
    var o = new Date(e, t, n, a || 0, i || 0, s || 0, r || 0);
    return 23 === o.getHours() && 0 === (a || 0) && o.setHours(o.getHours() + 2), o;
  }
  function $t(e) {
    return e.getTime;
  }
  function Qt(e, t) {
    return tn(
      e,
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds(),
    );
  }
  function en(e) {
    return e
      ? new Date(
          e.getFullYear(),
          e.getMonth(),
          e.getDate(),
          e.getHours(),
          e.getMinutes(),
          e.getSeconds(),
          e.getMilliseconds(),
        )
      : e;
  }
  function tn(e, t, n, a, i, s, r, o) {
    return null === t
      ? null
      : t && (A(t) || F(t)) && U(n)
      ? nn(t, e)
      : e && e.timezonePlugin
      ? e.timezonePlugin.createDate(e, t, n, a, i, s, r, o)
      : j(t)
      ? new Date(t)
      : U(t)
      ? new Date()
      : new Date(t, n || 0, a || 1, i || 0, s || 0, r || 0, o || 0);
  }
  function nn(e, t, n, a, i) {
    var s;
    if ((F(e) && (e = e.trim()), !e)) return null;
    var r = t && t.timezonePlugin;
    if (r && !i) {
      var o = Ht(e) ? e : r.parse(e, t);
      return o.setTimezone(t.displayTimezone), o;
    }
    return $t(e)
      ? e
      : e._isAMomentObject
      ? e.toDate()
      : A(e)
      ? new Date(e)
      : (s = Yt.exec(e))
      ? (At(s, 2, a), new Date(1970, 0, 1, s[2] ? +s[2] : 0, s[3] ? +s[3] : 0, s[4] ? +s[4] : 0, s[5] ? +s[5] : 0))
      : (s = zt.exec(e))
      ? (At(s, 0, a),
        new Date(
          s[1] ? +s[1] : 1970,
          s[2] ? s[2] - 1 : 0,
          s[3] ? +s[3] : 1,
          s[4] ? +s[4] : 0,
          s[5] ? +s[5] : 0,
          s[6] ? +s[6] : 0,
          s[7] ? +s[7] : 0,
        ))
      : on(n, e, t);
  }
  function an(e, t, n, a, i) {
    var s = (h && window.moment) || t.moment,
      r = t.timezonePlugin && (t.dataTimezone || t.displayTimezone),
      o = r ? 'iso8601' : t.returnFormat;
    if (r && i)
      return (function (e, t) {
        var n = t.dataTimezone || t.displayTimezone,
          a = t.timezonePlugin;
        if (n && a && Ht(e)) {
          var i = e.clone();
          return i.setTimezone(n), i.toISOString();
        }
        return e;
      })(e, t);
    if (e) {
      if ('moment' === o && s) return s(e);
      if ('locale' === o) return rn(n, e, t);
      if ('iso8601' === o)
        return (function (e, t) {
          var n = '',
            a = '';
          return (
            e &&
              (t.h &&
                ((a += G(e.getHours()) + ':' + G(e.getMinutes())),
                t.s && (a += ':' + G(e.getSeconds())),
                t.u && (a += '.' + G(e.getMilliseconds(), 3)),
                t.tz && (a += t.tz)),
              t.y
                ? ((n += e.getFullYear()),
                  t.m && ((n += '-' + G(e.getMonth() + 1)), t.d && (n += '-' + G(e.getDate())), t.h && (n += 'T' + a)))
                : t.h && (n = a)),
            n
          );
        })(e, a);
    }
    return e;
  }
  function sn(e, t, n) {
    return rn(e, t, a({}, Rt, y.locale, n));
  }
  function rn(e, t, n) {
    var a,
      i,
      s = '',
      r = !1,
      o = function (t) {
        for (var n = 0, i = a; i + 1 < e.length && e.charAt(i + 1) === t; ) n++, i++;
        return n;
      },
      l = function (e) {
        var t = o(e);
        return (a += t), t;
      },
      c = function (e, t, n) {
        var a = '' + t;
        if (l(e)) for (; a.length < n; ) a = '0' + a;
        return a;
      },
      h = function (e, t, n, a) {
        return 3 === l(e) ? a[t] : n[t];
      };
    for (a = 0; a < e.length; a++)
      if (r) "'" !== e.charAt(a) || l("'") ? (s += e.charAt(a)) : (r = !1);
      else
        switch (e.charAt(a)) {
          case 'D':
            s += o('D') > 1 ? h('D', t.getDay(), n.dayNamesShort, n.dayNames) : c('D', n.getDay(t), 2);
            break;
          case 'M':
            s += o('M') > 1 ? h('M', n.getMonth(t), n.monthNamesShort, n.monthNames) : c('M', n.getMonth(t) + 1, 2);
            break;
          case 'Y':
            (i = n.getYear(t)), (s += 3 === l('Y') ? i : (i % 100 < 10 ? '0' : '') + (i % 100));
            break;
          case 'h':
            var u = t.getHours();
            s += c('h', u > 12 ? u - 12 : 0 === u ? 12 : u, 2);
            break;
          case 'H':
            s += c('H', t.getHours(), 2);
            break;
          case 'm':
            s += c('m', t.getMinutes(), 2);
            break;
          case 's':
            s += c('s', t.getSeconds(), 2);
            break;
          case 'a':
            s += t.getHours() > 11 ? n.pmText : n.amText;
            break;
          case 'A':
            s += t.getHours() > 11 ? n.pmText.toUpperCase() : n.amText.toUpperCase();
            break;
          case "'":
            l("'") ? (s += "'") : (r = !0);
            break;
          default:
            s += e.charAt(a);
        }
    return s;
  }
  function on(e, t, n) {
    var i = a({}, Rt, n),
      s = nn(i.defaultValue || new Date());
    if (!t) return s;
    e || (e = i.dateFormat + i.separator + i.timeFormat);
    var r,
      o = i.shortYearCutoff,
      l = i.getYear(s),
      c = i.getMonth(s) + 1,
      h = i.getDay(s),
      u = s.getHours(),
      d = s.getMinutes(),
      _ = 0,
      p = -1,
      m = !1,
      f = 0,
      v = function (t) {
        for (var n = 0, a = r; a + 1 < e.length && e.charAt(a + 1) === t; ) n++, a++;
        return n;
      },
      g = function (e) {
        var t = v(e);
        return (r += t), t;
      },
      y = function (e) {
        var n = g(e),
          a = new RegExp('^\\d{1,' + (n >= 2 ? 4 : 2) + '}'),
          i = t.substr(f).match(a);
        return i ? ((f += i[0].length), parseInt(i[0], 10)) : 0;
      },
      b = function (e, n, a) {
        for (var i = 3 === g(e) ? a : n, s = 0; s < i.length; s++)
          if (t.substr(f, i[s].length).toLowerCase() === i[s].toLowerCase()) return (f += i[s].length), s + 1;
        return 0;
      },
      x = function () {
        f++;
      };
    for (r = 0; r < e.length; r++)
      if (m) "'" !== e.charAt(r) || g("'") ? x() : (m = !1);
      else
        switch (e.charAt(r)) {
          case 'Y':
            l = y('Y');
            break;
          case 'M':
            c = v('M') < 2 ? y('M') : b('M', i.monthNamesShort, i.monthNames);
            break;
          case 'D':
            v('D') < 2 ? (h = y('D')) : b('D', i.dayNamesShort, i.dayNames);
            break;
          case 'H':
            u = y('H');
            break;
          case 'h':
            u = y('h');
            break;
          case 'm':
            d = y('m');
            break;
          case 's':
            _ = y('s');
            break;
          case 'a':
            p = b('a', [i.amText, i.pmText], [i.amText, i.pmText]) - 1;
            break;
          case 'A':
            p = b('A', [i.amText, i.pmText], [i.amText, i.pmText]) - 1;
            break;
          case "'":
            g("'") ? x() : (m = !0);
            break;
          default:
            x();
        }
    if (l < 100) {
      var C = void 0;
      (C = l <= (F(o) ? (new Date().getFullYear() % 100) + parseInt(o, 10) : +o) ? 0 : -100),
        (l += new Date().getFullYear() - (new Date().getFullYear() % 100) + C);
    }
    u = -1 === p ? u : p && u < 12 ? u + 12 : p || 12 !== u ? u : 0;
    var w = i.getDate(l, c - 1, h, u, d, _);
    return i.getYear(w) !== l || i.getMonth(w) + 1 !== c || i.getDay(w) !== h ? s : w;
  }
  function ln(e, t, n) {
    if (e === t) return !0;
    if ((z(e) && !e.length && null === t) || (z(t) && !t.length && null === e)) return !0;
    if (null === e || null === t || e === N || t === N) return !1;
    if (F(e) && F(t)) return e === t;
    var a = n && n.dateFormat;
    if (z(e) || z(t)) {
      if (e.length !== t.length) return !1;
      for (var i = 0; i < e.length; i++) {
        var s = e[i],
          r = t[i];
        if (!(F(s) && F(r) ? s === r : +nn(s, n, a) == +nn(r, n, a))) return !1;
      }
      return !0;
    }
    return +nn(e, n, a) == +nn(t, n, a);
  }
  function cn(e, t) {
    var n = (function (e) {
      return Ht(e) ? e.clone() : new Date(e);
    })(e);
    return n.setDate(n.getDate() + t), n;
  }
  function hn(e, t, n) {
    return t && e < t ? new Date(t) : n && e > n ? new Date(n) : e;
  }
  h && 'undefined' == typeof Symbol && (window.Symbol = { toPrimitive: 'toPrimitive' }),
    (b.datetime = { formatDate: sn, parseDate: on });
  var un = 1,
    dn = 'month',
    _n = 'year',
    pn = 'multi-year',
    mn = 296,
    fn = a({}, Rt, {
      dateText: 'Date',
      eventText: 'event',
      eventsText: 'events',
      moreEventsText: '{count} more',
      nextPageText: 'Next page',
      prevPageText: 'Previous page',
      showEventTooltip: !0,
      showToday: !0,
      timeText: 'Time',
    });
  function vn(e, t) {
    var n = t.refDate ? nn(t.refDate) : Lt,
      a = t.showCalendar ? t.calendarType : t.eventRange,
      i = (t.showCalendar ? ('year' === a ? 1 : 'week' === a ? t.weeks : t.size) : t.eventRangeSize) || 1,
      s = t.getDate,
      r = 'week' === a ? Kt(n, t) : n,
      o = t.getYear(r),
      l = t.getMonth(r),
      c = t.getDay(r);
    switch (a) {
      case 'year':
        return s(o + e * i, 0, 1);
      case 'week':
        return s(o, l, c + 7 * i * e);
      case 'day':
        return s(o, l, c + i * e);
      default:
        return s(o, l + e * i, 1);
    }
  }
  function gn(e, t) {
    var n,
      a = t.refDate ? nn(t.refDate) : Lt,
      i = t.getYear,
      s = t.getMonth,
      r = t.showCalendar ? t.calendarType : t.eventRange,
      o = (t.showCalendar ? ('year' === r ? 1 : 'week' === r ? t.weeks : t.size) : t.eventRangeSize) || 1;
    switch (r) {
      case 'year':
        n = i(e) - i(a);
        break;
      case 'week':
        n = Xt(Kt(a, t), Kt(e, t)) / 7;
        break;
      case 'day':
        n = Xt(a, e);
        break;
      case 'month':
        n = s(e) - s(a) + 12 * (i(e) - i(a));
        break;
      default:
        return N;
    }
    return $(n / o);
  }
  function yn(e, t) {
    var n = t.refDate ? nn(t.refDate) : Lt;
    return $((t.getYear(e) - t.getYear(n)) / 12);
  }
  function bn(e, t) {
    var n = t.refDate ? nn(t.refDate) : Lt;
    return t.getYear(e) - t.getYear(n);
  }
  function xn(e, t) {
    var n = nn(e.start || e.date),
      a = nn(t.start || e.date),
      i = e.title || e.text,
      s = t.title || t.text,
      r = n ? +n * (e.allDay ? 1 : 10) : 0,
      o = a ? +a * (t.allDay ? 1 : 10) : 0;
    return r === o ? (i > s ? 1 : -1) : r - o;
  }
  function Cn(e, t) {
    return 'auto' === e ? Math.max(1, Math.min(3, Math.floor(t ? t / mn : 1))) : e ? +e : 1;
  }
  function wn(e, t) {
    return e && e.slice(0).sort(t || xn);
  }
  var Tn,
    kn = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t._newProps = {}),
          (t._setEl = function (e) {
            t._el = e ? e._el || e : null;
          }),
          t
        );
      }
      return (
        n(t, e),
        Object.defineProperty(t.prototype, 'value', {
          get: function () {
            return this.__value;
          },
          set: function (e) {
            this.__value = e;
          },
          enumerable: !0,
          configurable: !0,
        }),
        (t.prototype.componentDidMount = function () {
          this.__init(), this._init(), this._mounted(), this._updated(), this._enhance();
        }),
        (t.prototype.componentDidUpdate = function () {
          this._updated(), this._enhance();
        }),
        (t.prototype.componentWillUnmount = function () {
          this._destroy(), this.__destroy();
        }),
        (t.prototype.render = function () {
          return this._willUpdate(), this._template(this.s, this.state);
        }),
        (t.prototype.getInst = function () {
          return this;
        }),
        (t.prototype.setOptions = function (e) {
          for (var t in e) this.props[t] = e[t];
          this.forceUpdate();
        }),
        (t.prototype._safeHtml = function (e) {
          return { __html: e };
        }),
        (t.prototype._init = function () {}),
        (t.prototype.__init = function () {}),
        (t.prototype._emit = function (e, t) {}),
        (t.prototype._template = function (e, t) {}),
        (t.prototype._mounted = function () {}),
        (t.prototype._updated = function () {}),
        (t.prototype._destroy = function () {}),
        (t.prototype.__destroy = function () {}),
        (t.prototype._willUpdate = function () {}),
        (t.prototype._enhance = function () {
          var e = this._shouldEnhance;
          e && (Tt(!0 === e ? this._el : e), (this._shouldEnhance = !1));
        }),
        t
      );
    })(vt),
    Sn = 0,
    Dn = { large: 992, medium: 768, small: 576, xlarge: 1200, xsmall: 0 };
  u &&
    ((Tn = u.matches),
    u.addListener(function (e) {
      (Tn = e.matches), w.next();
    }));
  var In,
    Mn,
    En = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (t.s = {}), (t.state = {}), (t._mbsc = !0), (t._v = { version: '5.22.2' }), (t._uid = ++Sn), t;
      }
      return (
        n(t, e),
        Object.defineProperty(t.prototype, 'nativeElement', {
          get: function () {
            return this._el;
          },
          enumerable: !0,
          configurable: !0,
        }),
        (t.prototype.destroy = function () {}),
        (t.prototype._hook = function (e, t) {
          var n = this.s;
          if (((t.inst = this), (t.type = e), this._emit(e, t), n[e])) return n[e](t, this);
        }),
        (t.prototype.__init = function () {
          var e = this;
          if (this.constructor.defaults) {
            this._optChange = w.subscribe(function () {
              e.forceUpdate();
            });
            var t = this.props.modules;
            if (t)
              for (var n = 0, a = t; n < a.length; n++) {
                var i = a[n];
                i.init && i.init(this);
              }
          }
          this._hook('onInit', {});
        }),
        (t.prototype.__destroy = function () {
          this._optChange !== N && w.unsubscribe(this._optChange), this._hook('onDestroy', {});
        }),
        (t.prototype._render = function (e, t) {}),
        (t.prototype._willUpdate = function () {
          this._merge(), this._render(this.s, this.state);
        }),
        (t.prototype._resp = function (e) {
          var t,
            n = e.responsive,
            a = -1,
            i = this.state.width;
          if ((i === N && (i = 375), n && i))
            for (var s = 0, r = Object.keys(n); s < r.length; s++) {
              var o = r[s],
                l = n[o],
                c = l.breakpoint || Dn[o];
              i >= c && c > a && ((t = l), (a = c));
            }
          return t;
        }),
        (t.prototype._merge = function () {
          var e,
            t,
            n = this.constructor,
            i = n.defaults,
            r = this._opt || {},
            o = {};
          if (((this._prevS = this.s || {}), i)) {
            for (var l in this.props) this.props[l] !== N && (o[l] = this.props[l]);
            var h = o.locale || r.locale || y.locale || {},
              u = o.calendarSystem || h.calendarSystem || r.calendarSystem || y.calendarSystem,
              d = o.theme || r.theme || y.theme,
              _ = o.themeVariant || r.themeVariant || y.themeVariant;
            ('auto' !== d && d) || (d = C.theme || ''),
              ('dark' !== _ && (!Tn || ('auto' !== _ && _))) || !x[d + '-dark'] || (d += '-dark'),
              (o.theme = d);
            var p = (t = x[d]) && t[n._name];
            e = a({}, i, p, h, y, r, u, o);
            var m = this._resp(e);
            (this._respProps = m), m && (e = a({}, e, m));
          } else (e = a({}, this.props)), (t = x[e.theme]);
          var f = t && t.baseTheme;
          (e.baseTheme = f),
            (this.s = e),
            (this._className = e.cssClass || e.class || e.className || ''),
            (this._rtl = ' mbsc-' + (e.rtl ? 'rtl' : 'ltr')),
            (this._theme = ' mbsc-' + e.theme + (f ? ' mbsc-' + f : '')),
            (this._touchUi = 'auto' === e.touchUi || e.touchUi === N ? c : e.touchUi),
            (this._hb = 'ios' !== s || ('ios' !== e.theme && 'ios' !== f) ? '' : ' mbsc-hb');
        }),
        (t.defaults = N),
        (t._name = ''),
        t
      );
    })(kn),
    On = 'animationstart',
    Vn = 'blur',
    Nn = 'change',
    Pn = 'click',
    Ln = 'contextmenu',
    Hn = 'dblclick',
    Rn = 'focus',
    zn = 'focusin',
    Yn = 'input',
    An = 'keydown',
    Fn = 'mousedown',
    Wn = 'mousemove',
    Un = 'mouseup',
    jn = 'mouseenter',
    Bn = 'mouseleave',
    qn = 'mousewheel',
    Xn = 'resize',
    Kn = 'scroll',
    Gn = 'touchstart',
    Jn = 'touchmove',
    Zn = 'touchend',
    $n = 'touchcancel',
    Qn = 'wheel',
    ea = 13,
    ta = 32,
    na = 33,
    aa = 34,
    ia = 35,
    sa = 36,
    ra = 37,
    oa = 38,
    la = 39,
    ca = 40,
    ha = 0;
  function ua(e, t, n) {
    var a,
      i,
      s,
      r,
      o,
      l,
      c,
      h = 0;
    function u() {
      (i.style.width = '100000px'),
        (i.style.height = '100000px'),
        (a.scrollLeft = 1e5),
        (a.scrollTop = 1e5),
        (l.scrollLeft = 1e5),
        (l.scrollTop = 1e5);
    }
    function d() {
      var e = +new Date();
      (r = 0), c || (e - h > 200 && !a.scrollTop && !a.scrollLeft && ((h = e), u()), r || (r = _e(d)));
    }
    function _() {
      o || (o = _e(p));
    }
    function p() {
      (o = 0), u(), t();
    }
    return (
      se && se.ResizeObserver
        ? (In ||
            (In = new se.ResizeObserver(function (e) {
              o ||
                (o = _e(function () {
                  for (var t = 0, n = e; t < n.length; t++) {
                    var a = n[t];
                    a.target.__mbscResize && a.target.__mbscResize();
                  }
                  o = 0;
                }));
            })),
          ha++,
          (e.__mbscResize = function () {
            n ? n.run(t) : t();
          }),
          In.observe(e))
        : (s = ie && ie.createElement('div')),
      s &&
        ((s.innerHTML =
          '<div class="mbsc-resize"><div class="mbsc-resize-i mbsc-resize-x"></div></div><div class="mbsc-resize"><div class="mbsc-resize-i mbsc-resize-y"></div></div>'),
        (s.dir = 'ltr'),
        (l = s.childNodes[1]),
        (a = s.childNodes[0]),
        (i = a.childNodes[0]),
        e.appendChild(s),
        Ce(a, 'scroll', _),
        Ce(l, 'scroll', _),
        n
          ? n.runOutsideAngular(function () {
              _e(d);
            })
          : _e(d)),
      {
        detach: function () {
          In
            ? (ha--, delete e.__mbscResize, In.unobserve(e), ha || (In = N))
            : (s && (we(a, 'scroll', _), we(l, 'scroll', _), e.removeChild(s), pe(o), (s = N)), (c = !0));
        },
      }
    );
  }
  var da = 'input,select,textarea,button',
    _a = 'textarea,button,input[type="button"],input[type="submit"]',
    pa = da + ',[tabindex="0"]',
    ma = { enter: ea, esc: 27, space: ta },
    fa = h && /(iphone|ipod)/i.test(d) && v >= 7 && v < 15;
  function va(e, t) {
    var n = e.s,
      a = [],
      i = {
        cancel: { cssClass: 'mbsc-popup-button-close', name: 'cancel', text: n.cancelText },
        close: { cssClass: 'mbsc-popup-button-close', name: 'close', text: n.closeText },
        ok: { cssClass: 'mbsc-popup-button-primary', keyCode: ea, name: 'ok', text: n.okText },
        set: { cssClass: 'mbsc-popup-button-primary', keyCode: ea, name: 'set', text: n.setText },
      };
    return t && t.length
      ? (t.forEach(function (t) {
          var n = F(t) ? i[t] || { text: t } : t;
          (n.handler && !F(n.handler)) ||
            (F(n.handler) && (n.name = n.handler),
            (n.handler = function (t) {
              e._onButtonClick({ domEvent: t, button: n });
            })),
            a.push(n);
        }),
        a)
      : N;
  }
  function ga(e, t) {
    void 0 === t && (t = 0);
    var n = e._prevModal;
    return n && n !== e && t < 10 ? (n.isVisible() ? n : ga(n, t + 1)) : N;
  }
  var ya = (function (e) {
    function t() {
      var t = (null !== e && e.apply(this, arguments)) || this;
      return (
        (t._lastFocus = +new Date()),
        (t._setActive = function (e) {
          t._active = e;
        }),
        (t._setContent = function (e) {
          t._content = e;
        }),
        (t._setLimitator = function (e) {
          t._limitator = e;
        }),
        (t._setPopup = function (e) {
          t._popup = e;
        }),
        (t._setWrapper = function (e) {
          t._wrapper = e;
        }),
        (t._onOverlayClick = function () {
          t._isOpen && t.s.closeOnOverlayClick && !t._preventClose && t._close('overlay'), (t._preventClose = !1);
        }),
        (t._onDocClick = function (e) {
          t.s.showOverlay || e.target === t.s.focusElm || Mn !== t || t._onOverlayClick();
        }),
        (t._onMouseDown = function (e) {
          t.s.showOverlay || (t._target = e.target);
        }),
        (t._onMouseUp = function (e) {
          t._target &&
            t._popup &&
            t._popup.contains(t._target) &&
            !t._popup.contains(e.target) &&
            (t._preventClose = !0),
            (t._target = !1);
        }),
        (t._onPopupClick = function () {
          t.s.showOverlay || (t._preventClose = !0);
        }),
        (t._onAnimationEnd = function (e) {
          e.target === t._popup &&
            (t._isClosing &&
              (t._onClosed(), (t._isClosing = !1), t.state.isReady ? t.setState({ isReady: !1 }) : t.forceUpdate()),
            t._isOpening && (t._onOpened(), (t._isOpening = !1), t.forceUpdate()));
        }),
        (t._onButtonClick = function (e) {
          var n = e.domEvent,
            a = e.button;
          t._hook('onButtonClick', { domEvent: n, button: a }), /cancel|close|ok|set/.test(a.name) && t._close(a.name);
        }),
        (t._onFocus = function (e) {
          var n = +new Date();
          Mn === t &&
            e.target.nodeType &&
            t._ctx.contains(e.target) &&
            t._popup &&
            !t._popup.contains(e.target) &&
            n - t._lastFocus > 100 &&
            e.target !== t.s.focusElm &&
            ((t._lastFocus = n), t._active.focus());
        }),
        (t._onKeyDown = function (e) {
          var n = t.s,
            a = e.keyCode,
            i = n.focusElm && !n.focusOnOpen ? n.focusElm : N;
          if (
            (((a === ta && !Pe(e.target, da)) || (t._lock && (a === oa || a === ca))) && e.preventDefault(),
            n.focusTrap && 9 === a)
          ) {
            var s = t._popup.querySelectorAll(pa),
              r = [],
              o = -1,
              l = 0,
              c = -1,
              h = N;
            Re(s, function (e) {
              e.disabled ||
                (!e.offsetHeight && !e.offsetWidth) ||
                (r.push(e), o++, e === t._doc.activeElement && (c = o));
            }),
              e.shiftKey && ((l = o), (o = 0)),
              c === o ? (h = i || r[l]) : e.target === i && (h = r[l]),
              h && (h.focus(), e.preventDefault());
          }
        }),
        (t._onContentScroll = function (e) {
          !t._lock || (e.type === Jn && 'stylus' === e.touches[0].touchType) || e.preventDefault();
        }),
        (t._onScroll = function (e) {
          var n = t.s;
          n.closeOnScroll ? t._close('scroll') : (t._hasContext || 'anchored' === n.display) && t.position();
        }),
        (t._onWndKeyDown = function (e) {
          var n = t.s,
            a = e.keyCode;
          if (Mn === t && a !== N) {
            if (
              (t._hook('onKeyDown', { keyCode: a }),
              n.closeOnEsc && 27 === a && t._close('esc'),
              a === ea && Pe(e.target, _a) && !e.shiftKey)
            )
              return;
            if (t._buttons)
              for (var i = 0, s = t._buttons; i < s.length; i++)
                for (var r = s[i], o = 0, l = z(r.keyCode) ? r.keyCode : [r.keyCode]; o < l.length; o++) {
                  var c = l[o];
                  if (!r.disabled && c !== N && (c === a || ma[c] === a)) return void r.handler(e);
                }
          }
        }),
        (t._onResize = function () {
          var e = t._wrapper,
            n = t._hasContext;
          if (e) {
            (t._vpWidth = Math.min(e.clientWidth, n ? 1 / 0 : t._win.innerWidth)),
              (t._vpHeight = Math.min(e.clientHeight, n ? 1 / 0 : t._win.innerHeight)),
              (t._maxWidth = t._limitator.offsetWidth),
              (t._maxHeight =
                t.s.maxHeight !== N || t._vpWidth < 768 || t._vpHeight < 650 ? t._limitator.offsetHeight : 600),
              (t._round = !1 === t.s.touchUi || (t._popup.offsetWidth < t._vpWidth && t._vpWidth > t._maxWidth));
            var a = {
              isLarge: t._round,
              maxPopupHeight: t._maxHeight,
              maxPopupWidth: t._maxWidth,
              target: e,
              windowHeight: t._vpHeight,
              windowWidth: t._vpWidth,
            };
            !1 === t._hook('onResize', a) || a.cancel || t.position();
          }
        }),
        t
      );
    }
    return (
      n(t, e),
      (t.prototype.open = function () {
        this._isOpen || this.setState({ isOpen: !0 });
      }),
      (t.prototype.close = function () {
        this._close();
      }),
      (t.prototype.isVisible = function () {
        return !!this._isOpen;
      }),
      (t.prototype.position = function () {
        if (this._isOpen) {
          var e = this.s,
            t = this.state,
            n = this._wrapper,
            a = this._popup,
            i = this._hasContext,
            s = e.anchor,
            r = e.anchorAlign,
            o = e.rtl,
            l = De(this._scrollCont),
            c = Se(this._scrollCont),
            h = this._vpWidth,
            u = this._vpHeight,
            d = this._maxWidth,
            _ = this._maxHeight,
            p = Math.min(a.offsetWidth, d),
            m = Math.min(a.offsetHeight, _),
            f = e.showArrow;
          (this._lock = e.scrollLock && this._content.scrollHeight <= this._content.clientHeight),
            i && ((n.style.top = l + 'px'), (n.style.left = c + 'px'));
          var v =
            !1 ===
            this._hook('onPosition', {
              isLarge: this._round,
              maxPopupHeight: _,
              maxPopupWidth: d,
              target: this._wrapper,
              windowHeight: u,
              windowWidth: h,
            });
          if ('anchored' !== e.display || v) this.setState({ height: u, isReady: !0, showArrow: f, width: h });
          else {
            var g = 0,
              y = 0,
              b = R(t.modalLeft || 0, 8, h - p - 8),
              x = t.modalTop || 8,
              C = 'bottom',
              w = {},
              T = f ? 16 : 4,
              k = (n.offsetWidth - h) / 2,
              S = (n.offsetHeight - u) / 2;
            if (i) {
              var D = this._ctx.getBoundingClientRect();
              (y = D.top), (g = D.left);
            }
            if (s && this._ctx.contains(s)) {
              var I = s.getBoundingClientRect(),
                M = I.top - y,
                E = I.left - g,
                O = s.offsetWidth,
                V = s.offsetHeight;
              if (
                ((b = R(
                  (b =
                    ('start' === r && !o) || ('end' === r && o)
                      ? E
                      : ('end' === r && !o) || ('start' === r && o)
                      ? E + O - p
                      : E - (p - O) / 2),
                  8,
                  h - p - 8,
                )),
                (x = M + V + T),
                (w = { left: R(E + O / 2 - b - k, 30, p - 30) + 'px' }),
                x + m + T > u)
              )
                if (M - m - T > 0) (C = 'top'), (x = M - m - T);
                else if (!e.disableLeftRight) {
                  var N = E - p - 8 > 0;
                  (N || E + O + p + 8 <= h) &&
                    ((x = R(M - (m - V) / 2, 8, u - m - 8)) + m + 8 > u && (x = Math.max(u - m - 8, 0)),
                    (w = { top: R(M + V / 2 - x - S, 30, m - 30) + 'px' }),
                    (C = N ? 'left' : 'right'),
                    (b = N ? E - p : E + O));
                }
            }
            ('top' !== C && 'bottom' !== C) || (x + m + T > u && ((x = Math.max(u - m - T, 0)), (f = !1))),
              this.setState({
                arrowPos: w,
                bubblePos: C,
                height: u,
                isReady: !0,
                modalLeft: b,
                modalTop: x,
                showArrow: f,
                width: h,
              });
          }
        }
      }),
      (t.prototype._render = function (e, t) {
        'bubble' === e.display && (e.display = 'anchored');
        var n = e.animation,
          a = e.display,
          i = this._prevS,
          s = 'anchored' === a,
          r = 'inline' !== a,
          o = e.fullScreen && r,
          l = !!r && (e.isOpen === N ? t.isOpen : e.isOpen);
        if (
          (l &&
            (e.windowWidth !== i.windowWidth ||
              e.display !== i.display ||
              e.showArrow !== i.showArrow ||
              (e.anchor !== i.anchor && 'anchored' === e.display)) &&
            (this._shouldPosition = !0),
          (this._limits = { maxHeight: X(e.maxHeight), maxWidth: X(e.maxWidth) }),
          (this._style = {
            height: o ? '100%' : X(e.height),
            left: s && t.modalLeft ? t.modalLeft + 'px' : '',
            maxHeight: X(this._maxHeight || e.maxHeight),
            maxWidth: X(this._maxWidth || e.maxWidth),
            top: s && t.modalTop ? t.modalTop + 'px' : '',
            width: o ? '100%' : X(e.width),
          }),
          (this._hasContext = 'body' !== e.context && e.context !== N),
          (this._needsLock = fa && !this._hasContext && 'anchored' !== a && e.scrollLock),
          (this._isModal = r),
          (this._flexButtons = 'center' === a || (!this._touchUi && !o && ('top' === a || 'bottom' === a))),
          n !== N && !0 !== n)
        )
          this._animation = F(n) ? n : '';
        else
          switch (a) {
            case 'bottom':
              this._animation = 'slide-up';
              break;
            case 'top':
              this._animation = 'slide-down';
              break;
            default:
              this._animation = 'pop';
          }
        e.buttons ? e.buttons !== i.buttons && (this._buttons = va(this, e.buttons)) : (this._buttons = N),
          e.headerText !== i.headerText && (this._headerText = e.headerText ? this._safeHtml(e.headerText) : N),
          l && !this._isOpen && this._onOpen(),
          !l && this._isOpen && this._onClose(),
          (this._isOpen = l),
          (this._isVisible = l || this._isClosing);
      }),
      (t.prototype._updated = function () {
        var e = this,
          t = this.s,
          n = this._wrapper;
        if (
          ie &&
          (t.context !== this._prevS.context || !this._ctx) &&
          ((a = F(t.context) ? ie.querySelector(t.context) : t.context) || (a = ie.body),
          (a.__mbscLock = a.__mbscLock || 0),
          (a.__mbscIOSLock = a.__mbscIOSLock || 0),
          (a.__mbscModals = a.__mbscModals || 0),
          (this._ctx = a),
          this._justOpened)
        )
          return void ee(this, function () {
            e.forceUpdate();
          });
        if (n) {
          if (this._justOpened) {
            var a = this._ctx,
              i = this._hasContext,
              s = (this._doc = Te(n)),
              r = (this._win = Ie(n)),
              o = s.activeElement;
            if (!this._hasWidth && t.responsive) {
              var l = Math.min(n.clientWidth, i ? 1 / 0 : r.innerWidth),
                c = Math.min(n.clientHeight, i ? 1 / 0 : r.innerHeight);
              if (((this._hasWidth = !0), l !== this.state.width || c !== this.state.height))
                return void ee(this, function () {
                  e.setState({ height: c, width: l });
                });
            }
            if (
              ((this._scrollCont = i ? a : r),
              (this._observer = ua(n, this._onResize, this._zone)),
              (this._prevFocus = t.focusElm || o),
              a.__mbscModals++,
              t.focusOnOpen &&
                o &&
                setTimeout(function () {
                  o.blur();
                }),
              this._needsLock)
            ) {
              if (!a.__mbscIOSLock) {
                var h = De(this._scrollCont),
                  u = Se(this._scrollCont);
                (a.style.left = -u + 'px'),
                  (a.style.top = -h + 'px'),
                  (a.__mbscScrollLeft = u),
                  (a.__mbscScrollTop = h),
                  a.classList.add('mbsc-popup-open-ios'),
                  a.parentNode.classList.add('mbsc-popup-open-ios');
              }
              a.__mbscIOSLock++;
            }
            i && a.classList.add('mbsc-popup-ctx'),
              t.focusTrap && Ce(r, zn, this._onFocus),
              t.focusElm && !t.focusOnOpen && Ce(t.focusElm, An, this._onKeyDown),
              Ce(this._scrollCont, Jn, this._onContentScroll, { passive: !1 }),
              Ce(this._scrollCont, Qn, this._onContentScroll, { passive: !1 }),
              Ce(this._scrollCont, qn, this._onContentScroll, { passive: !1 }),
              setTimeout(function () {
                Ce(s, Fn, e._onMouseDown), Ce(s, Un, e._onMouseUp), Ce(s, Pn, e._onDocClick);
              }),
              this._hook('onOpen', { target: this._wrapper });
          }
          this._shouldPosition &&
            ee(this, function () {
              e._onResize();
            }),
            (this._justOpened = !1),
            (this._justClosed = !1),
            (this._shouldPosition = !1);
        }
      }),
      (t.prototype._destroy = function () {
        this._isOpen && (this._onClosed(), this._unlisten(), Mn === this && (Mn = ga(this)));
      }),
      (t.prototype._onOpen = function () {
        var e = this;
        me && this._animation ? ((this._isOpening = !0), (this._isClosing = !1)) : this._onOpened(),
          (this._justOpened = !0),
          (this._preventClose = !1),
          Mn !== this &&
            setTimeout(function () {
              (e._prevModal = Mn), (Mn = e);
            });
      }),
      (t.prototype._onClose = function () {
        var e = this;
        me && this._animation
          ? ((this._isClosing = !0), (this._isOpening = !1))
          : setTimeout(function () {
              e._onClosed(), e.setState({ isReady: !1 });
            }),
          (this._hasWidth = !1),
          this._unlisten();
      }),
      (t.prototype._onOpened = function () {
        var e = this.s;
        if (e.focusOnOpen) {
          var t = e.activeElm,
            n = t ? (F(t) ? this._popup.querySelector(t) || this._active : t) : this._active;
          n && n.focus && n.focus();
        }
        Ce(this._win, An, this._onWndKeyDown), Ce(this._scrollCont, Kn, this._onScroll);
      }),
      (t.prototype._onClosed = function () {
        var e,
          t,
          n = this,
          a = this._ctx,
          i = this._prevFocus,
          s = this.s.focusOnClose && i && i.focus && i !== this._doc.activeElement;
        a.__mbscModals--,
          (this._justClosed = !0),
          this._needsLock &&
            (a.__mbscIOSLock--,
            a.__mbscIOSLock ||
              (a.classList.remove('mbsc-popup-open-ios'),
              a.parentNode.classList.remove('mbsc-popup-open-ios'),
              (a.style.left = ''),
              (a.style.top = ''),
              (e = this._scrollCont),
              (t = a.__mbscScrollLeft),
              e.scrollTo ? e.scrollTo(t, e.scrollY) : (e.scrollLeft = t),
              (function (e, t) {
                e.scrollTo ? e.scrollTo(e.scrollX, t) : (e.scrollTop = t);
              })(this._scrollCont, a.__mbscScrollTop))),
          this._hasContext && !a.__mbscModals && a.classList.remove('mbsc-popup-ctx'),
          this._hook('onClosed', { focus: s }),
          s && i.focus(),
          setTimeout(function () {
            Mn === n && (Mn = ga(n));
          });
      }),
      (t.prototype._unlisten = function () {
        we(this._win, An, this._onWndKeyDown),
          we(this._scrollCont, Kn, this._onScroll),
          we(this._scrollCont, Jn, this._onContentScroll, { passive: !1 }),
          we(this._scrollCont, Qn, this._onContentScroll, { passive: !1 }),
          we(this._scrollCont, qn, this._onContentScroll, { passive: !1 }),
          we(this._doc, Fn, this._onMouseDown),
          we(this._doc, Un, this._onMouseUp),
          we(this._doc, Pn, this._onDocClick),
          this.s.focusTrap && we(this._win, zn, this._onFocus),
          this.s.focusElm && we(this.s.focusElm, An, this._onKeyDown),
          this._observer && (this._observer.detach(), (this._observer = null));
      }),
      (t.prototype._close = function (e) {
        this._isOpen && (this.s.isOpen === N && this.setState({ isOpen: !1 }), this._hook('onClose', { source: e }));
      }),
      (t.defaults = {
        buttonVariant: 'flat',
        cancelText: 'Cancel',
        closeOnEsc: !0,
        closeOnOverlayClick: !0,
        closeText: 'Close',
        contentPadding: !0,
        display: 'center',
        focusOnClose: !0,
        focusOnOpen: !0,
        focusTrap: !0,
        maxWidth: 600,
        okText: 'Ok',
        scrollLock: !0,
        setText: 'Set',
        showArrow: !0,
        showOverlay: !0,
      }),
      t
    );
  })(En);
  function ba(e, t, n) {
    void 0 === n && (n = 0),
      n > 10
        ? (delete e.__mbscTimer, t(e))
        : (clearTimeout(e.__mbscTimer),
          (e.__mbscTimer = setTimeout(function () {
            e.getInputElement
              ? e.getInputElement().then(function (a) {
                  a ? (delete e.__mbscTimer, t(a)) : ba(e, t, n + 1);
                })
              : ba(e, t, n + 1);
          }, 10)));
  }
  function xa(e, t) {
    if (e)
      if ((a = e).getInputElement || (a.tagName && 'ion-input' === a.tagName.toLowerCase())) ba(e, t);
      else if (e.vInput) t(e.vInput.nativeElement);
      else if (e._el) t(e._el);
      else if (1 === e.nodeType) t(e);
      else if (F(e)) {
        var n = ie.querySelector(e);
        n && t(n);
      }
    var a;
  }
  function Ca(e, t, n, a) {
    if (!e || 1 !== e.nodeType) return K;
    var i,
      s = function () {
        (t.s.showOnClick || t.s.showOnFocus) && p && !t._allowTyping && (m.readOnly = !0);
      },
      r = function (n) {
        var i = t.s;
        s(),
          a && a(n),
          !i.showOnClick ||
            i.disabled ||
            (t._popup._isVisible && e === t._popup._prevFocus) ||
            setTimeout(function () {
              (t._focusElm = e), (t._anchor = i.anchor || e), t.open();
            });
      },
      o = function (e) {
        t.s.showOnClick && (t.s.showOnFocus && (t._preventShow = !0), t._allowTyping || e.preventDefault());
      },
      l = function (e) {
        t.s.showOnClick &&
          (t._isOpen
            ? e.keyCode === ea && t._allowTyping && e.stopPropagation()
            : (e.keyCode === ta && e.preventDefault(), (e.keyCode !== ea && e.keyCode !== ta) || r(e)));
      },
      c = function (e) {
        s(), t.s.showOnFocus && (t._preventShow ? (t._preventShow = !1) : r(e));
      },
      h = function () {
        p && (m.readOnly = i);
      },
      u = function (e) {
        n && n(e);
      },
      d = function () {
        _.document.activeElement === e && (s(), (t._preventShow = !0));
      },
      _ = Ie(e),
      p = Pe(e, 'input,select'),
      m = e;
    return (
      p && ((m.autocomplete = 'off'), (i = m.readOnly)),
      Ce(e, Pn, r),
      Ce(e, Fn, o),
      Ce(e, An, l),
      Ce(e, Rn, c),
      Ce(e, Vn, h),
      Ce(e, Nn, u),
      Ce(_, Rn, d),
      function () {
        p && (m.readOnly = i),
          we(e, Pn, r),
          we(e, Fn, o),
          we(e, An, l),
          we(e, Rn, c),
          we(e, Vn, h),
          we(e, Nn, u),
          we(_, Rn, d);
      }
    );
  }
  var wa = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t._nullSupport = !0),
          (t._onInputChange = function (e, n) {
            var a = e.detail || (n !== N ? n : e.target.value);
            if (a !== t._tempValueText && !t._preventChange) {
              t._readValue(a, !0), (t._valueTextChange = a !== t._tempValueText);
              var i = W(a) ? null : t._get(t._tempValueRep);
              (t.value = i), t._valueChange(i);
            }
            t._preventChange = !1;
          }),
          (t._onResize = function (e) {
            t._hook('onResize', e);
          }),
          (t._onWrapperResize = function () {
            t._wrapper && t._onResize({ windowWidth: t._wrapper.offsetWidth });
          }),
          (t._onPopupClose = function (e) {
            /cancel|esc|overlay|scroll/.test(e.source) &&
              t._hook('onCancel', { value: t.value, valueText: t._valueText }),
              t.close();
          }),
          (t._onPopupClosed = function (e) {
            e.focus && (t._preventShow = !0), t._hook('onClosed', e), t._onClosed();
          }),
          (t._onPopupKey = function (e) {
            13 === e.keyCode && t._onEnterKey(e);
          }),
          (t._onPopupOpen = function (e) {
            (e.value = t.value), (e.valueText = t._valueText), t._hook('onOpen', e);
          }),
          (t._onButtonClick = function (e) {
            var n = e.domEvent,
              a = e.button;
            'set' === a.name && t.set(), t._popup && t._popup._onButtonClick({ domEvent: n, button: a });
          }),
          (t._setInput = function (e) {
            t._el = e && e.nativeElement ? e.nativeElement : e;
          }),
          (t._setPopup = function (e) {
            t._popup = e;
          }),
          (t._setWrapper = function (e) {
            t._wrapper = e;
          }),
          t
        );
      }
      return (
        n(t, e),
        (t.prototype.open = function () {
          this._inst ? this._inst.open() : this.s.isOpen === N && this.setState({ isOpen: !0 });
        }),
        (t.prototype.close = function () {
          if ('inline' !== this.s.display)
            if (this._inst) this._inst.close();
            else {
              var e = { value: this.value, valueText: this._valueText };
              this.s.isOpen === N && this.setState({ isOpen: !1 }), this._hook('onClose', e);
            }
        }),
        (t.prototype.set = function () {
          (this._valueRep = this._copy(this._tempValueRep)),
            (this._valueText = this._tempValueText),
            (this._value = this.value = this._get(this._valueRep)),
            this._valueChange(this.value);
        }),
        (t.prototype.position = function () {
          this._inst ? this._inst.position() : this._popup && this._popup.position();
        }),
        (t.prototype.isVisible = function () {
          return this._inst ? this._inst.isVisible() : !!this._popup && this._popup.isVisible();
        }),
        (t.prototype.getVal = function () {
          return this._get(this._valueRep);
        }),
        (t.prototype.setVal = function (e) {
          (this.value = e), this.setState({ value: e });
        }),
        (t.prototype.getTempVal = function () {
          return this._get(this._tempValueRep);
        }),
        (t.prototype.setTempVal = function (e) {
          (this._tempValueSet = !0), (this._tempValueRep = this._parse(e)), this._setOrUpdate(!0);
        }),
        (t.prototype._shouldValidate = function (e, t) {
          return !1;
        }),
        (t.prototype._valueEquals = function (e, t) {
          return e === t;
        }),
        (t.prototype._change = function (e) {}),
        (t.prototype._render = function (e, t) {
          var n = this,
            a = this.props || {},
            i = this._respProps || {},
            s = this._prevS;
          this._touchUi ||
            ((e.display = i.display || a.display || y.display || 'anchored'),
            (e.showArrow = i.showArrow || a.showArrow || !1)),
            'bubble' === e.display && (e.display = 'anchored'),
            (this._scrollLock = e.scrollLock);
          var r = e.isOpen !== N ? e.isOpen : t.isOpen,
            o = e.modelValue !== N ? e.modelValue : e.value,
            l = o !== N ? o : t.value === N ? e.defaultValue : t.value;
          if (
            ((this._showInput = e.showInput !== N ? e.showInput : 'inline' !== e.display && e.element === N),
            (!this._buttons ||
              e.buttons !== s.buttons ||
              e.display !== s.display ||
              e.setText !== s.setText ||
              e.cancelText !== s.cancelText ||
              e.closeText !== s.closeText ||
              e.touchUi !== s.touchUi) &&
              ((this._buttons = va(
                this,
                e.buttons ||
                  ('inline' === e.display || ('anchored' === e.display && !this._touchUi) ? [] : ['cancel', 'set']),
              )),
              (this._live = !0),
              this._buttons && this._buttons.length))
          )
            for (var h = 0, u = this._buttons; h < u.length; h++) {
              var d = u[h];
              ('ok' !== d.name && 'set' !== d.name) || (this._live = !1);
            }
          if (
            !this._valueEquals(l, this._value) ||
            this._tempValueRep === N ||
            this._shouldValidate(e, s) ||
            e.defaultSelection !== s.defaultSelection ||
            e.invalid !== s.invalid ||
            e.valid !== s.valid
          ) {
            this._readValue(l);
            var _ = this._get(this._tempValueRep),
              p = !(this._valueEquals(l, _) || (this._nullSupport && W(l)));
            this._setHeader(),
              clearTimeout(this._handler),
              (this._handler = setTimeout(function () {
                (n.value = l),
                  p && n._valueChange(_),
                  n._valueEquals(n._tempValue, _) || n._inst !== N || n._hook('onTempChange', { value: _ });
              }));
          }
          if ((e.headerText !== s.headerText && this._setHeader(), r && !this._isOpen)) {
            if (!this._tempValueSet || this._live) {
              var m = this._get(this._tempValueRep),
                f = this._get(this._valueRep);
              (this._tempValueRep = this._copy(this._valueRep)),
                (this._tempValueText = this._format(this._tempValueRep)),
                (this._tempValue = m),
                this._setHeader(),
                this._valueEquals(m, f) ||
                  setTimeout(function () {
                    n._hook('onTempChange', { value: f });
                  });
            }
            this._onOpen();
          }
          (this._allowTyping = e.inputTyping && !c && !this._touchUi),
            (this._anchorAlign = e.anchorAlign || (this._touchUi ? 'center' : 'start')),
            (this._cssClass = 'mbsc-picker ' + (e.cssClass || '')),
            (this._isOpen = r),
            (this._maxWidth = e.maxWidth),
            (this._valueTextChange = this._valueTextChange || this._oldValueText !== this._valueText),
            (this._oldValueText = this._valueText),
            (this._value = l),
            (this._shouldInitInput = this._shouldInitInput || e.display !== s.display || e.element !== s.element);
        }),
        (t.prototype._updated = function () {
          var e = this,
            t = this.s,
            n = this._input;
          this._shouldInitInput &&
            !this._inst &&
            (this._unlisten(),
            this._wrapper &&
              'inline' === t.display &&
              (this._observer = ua(this._wrapper, this._onWrapperResize, this._zone)),
            xa(t.element || this._el, function (n) {
              (e._el = n),
                'inline' !== t.display && (e._resetEl = Ca(n, e, e._onInputChange)),
                Pe(n, 'input,select') && ((e._input = n), e._write(n));
            })),
            this._valueTextChange && n && this._write(n),
            (this._shouldInitInput = !1),
            (this._valueTextChange = !1),
            (this._anchor = t.anchor || this._focusElm || t.element || this._el);
        }),
        (t.prototype._writeValue = function (e, t, n) {
          var a = e.value;
          return (e.value = t), a !== t;
        }),
        (t.prototype._destroy = function () {
          this._unlisten(), (this._shouldInitInput = !0);
        }),
        (t.prototype._setHeader = function () {
          var e = this.s.headerText;
          this._headerText = e ? e.replace(/\{value\}/i, this._tempValueText || '&nbsp;') : N;
        }),
        (t.prototype._setOrUpdate = function (e) {
          var t = this._get(this._tempValueRep);
          (this._tempValue = t),
            (this._tempValueText = this._format(this._tempValueRep)),
            this._setHeader(),
            e || this._hook('onTempChange', { value: t }),
            this._live ? this.set() : this.forceUpdate();
        }),
        (t.prototype._copy = function (e) {
          return e;
        }),
        (t.prototype._format = function (e) {
          return e;
        }),
        (t.prototype._get = function (e) {
          return e;
        }),
        (t.prototype._parse = function (e, t) {
          return e;
        }),
        (t.prototype._validate = function () {}),
        (t.prototype._onClosed = function () {}),
        (t.prototype._onOpen = function () {}),
        (t.prototype._onParse = function () {}),
        (t.prototype._onEnterKey = function (e) {
          this.set(), this.close();
        }),
        (t.prototype._valueChange = function (e) {
          this.s.value === N && this.setState({ value: e }),
            this._change(e),
            this._hook('onChange', { value: e, valueText: this._tempValueText });
        }),
        (t.prototype._readValue = function (e, t) {
          (this._tempValueRep = this._parse(e, t)),
            this._onParse(),
            this._validate(),
            (this._tempValueText = this._format(this._tempValueRep)),
            (this._valueRep = this._copy(this._tempValueRep)),
            (this._valueText = W(e) ? '' : this._tempValueText);
        }),
        (t.prototype._unlisten = function () {
          this._resetEl && (this._resetEl(), (this._resetEl = N)),
            this._observer && (this._observer.detach(), (this._observer = N));
        }),
        (t.prototype._write = function (e) {
          var t = this,
            n = this._value;
          this._writeValue(e, this._valueText || '', n) &&
            setTimeout(function () {
              (t._preventChange = !0), He(e, Yn), He(e, Nn);
            });
          var a = e.__mbscFormInst;
          a && a.setOptions({ pickerMap: this.s.valueMap, pickerValue: n });
        }),
        (t.defaults = {
          cancelText: 'Cancel',
          closeText: 'Close',
          focusOnClose: 'android' !== s,
          okText: 'Ok',
          setText: 'Set',
          showOnFocus: c,
        }),
        t
      );
    })(En),
    Ta = { 0: 'SU', 1: 'MO', 2: 'TU', 3: 'WE', 4: 'TH', 5: 'FR', 6: 'SA' },
    ka = { SU: 0, MO: 1, TU: 2, WE: 3, TH: 4, FR: 5, SA: 6 },
    Sa = {
      byday: 'weekDays',
      bymonth: 'month',
      bymonthday: 'day',
      bysetpos: 'pos',
      dtstart: 'from',
      freq: 'repeat',
      wkst: 'weekStart',
    };
  function Da(e, t, n, a) {
    var i = nn(t.start, t.allDay ? N : n),
      s = nn(t.end, t.allDay ? N : n),
      r = s - i;
    for (a && ((t.start = i), (t.end = s)), i = Bt(i), s = n.exclusiveEndDates ? s : Bt(cn(s, 1)); i < s || !r; )
      Ia(e, i, t), (i = cn(i, 1)), (r = 1);
  }
  function Ia(e, t, n) {
    var a = jt(t);
    e[a] || ((e[a] = []), (e[a].date = Bt(t, !0))), e[a].push(n);
  }
  function Ma(e, t, n, a, i, s) {
    var r = {};
    if (i)
      for (
        var o = (function (e) {
            if (e) return z(e) ? e : F(e) ? e.split(',') : [e];
            return [];
          })(i),
          l = 0,
          c = o;
        l < c.length;
        l++
      ) {
        r[jt(nn(c[l]))] = !0;
      }
    if (s)
      for (var h = 0, u = Na(s, e, t, n, a); h < u.length; h++) {
        r[jt(u[h].d)] = !0;
      }
    return r;
  }
  function Ea(e) {
    return F(e) || e.getTime || e.toDate ? e : e.start || e.date;
  }
  function Oa(e, t, n, a) {
    for (var i = null, s = 0, r = e; s < r.length; s++) {
      var o = r[s];
      if (o.recurring) {
        var l = nn(o.start || o.date),
          c = Na(o.recurring, l, t, N, n, o.reccurringException, o.recurringExceptionRule, 'first');
        (!i || c < i) && (i = c);
      } else if (o.start && o.end) {
        var h = nn(o.start, n, a);
        nn(o.end, n, a) > t && (i = h <= t ? t : i && i < h ? i : h);
      } else {
        var u = nn(Ea(o), n, a);
        u > t && (!i || u < i) && (i = u);
      }
    }
    return i;
  }
  function Va(e, t, n, a) {
    var i = t;
    e.sort(function (e, t) {
      return nn(Ea(e), n, a) - nn(Ea(t), n, a);
    });
    for (var s = 0, r = e; s < r.length; s++) {
      var o = r[s];
      if (o.recurring) {
        var l = nn(o.start || o.date),
          c = Na(o.recurring, l, t, N, n, o.reccurringException, o.recurringExceptionRule, 'last');
        c > i && (i = c);
      } else if (o.start && o.end) {
        var h = nn(o.start, n, a),
          u = nn(o.end, n, a);
        u > i && Xt(i, h) <= 1 && (i = u);
      } else {
        var d = nn(Ea(o), n, a);
        d > i && Xt(i, d) <= 1 && (i = d);
      }
    }
    return i;
  }
  function Na(e, t, n, a, i, s, r, o) {
    F(e) &&
      (e = (function (e) {
        for (var t = {}, n = 0, a = e.split(';'); n < a.length; n++) {
          var i = a[n].split('='),
            s = i[0].trim().toLowerCase(),
            r = i[1].trim();
          t[Sa[s] || s] = r;
        }
        return t;
      })(e));
    for (
      var l,
        c,
        h = i.getYear,
        u = i.getMonth,
        d = i.getDay,
        _ = i.getDate,
        p = i.getMaxDayOfMonth,
        m = (e.repeat || '').toLowerCase(),
        f = e.interval || 1,
        v = e.count,
        g = e.from ? nn(e.from) : t || (1 !== f || v !== N ? new Date() : n),
        y = Bt(g),
        b = h(g),
        x = u(g),
        C = e.until ? nn(e.until) : 1 / 0,
        w = g < n,
        T = w ? n : Bt(g),
        k = 'first' === o,
        S = 'last' === o,
        D = k || S || !a || C < a ? C : a,
        I = v === N ? 1 / 0 : v,
        M = (e.weekDays || Ta[g.getDay()]).split(','),
        E = ka[(e.weekStart || 'MO').trim().toUpperCase()],
        O = z(e.day) ? e.day : ((e.day || d(g)) + '').split(','),
        V = z(e.month) ? e.month : ((e.month || u(g) + 1) + '').split(','),
        P = [],
        L = e.pos !== N,
        H = L ? +e.pos : 1,
        R = [],
        Y = a ? Ma(t, n, a, i, s, r) : {},
        A = !0,
        W = 0,
        U = 0,
        j = null,
        B = n,
        q = 0,
        X = M;
      q < X.length;
      q++
    ) {
      var K = X[q];
      R.push(ka[K.trim().toUpperCase()]);
    }
    var G = function () {
        if ((a || (Y = Ma(c, c, cn(c, 1), i, s, r)), !Y[jt(c)] && c >= T))
          if (k) (j = !j || c < j ? c : j), (A = !1);
          else if (S) {
            var e = Xt(B, c);
            (B = c > B && e <= 1 ? c : B), (A = e <= 1);
          } else P.push({ d: c, i: U });
        U++;
      },
      J = function (e, t) {
        for (var n = [], a = 0, i = R; a < i.length; a++)
          for (var s = Kt(e, { firstDay: i[a] }); s < t; s.setDate(s.getDate() + 7))
            s.getMonth() === e.getMonth() && n.push(+s);
        n.sort();
        var r = n[H < 0 ? n.length + H : H - 1];
        (c = r ? new Date(r) : t) < D ? r && G() : (A = !1);
      };
    switch (m) {
      case 'daily':
        for (U = v && w ? $(Xt(g, n) / f) : 0; A; ) (c = _(h(g), u(g), d(g) + U * f)) < D && U < I ? G() : (A = !1);
        break;
      case 'weekly':
        var Z = R,
          Q = Kt(g, { firstDay: E }),
          ee = Q.getDay();
        for (
          Z.sort(function (e, t) {
            return (e = (e -= ee) < 0 ? e + 7 : e) - (t = (t -= ee) < 0 ? t + 7 : t);
          });
          A;

        ) {
          for (var te = 0, ne = Z; te < ne.length; te++) {
            (l = cn(Q, (K = ne[te]) < E ? K - E + 7 : K - E)),
              (c = _(h(l), u(l), d(l) + 7 * W * f)) < D && U < I ? c >= y && G() : (A = !1);
          }
          W++;
        }
        break;
      case 'monthly':
        for (; A; ) {
          var ae = p(b, x + W * f);
          if (L) J(_(b, x + W * f, 1), _(b, x + W * f + 1, 1));
          else
            for (var ie = 0, se = O; ie < se.length; ie++) {
              var re = se[ie];
              (c = _(b, x + W * f, (de = +re) < 0 ? ae + de + 1 : de)) < D && U < I
                ? ae >= re && c >= y && G()
                : (A = !1);
            }
          W++;
        }
        break;
      case 'yearly':
        for (; A; ) {
          for (var oe = 0, le = V; oe < le.length; oe++) {
            var ce = +le[oe];
            ae = p(b + W * f, ce - 1);
            if (L) J(_(b + W * f, ce - 1, 1), _(b + W * f, ce, 1));
            else
              for (var he = 0, ue = O; he < ue.length; he++) {
                var de;
                re = ue[he];
                (c = _(b + W * f, ce - 1, (de = +re) < 0 ? ae + de + 1 : de)) < D && U < I
                  ? ae >= re && c >= y && G()
                  : (A = !1);
              }
          }
          W++;
        }
    }
    return k ? j : S ? B : P;
  }
  function Pa(e, t, n, i, s) {
    var r = {},
      o = i.timezonePlugin,
      l = i.dataTimezone || i.displayTimezone,
      c = o ? { displayTimezone: l, timezonePlugin: o } : i;
    if (!e) return N;
    for (var h = 0, u = e; h < u.length; h++) {
      var d = u[h],
        _ = Ea(d),
        p = nn(_, d.allDay ? N : i);
      if (d.recurring)
        for (
          var m = Yt.test(_) ? null : nn(_),
            f = cn(t, -1),
            v = cn(n, 1),
            g = Na(d.recurring, m, f, v, i, d.recurringException, d.recurringExceptionRule),
            y = tn(d.allDay ? N : c, p),
            b = d.end ? nn(d.end, d.allDay ? N : i) : y,
            x = +b - +y,
            C = 0,
            w = g;
          C < w.length;
          C++
        ) {
          var T = w[C],
            k = T.d,
            S = a({}, d);
          if (
            (d.start
              ? (S.start = tn(
                  d.allDay ? N : c,
                  k.getFullYear(),
                  k.getMonth(),
                  k.getDate(),
                  y.getHours(),
                  y.getMinutes(),
                  y.getSeconds(),
                ))
              : ((S.allDay = !0), (S.start = tn(N, k.getFullYear(), k.getMonth(), k.getDate()))),
            d.end)
          ) {
            if (d.allDay) {
              var D = cn(k, Xt(y, b));
              S.end = new Date(
                D.getFullYear(),
                D.getMonth(),
                D.getDate(),
                b.getHours(),
                b.getMinutes(),
                b.getSeconds(),
              );
            } else S.end = tn(c, +S.start + x);
            '00:00' === d.end && S.end.setHours(23, 59, 59, 999);
          }
          (S.nr = T.i),
            (S.occurrenceId = S.id + '_' + jt(S.start)),
            (S.original = d),
            S.start && S.end ? Da(r, S, i, s) : Ia(r, k, S);
        }
      else d.start && d.end ? Da(r, d, i, s) : p && Ia(r, p, d);
    }
    return r;
  }
  function La(e, t, n, a, i, s) {
    var r = jt(t);
    if ((i && +t < i) || (s && +t > s)) return !0;
    if (a && a[r]) return !1;
    var o = n && n[r];
    if (o)
      for (var l = 0, c = o; l < c.length; l++) {
        var h = c[l],
          u = h.start,
          d = h.end,
          _ = h.allDay;
        if (!u || !d || _) return h;
        var p = Ut(e, _, u, d),
          m = Ft(e, t),
          f = Wt(e, p);
        if (!Gt(u, d) && (+u == +m || +p == +f || (!Gt(t, u) && !Gt(t, d) && t > u && t < d))) return h;
      }
    return !1;
  }
  function Ha(e, t, n, a, i, s, r) {
    var o,
      l,
      c = !0,
      h = !0,
      u = 0,
      d = 0;
    +e < n && (e = tn(t, n)), +e > a && (e = tn(t, a));
    var _ = t.getYear(e),
      p = t.getMonth(e),
      m = t.getDate(_, p - 1, 1),
      f = t.getDate(_, p + 2, 1),
      v = +m > n ? +m : n,
      g = +f < a ? +f : a;
    if ((i || ((s = Pa(t.valid, m, f, t, !0)), (i = Pa(t.invalid, m, f, t, !0))), !La(t, e, i, s, n, a))) return e;
    for (o = e, l = e; c && +o < g && u < 100; ) (c = La(t, (o = cn(o, 1)), i, s, n, a)), u++;
    for (; h && +l > v && d < 100; ) (h = La(t, (l = cn(l, -1)), i, s, n, a)), d++;
    return c && h
      ? e
      : 1 !== r || c
      ? -1 !== r || h
        ? Jt(e, o, t)
          ? o
          : Jt(e, l, t)
          ? l
          : d >= u && !c
          ? o
          : l
        : l
      : o;
  }
  var Ra = {},
    za = ' - ',
    Ya = ['calendar'],
    Aa = [{ recurring: { repeat: 'daily' } }];
  function Fa(e) {
    return 'start' === e ? 'end' : 'start';
  }
  function Wa(e, t) {
    var n = Kt(new Date(e), t, t.firstSelectDay !== N ? t.firstSelectDay : t.firstDay),
      a = new Date(n.getFullYear(), n.getMonth(), n.getDate() + t.selectSize - 1);
    return { start: n, end: a };
  }
  var Ua = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t._iso = {}),
          (t._onActiveChange = function (e) {
            (t._active = e.date), t.forceUpdate();
          }),
          (t._onResize = function (e) {
            var n = e.windowWidth;
            (e.cancel = t.state.width !== n),
              t.setState({
                isLarge: e.isLarge,
                maxPopupWidth: e.maxPopupWidth,
                width: n,
                widthType: n > 600 ? 'md' : 'sm',
              });
          }),
          (t._onDayHoverIn = function (e) {
            var n = e.date,
              a = e.hidden;
            t.setState({ hoverDate: a ? N : +n });
          }),
          (t._onDayHoverOut = function (e) {
            var n = e.date;
            t.state.hoverDate === +n && t.setState({ hoverDate: N });
          }),
          (t._onCellClick = function (e) {
            (t._lastSelected = Qt(t.s, e.date)), (e.active = t._activeSelect), t._hook('onCellClick', e);
          }),
          (t._onCalendarChange = function (e) {
            t._tempValueSet = !1;
            var n = t.s,
              a = t._copy(t._tempValueRep),
              i = ae(e.value, function (e) {
                return Qt(n, e);
              }),
              s = 'preset-range' === n.select,
              r = 'range' === n.select,
              o = r && t._newSelection,
              l = (r || s) && n.exclusiveEndDates && !t._hasTime;
            if ((l && a.end && (a.end = +Ft(n, tn(n, a.end - 1))), t._hasTime && t._selectedTime && !r))
              if (t.s.selectMultiple) {
                var c = i[i.length - 1];
                c && c.setHours(t._selectedTime.getHours(), t._selectedTime.getMinutes());
              } else i.setHours(t._selectedTime.getHours(), t._selectedTime.getMinutes());
            if (r || s) {
              var h = t._getDate(a),
                u = h.filter(function (e) {
                  return null !== e;
                }),
                d = u.map(function (e) {
                  return +e;
                }),
                _ = u.map(function (e) {
                  return +Bt(e);
                }),
                p = i.filter(function (e) {
                  return _.indexOf(+e) < 0;
                })[0];
              if (s) {
                if (p) {
                  var m = Wa(+p, n),
                    f = m.start,
                    v = m.end;
                  (a.start = +f), (a.end = +v);
                }
              } else {
                var g = !t._hasTime,
                  y = t._renderControls,
                  b = t._activeSelect,
                  x = Fa(b);
                if (p) {
                  switch (
                    (t._hasTime &&
                      t._selectedTime &&
                      p.setHours(
                        t._selectedTime.getHours(),
                        t._selectedTime.getMinutes(),
                        t._selectedTime.getSeconds(),
                        t._selectedTime.getMilliseconds(),
                      ),
                    d.length)
                  ) {
                    case 0:
                      (a = {})[b] = +p;
                      break;
                    case 1:
                      if (y) {
                        a[b] = +p;
                        break;
                      }
                      d[0] > +p || 'start' === t._activeSelect
                        ? t._hasTime
                          ? (a[b] = +p)
                          : ((a = { start: +p }), (g = !1))
                        : (a.end = +p);
                      break;
                    case 2:
                      if (y) {
                        a[b] = +p;
                        break;
                      }
                      d[0] > +p || 'start' === t._activeSelect
                        ? t._hasTime
                          ? (a[b] = +p)
                          : ((a = { start: +p }), 'end' === t._activeSelect && (g = !1))
                        : 'end' === t._activeSelect && (a.end = +p);
                  }
                  y && a.start && a.end && a.start > a.end && ((a = { start: +p }), t._setActiveSelect('end'));
                } else {
                  var C = void 0;
                  (C = 1 === d.length ? tn(n, d[0]) : t._lastSelected),
                    t._hasTime && t._selectedTime
                      ? C.setHours(
                          t._selectedTime.getHours(),
                          t._selectedTime.getMinutes(),
                          t._selectedTime.getSeconds(),
                          t._selectedTime.getMilliseconds(),
                        )
                      : !n.exclusiveEndDates &&
                        !t._hasTime &&
                        'end' === t._activeSelect &&
                        h[0] &&
                        Gt(C, h[0]) &&
                        C.setHours(23, 59, 59, 999),
                    y || t._hasTime ? (a[b] = +C) : 'start' === t._activeSelect ? (a = { start: +C }) : (a.end = +C);
                }
                if (a.start && a.end) {
                  if (a.start > a.end) {
                    var w = tn(n, a.start),
                      T = tn(n, a.end);
                    Gt(w, T)
                      ? (T.setHours(w.getHours(), w.getMinutes(), w.getSeconds(), w.getMilliseconds()), (a.end = +T))
                      : (a.end = N);
                  }
                  if (n.minRange && a.end) {
                    var k = t._hasTime ? a.start + n.minRange : +cn(tn(n, a.start), n.minRange - 1);
                    a.end < k && (!t._hasTime || 'start' === b) && (a.end = N);
                  }
                  if (n.maxRange && a.end) {
                    k = t._hasTime ? a.start + n.maxRange : +cn(tn(n, a.start), n.maxRange) - 1;
                    a.end > k && (!t._hasTime || 'start' === b) && (a.end = N);
                  }
                  if (a.end && 'start' === b && !n.inRangeInvalid) {
                    var S = n.valid ? cn(Va(n.valid, tn(n, a.start), n), 1) : Oa(n.invalid || [], tn(n, a.start), n);
                    null !== S && +S < a.end && (a.end = N);
                  }
                }
                g &&
                  (t._newSelection || !t._renderControls || (t._newSelection === N && 'inline' === t.s.display)) &&
                  (t._setActiveSelect(x), (t._newSelection = !1));
              }
            } else if (((a = { date: {} }), t.s.selectMultiple))
              for (var D = 0, I = i; D < I.length; D++) {
                var M = I[D];
                a.date[+M] = M;
              }
            else {
              if (t._hasTime) {
                var E = t._selectedTime || new Date();
                i.setHours(E.getHours(), E.getMinutes(), E.getSeconds(), E.getMilliseconds());
              }
              a.date[+i] = i;
            }
            (t._tempValueRep = a),
              l && a.end && (a.end = +Ft(n, cn(tn(n, a.end), 1))),
              t._setOrUpdate(),
              !t._live || (t.s.selectMultiple && !r) || t._hasTime || (r && (!a.start || !a.end || o)) || t.close();
          }),
          (t._onDatetimeChange = function (e) {
            var n = t.s,
              a = 'range' === n.select,
              i = Qt(n, e.value),
              s = t._hasTime ? i : Bt(i),
              r = +s;
            t._tempValueSet = !1;
            var o = t._copy(t._tempValueRep),
              l = a && n.exclusiveEndDates && !t._hasTime;
            if ((l && o.end && (o.end = +Ft(n, tn(n, o.end - 1))), a))
              if ('start' === t._activeSelect) {
                if (
                  (t._hasTime &&
                    t._selectedTime &&
                    s.setHours(
                      t._selectedTime.getHours(),
                      t._selectedTime.getMinutes(),
                      t._selectedTime.getSeconds(),
                      t._selectedTime.getMilliseconds(),
                    ),
                  (o.start = r),
                  o.end)
                ) {
                  var c = n.minRange && !t._hasTime ? 24 * (n.minRange - 1) * 60 * 60 * 1e3 - 1 : n.minRange || 0;
                  o.end - o.start < c && (o.end = N);
                }
              } else
                t._hasTime
                  ? t._selectedTime &&
                    s.setHours(
                      t._selectedTime.getHours(),
                      t._selectedTime.getMinutes(),
                      t._selectedTime.getSeconds(),
                      t._selectedTime.getMilliseconds(),
                    )
                  : o.start !== +Bt(s) || n.exclusiveEndDates || s.setHours(23, 59, 59, 999),
                  (o.end = +s);
            else {
              if (t._hasTime && t._hasDate && n.controls.indexOf('datetime') < 0) {
                var h = t._selectedTime || new Date();
                s.setHours(h.getHours(), h.getMinutes(), h.getSeconds(), h.getMilliseconds());
              } else t._selectedTime = tn(n, s);
              (o = { date: {} }).date[+s] = s;
            }
            (t._tempValueRep = o), l && o.end && (o.end = +Ft(n, cn(tn(n, o.end), 1))), t._setOrUpdate();
          }),
          (t._onTimePartChange = function (e) {
            t._tempValueSet = !1;
            var n = t.s,
              a = 'range' === n.select,
              i = Qt(n, e.value);
            if (((t._selectedTime = i), a)) {
              var s = t._getDate(t._tempValueRep),
                r = 'start' === t._activeSelect ? 0 : 1;
              if (s[r])
                (o = tn(n, s[r])).setHours(i.getHours(), i.getMinutes(), i.getSeconds(), i.getMilliseconds()),
                  (s[r] = o),
                  'start' === t._activeSelect && +o > +s[1] && (s.length = 1),
                  (t._tempValueRep = t._parse(s));
              else t._selectedTime.setHours(i.getHours(), i.getMinutes(), i.getSeconds(), i.getMilliseconds());
            } else if (!n.selectMultiple) {
              var o;
              (o = t._getDate(t._tempValueRep))
                ? (o.setHours(i.getHours(), i.getMinutes(), i.getSeconds(), i.getMilliseconds()),
                  (t._tempValueRep = { date: {} }),
                  (t._tempValueRep.date[+o] = o))
                : (t._selectedTime.setHours(i.getHours(), i.getMinutes(), i.getSeconds(), i.getMilliseconds()),
                  t._live && t.forceUpdate());
            }
            t._setOrUpdate();
          }),
          (t._changeActiveTab = function (e) {
            t.setState({ activeTab: e.target.value });
          }),
          (t._changeActiveSelect = function (e) {
            var n = e.target.value;
            t._setActiveSelect(n), t.setActiveDate(n);
          }),
          (t._clearEnd = function () {
            (t._tempValueRep.end = N), t._hasTimegrid && (t._selectedTime = N), t._setOrUpdate();
          }),
          (t._clearStart = function () {
            (t._tempValueRep = {}), (t._newSelection = !0), t._hasTimegrid && (t._selectedTime = N), t._setOrUpdate();
          }),
          (t._proxy = function (e) {
            t._hook(e.type, e);
          }),
          (t._onInputClickRange = function (e) {
            var n = e.target === t._startInput || t._renderControls ? 'start' : 'end';
            t._setActiveSelect(n);
          }),
          (t._onInputChangeRange = function (e) {
            var n = t._startInput,
              a = t._endInput,
              i = (n ? n.value : '') + (a && a.value ? za + a.value : '');
            t._onInputChange(e, i);
          }),
          t
        );
      }
      return (
        n(t, e),
        (t.prototype.setActiveDate = function (e) {
          var t = Fa(e);
          this._activeSelect = e;
          var n = this._tempValueRep[e],
            a = this._tempValueRep[t];
          (this._tempValueRep.start && this._tempValueRep.end) || (!n && a)
            ? (this._newSelection = !1)
            : n && !a && (this._newSelection = !0),
            n && (this._active = n),
            !n && this._hasTimegrid && (this._selectedTime = N),
            this.forceUpdate();
        }),
        (t.prototype.getTempVal = function () {
          return e.prototype.getTempVal.call(this);
        }),
        (t.prototype.setTempVal = function (t) {
          e.prototype.setTempVal.call(this, t);
        }),
        (t.prototype.navigate = function (e) {
          (this._active = +nn(e)), this.forceUpdate();
        }),
        (t.prototype._shouldValidate = function (e, t) {
          return (
            e.controls !== t.controls ||
            e.dataTimezone !== t.dataTimezone ||
            e.displayTimezone !== t.displayTimezone ||
            e.dateFormat !== t.dateFormat ||
            e.timeFormat !== t.timeFormat ||
            e.locale !== t.locale ||
            e.min !== t.min ||
            e.max !== t.max
          );
        }),
        (t.prototype._valueEquals = function (e, t) {
          var n = (z(e) && 0 === e.length) || e === N || null === e,
            a = (z(t) && 0 === t.length) || t === N || null === t;
          return (n && n === a) || ln(e, t, this.s);
        }),
        (t.prototype.setVal = function (t) {
          if ('range' === this.s.select && t) {
            var n = t[0],
              a = t[1];
            (this._savedStartValue = +nn(n, this.s, this._valueFormat)),
              (this._savedEndValue = +nn(a, this.s, this._valueFormat));
          }
          e.prototype.setVal.call(this, t);
        }),
        (t.prototype._init = function () {
          this.props.modules &&
            this.props.modules.forEach(function (e) {
              Ra[e._name] = e;
            });
        }),
        (t.prototype._render = function (t, n) {
          var s = this;
          t.inRangeInvalid && (t.rangeEndInvalid = !1),
            'preset-range' === t.select && (t.controls = Ya),
            t.exclusiveEndDates === N && (t.exclusiveEndDates = !!t.displayTimezone);
          var r = this._hasTime,
            o = (this._hasDate = !!te(t.controls, function (e) {
              return /date|calendar/.test(e);
            })),
            l = (this._hasTime = !!te(t.controls, function (e) {
              return /time/.test(e);
            }));
          l || (t.timezonePlugin = t.dataTimezone = t.displayTimezone = N),
            !t.valid || (t.invalid && !l) || (t.invalid = Aa);
          var c = this._prevS;
          t.buttons;
          var h = t.calendarSize;
          t.children, t.className;
          var u = t.controls;
          t.cssClass, t.element, t.modelValue, t.onDestroy, t.onInit, t.onTempChange, t.responsive;
          var d = t.select,
            _ = t.selectMultiple,
            p = t.tabs,
            m = i(t, [
              'buttons',
              'calendarSize',
              'children',
              'className',
              'controls',
              'cssClass',
              'element',
              'modelValue',
              'onDestroy',
              'onInit',
              'onTempChange',
              'responsive',
              'select',
              'selectMultiple',
              'tabs',
            ]),
            f = n.widthType || 'sm',
            v = 'date' !== d;
          if (
            ((this._renderTabs = u.length > 1 && ('auto' === p ? 'sm' === f : p)), d !== c.select && this._tempValueRep)
          )
            if (v && this._tempValueRep.date) {
              var g = Object.keys(this._tempValueRep.date)
                  .map(function (e) {
                    return +e;
                  })
                  .sort(),
                y = g[0],
                b = g[1];
              (this._tempValueRep.start = y),
                (this._tempValueRep.end = b),
                (this._tempValueRep.date = N),
                (this._tempValueText = this._format(this._tempValueRep)),
                setTimeout(function () {
                  s.set();
                });
            } else if (!v && (this._tempValueRep.start || this._tempValueRep.end)) {
              this._tempValueRep.date || (this._tempValueRep.date = {});
              var x = this._tempValueRep.start || this._tempValueRep.end;
              this._tempValueRep.date[x] = new Date(x);
              var C = this._tempValueRep.end || this._tempValueRep.start;
              C !== x && t.selectMultiple && (this._tempValueRep.date[C] = new Date(C)),
                (this._tempValueRep.start = N),
                (this._tempValueRep.end = N),
                (this._tempValueText = this._format(this._tempValueRep)),
                setTimeout(function () {
                  s.set();
                });
            }
          t.min !== c.min && (this._min = W(t.min) ? N : nn(t.min, t, t.dateFormat)),
            t.max !== c.max && (this._max = W(t.max) ? N : nn(t.max, t, t.dateFormat)),
            t.minTime !== c.minTime && (this._minTime = W(t.minTime) ? N : nn(t.minTime, t, t.timeFormat)),
            t.maxTime !== c.maxTime && (this._maxTime = W(t.maxTime) ? N : nn(t.maxTime, t, t.timeFormat));
          var w = this._tempValueRep && this._tempValueRep.end,
            T = this._tempValueRep && this._tempValueRep.start,
            k = (o ? t.dateFormat : '') + (l ? (o ? t.separator : '') + t.timeFormat : ''),
            S = u !== c.controls;
          if (S) {
            (this._controls = []), (this._controlsClass = ''), (this._hasCalendar = !1), (this._hasTimegrid = !1);
            for (var D = 0, I = u; D < I.length; D++) {
              'timegrid' === ($ = I[D]) && (this._hasTimegrid = !0),
                'calendar' === $ && (this._hasCalendar = !0),
                this._controls.push({
                  Component: Ra['calendar' === $ ? 'Calendar' : 'timegrid' === $ ? 'Timegrid' : 'Datetime'],
                  name: $,
                  title: 'time' === $ || 'timegrid' === $ ? t.timeText : t.dateText,
                }),
                (this._controlsClass += ' mbsc-datepicker-control-' + $);
            }
            l || (this._selectedTime = N);
          }
          if (
            ((this._renderControls = v && 'preset-range' !== d && (t.showRangeLabels === N || t.showRangeLabels)),
            (this._nullSupport = 'inline' !== t.display || 'date' !== d || !0 === t.selectMultiple),
            (this._valueFormat = k),
            (this._activeTab = n.activeTab || u[0]),
            e.prototype._render.call(this, t, n),
            S && v && t.exclusiveEndDates && l !== r && (w || T))
          ) {
            var M = this._savedStartValue,
              E = this._savedEndValue;
            setTimeout(function () {
              if (l) (s._tempValueRep.start = M || T), (s._tempValueRep.end = E || w);
              else {
                (s._savedStartValue = T), (s._savedEndValue = w), (s._clearSaved = !1);
                var e = a({}, t, {
                  dataTimezone: s.props.dataTimezone,
                  displayTimezone: s.props.displayTimezone,
                  timezonePlugin: s.props.timezonePlugin,
                });
                if ((T && (s._tempValueRep.start = +en(Ft(e, tn(e, T)))), w)) {
                  var n = tn(e, w - 1);
                  s._tempValueRep.end = +en(tn(e, +Wt(e, n) + 1));
                }
              }
              (s._valueText = s._tempValueText = s._format(s._tempValueRep)), (s._valueTextChange = !0), s.set();
            }),
              (this._valueTextChange = !1);
          }
          var O,
            V = t.value !== N ? t.value !== c.value : n.value !== this._prevStateValue;
          if (
            (v && this._clearSaved && V && (this._savedEndValue = this._savedStartValue = N),
            (this._clearSaved = !0),
            (t.headerText === c.headerText &&
              t.selectCounter === c.selectCounter &&
              t.selectMultiple === c.selectMultiple) ||
              this._setHeader(),
            (this._scrollLock = t.scrollLock !== N ? t.scrollLock : !this._hasTimegrid),
            (this._showInput =
              t.showInput !== N ? t.showInput : this._showInput && (!v || (!t.startInput && !t.endInput))),
            (this._shouldInitInputs =
              this._shouldInitInputs || d !== c.select || t.startInput !== c.startInput || t.endInput !== c.endInput),
            (this._shouldInitInput = this._shouldInitInput || this._shouldInitInputs),
            S ||
              t.dateWheels !== c.dateWheels ||
              t.timeWheels !== c.timeWheels ||
              t.dateFormat !== c.dateFormat ||
              t.timeFormat !== c.timeFormat)
          ) {
            var P = t.dateWheels || t.dateFormat,
              L = t.timeWheels || t.timeFormat,
              H = (this._iso = {});
            o &&
              (/y/i.test(P) && (H.y = 1),
              /M/.test(P) && ((H.y = 1), (H.m = 1)),
              /d/i.test(P) && ((H.y = 1), (H.m = 1), (H.d = 1))),
              l && (/h/i.test(L) && (H.h = 1), /m/.test(L) && (H.i = 1), /s/i.test(L) && (H.s = 1));
          }
          if (
            (v
              ? (this._activeSelect === N && this._setActiveSelect('start', !0), (O = this._selectionNotReady()))
              : ((this._activeSelect = N), (O = !1)),
            this._buttons)
          ) {
            var Y = te(this._buttons, function (e) {
              return 'set' === e.name;
            });
            Y && Y.disabled !== O && ((Y.disabled = O), (this._buttons = this._buttons.slice()));
          }
          var A = this._activeSelect;
          this._needsWidth =
            ('anchored' === t.display ||
              'center' === t.display ||
              ('inline' !== t.display && n.isLarge) ||
              (u.length > 1 && !p)) &&
            t.width === N;
          var F = t.max !== N ? nn(t.max, t, k) : N,
            U = t.min !== N ? nn(t.min, t, k) : N;
          (this._maxLimited = F), (this._minLimited = U);
          var j = this._tempValueRep.start;
          if (j && (this._prevStart !== j || c.valid !== t.valid || c.invalid !== t.invalid)) {
            var B = tn(t, j);
            this._nextInvalid = t.valid ? cn(Va(t.valid, B, t), 1) : Oa(t.invalid || [], B, t);
          }
          var q = 'end' === A && j;
          if (q) {
            if (!t.inRangeInvalid) {
              var X = this._nextInvalid;
              X && (t.rangeEndInvalid ? (this._maxLimited = tn(t, +cn(X, 1) - 1)) : (this._maxLimited = tn(t, +X - 1)));
            }
            (this._hasCalendar && !l) ||
              ((!this._minLimited || nn(this._minLimited, t, k) < tn(t, j)) &&
                (this._minLimited = tn(t, this._tempValueRep.start)));
          }
          if (((this._minTimeLimited = this._minLimited), q)) {
            if (t.minRange) {
              var K = l ? this._tempValueRep.start + t.minRange : +cn(tn(t, this._tempValueRep.start), t.minRange) - 1;
              (!this._minLimited || +nn(this._minLimited, t, k) < K) &&
                ((this._minLimited = tn(t, K)), (this._minTimeLimited = this._minLimited));
            }
            if (
              (this._minTimeLimited === N &&
                this._tempValueRep.start &&
                this._tempValueRep.end &&
                (this._minTimeLimited = tn(t, +this._tempValueRep.start)),
              t.maxRange !== N)
            ) {
              var G = l ? this._tempValueRep.start + t.maxRange : +cn(tn(t, this._tempValueRep.start), t.maxRange) - 1;
              (!this._maxLimited || +nn(this._maxLimited, t, k) > G) && (this._maxLimited = tn(t, G));
            }
          }
          for (var J = 0, Z = this._controls; J < Z.length; J++) {
            var $ = Z[J],
              Q = a({}, m, {
                display: 'inline',
                isOpen: t.isOpen || n.isOpen,
                max: this._maxLimited,
                min: this._minLimited,
              });
            if (
              (t.rangeEndInvalid && q && this._nextInvalid && (Q.valid = (Q.valid || []).concat([this._nextInvalid])),
              'calendar' === $.name)
            ) {
              (Q.min = this._minLimited ? Bt(this._minLimited) : N),
                (Q.max = this._maxLimited ? Bt(this._maxLimited) : N),
                (Q.selectRange = v),
                (Q.width = this._needsWidth ? mn * Cn(t.pages, n.maxPopupWidth) : N),
                'week' === t.calendarType && h ? (Q.weeks = h) : (Q.size = h);
              var ee = 'auto' === t.pages ? 3 : t.pages || 1;
              if (((this._maxWidth = t.maxWidth || (ee > 2 ? mn * ee : N)), v)) {
                var ne = this._getDate(this._tempValueRep),
                  ae = ne[1];
                ae && t.exclusiveEndDates && !l && (ne[1] = tn(t, +ae - 1));
                var ie = ne
                  .filter(function (e) {
                    return null !== e;
                  })
                  .map(function (e) {
                    return +Bt(e);
                  })
                  .filter(function (e, t, n) {
                    return n.indexOf(e) === t;
                  })
                  .map(function (e) {
                    return new Date(e);
                  });
                if (((Q.value = ie), t.rangeHighlight))
                  if (
                    ((Q.rangeStart = ne[0] && +Bt(en(ne[0]))),
                    (Q.rangeEnd = ne[1] && +Bt(en(ne[1]))),
                    (Q.onDayHoverIn = this._onDayHoverIn),
                    (Q.onDayHoverOut = this._onDayHoverOut),
                    'preset-range' === d)
                  ) {
                    if (n.hoverDate) {
                      var se = Wa(n.hoverDate, t);
                      (y = se.start), (b = se.end);
                      (Q.hoverStart = +y), (Q.hoverEnd = +b);
                    }
                  } else
                    'end' === A && ne[0] && ((Q.hoverStart = Q.rangeEnd || Q.rangeStart), (Q.hoverEnd = n.hoverDate)),
                      'start' === A &&
                        ne[1] &&
                        this._renderControls &&
                        ((Q.hoverStart = n.hoverDate), (Q.hoverEnd = Q.rangeStart || Q.rangeEnd));
              } else (Q.selectMultiple = _), (Q.value = this._getDate(this._tempValueRep));
              for (
                var re = z(Q.value) ? Q.value : [Q.value],
                  oe = Q.min ? +Q.min : -1 / 0,
                  le = Q.max ? +Q.max : 1 / 0,
                  ce = void 0,
                  he = 0,
                  ue = re;
                he < ue.length;
                he++
              ) {
                var de = ue[he];
                !ce && de >= oe && de <= le && (ce = +de);
              }
              !ce && v && re.length && (ce = +re[0]),
                (ce === this._selectedDate && this._active !== N && t.min === c.min && t.max === c.max) ||
                  ((this._selectedDate = ce),
                  (this._active = ce ? +Bt(new Date(ce)) : R(this._active || +Bt(new Date()), oe, le)));
              var _e = t.dateWheels || t.dateFormat,
                pe = /d/i.test(_e) ? dn : /m/i.test(_e) ? _n : /y/i.test(_e) ? pn : dn;
              (Q.active = this._active),
                (Q.onActiveChange = this._onActiveChange),
                (Q.onChange = this._onCalendarChange),
                (Q.onCellClick = this._onCellClick),
                (Q.onCellHoverIn = this._proxy),
                (Q.onCellHoverOut = this._proxy),
                (Q.onLabelClick = this._proxy),
                (Q.onPageChange = this._proxy),
                (Q.onPageLoaded = this._proxy),
                (Q.onPageLoading = this._proxy),
                (Q.selectView = pe);
            } else {
              var me = Object.keys(this._tempValueRep.date || {});
              if (
                ((Q.displayStyle =
                  ('bottom' !== t.display && 'top' !== t.display) || (!this._hasCalendar && !this._renderTabs)
                    ? t.display
                    : 'center'),
                (Q.mode = $.name),
                ('time' !== $.name && 'timegrid' !== $.name) || !o)
              )
                if (((Q.onChange = this._onDatetimeChange), v)) {
                  var fe = this._tempValueRep[A],
                    ve = this._tempValueRep[Fa(A)];
                  (Q.value = fe ? tn(t, fe) : ve ? tn(t, ve) : null),
                    'end' === A && t.exclusiveEndDates && !l && (Q.value = tn(t, +Q.value - 1));
                } else {
                  var ge = this._tempValueRep.date && this._tempValueRep.date[me[0]],
                    ye = ge;
                  ge && (l || (ye = Bt(ge))), (Q.value = ye || null);
                }
              else {
                if (((Q.onChange = this._onTimePartChange), v)) {
                  var be = this._tempValueRep[A],
                    xe = void 0;
                  this._selectedTime &&
                    (!this._minTimeLimited || this._selectedTime > this._minTimeLimited
                      ? (xe = this._selectedTime)
                      : (xe = tn(t, this._minTimeLimited)).setHours(
                          this._selectedTime.getHours(),
                          this._selectedTime.getMinutes(),
                          this._selectedTime.getSeconds(),
                          this._selectedTime.getMilliseconds(),
                        ));
                  var Ce = tn(t);
                  Ce.setSeconds(0, 0),
                    (this._selectedTime = be ? tn(t, be) : xe || ('time' === $.name ? Ce : N)),
                    (Q.value = this._selectedTime);
                } else if (!t.selectMultiple) {
                  var we = (this._tempValueRep.date && this._tempValueRep.date[me[0]]) || this._selectedTime;
                  this._selectedTime = Q.value = we;
                }
                (Q.min = this._minTimeLimited), (Q.max = this._maxLimited);
              }
              if ('time' === $.name || 'timegrid' === $.name) {
                var Te = Q.value || hn(new Date(), Q.min, Q.max);
                if (this._minTime) {
                  var ke = this._minTime;
                  oe = new Date(
                    Te.getFullYear(),
                    Te.getMonth(),
                    Te.getDate(),
                    ke.getHours(),
                    ke.getMinutes(),
                    ke.getSeconds(),
                    ke.getMilliseconds(),
                  );
                  (!Q.min || oe > Q.min) && (Q.min = oe);
                }
                if (this._maxTime) {
                  var Se = this._maxTime;
                  le = new Date(
                    Te.getFullYear(),
                    Te.getMonth(),
                    Te.getDate(),
                    Se.getHours(),
                    Se.getMinutes(),
                    Se.getSeconds(),
                    Se.getMilliseconds(),
                  );
                  (!Q.max || le < Q.max) && (Q.max = le);
                }
              }
            }
            $.options = Q;
          }
          (this._prevStart = this._tempValueRep.start), (this._prevStateValue = n.value);
        }),
        (t.prototype._updated = function () {
          var t = this,
            n = this.s;
          if (this._shouldInitInputs) {
            if ((this._resetInputs(), 'range' === n.select)) {
              var a = n.startInput;
              a && this._setupInput('start', a);
              var i = n.endInput;
              i && this._setupInput('end', i),
                !n.element ||
                  (this._startInput !== n.element && this._endInput !== n.element) ||
                  ((this._shouldInitInput = !1), clearTimeout(n.element.__mbscTimer));
            }
            this._shouldInitInputs = !1;
          }
          var s = this._valueTextChange;
          if ((e.prototype._updated.call(this), 'range' === n.select && s)) {
            var r = function (e, n) {
              (e.value = n),
                setTimeout(function () {
                  (t._preventChange = !0), He(e, Yn), He(e, Nn);
                });
            };
            this._startInput && r(this._startInput, this._getValueText('start')),
              this._endInput && r(this._endInput, this._getValueText('end'));
          }
        }),
        (t.prototype._onEnterKey = function (t) {
          this._selectionNotReady() || e.prototype._onEnterKey.call(this, t);
        }),
        (t.prototype._setupInput = function (e, t) {
          var n = this;
          xa(t, function (t) {
            var a = Ca(t, n, n._onInputChangeRange, n._onInputClickRange);
            'start' === e
              ? ((n._startInput = t), (n._resetStartInput = a))
              : ((n._endInput = t), (n._resetEndInput = a));
            var i = n._getValueText(e),
              s = i !== t.value;
            (t.value = i),
              s &&
                setTimeout(function () {
                  (n._preventChange = !0), He(t, Yn), He(t, Nn);
                });
          });
        }),
        (t.prototype._destroy = function () {
          this._resetInputs(), e.prototype._destroy.call(this);
        }),
        (t.prototype._setHeader = function () {
          var t = this.s;
          if (t.selectCounter && t.selectMultiple) {
            var n = Object.keys((this._tempValueRep && this._tempValueRep.date) || {}).length;
            this._headerText = ((n > 1 && t.selectedPluralText) || t.selectedText).replace(/{count}/, '' + n);
          } else e.prototype._setHeader.call(this);
        }),
        (t.prototype._validate = function () {
          if (!(this._max <= this._min)) {
            var e = this.s,
              t = this._min ? +this._min : -1 / 0,
              n = this._max ? +this._max : 1 / 0;
            if ('date' === e.select) {
              var a = this._tempValueRep.date;
              if (!e.selectMultiple)
                for (var i = 0, s = Object.keys(a); i < s.length; i++) {
                  var r = s[i],
                    o = a[r],
                    l = Ha(o, e, t, n);
                  +l != +o && (delete a[r], (a[+Bt(l)] = l));
                }
            } else {
              var c = this._getDate(this._tempValueRep),
                h = c[0],
                u = c[1];
              h &&
                ((h = Ha(h, e, t, n)),
                e.inRangeInvalid ||
                  (this._prevStart && this._prevStart === +h) ||
                  (this._nextInvalid = e.valid ? cn(Va(e.valid, h, e), 1) : Oa(e.invalid || [], h, e))),
                u &&
                  (u =
                    !e.inRangeInvalid && this._nextInvalid && this._nextInvalid <= u
                      ? e.rangeEndInvalid
                        ? this._nextInvalid
                        : cn(this._nextInvalid, -1)
                      : Ha(u, e, t, n)),
                h && u && h > u && ('end' === this._activeSelect ? (h = u) : (u = h)),
                h && (this._prevStart = this._tempValueRep.start = +h),
                u && (this._tempValueRep.end = +u);
            }
          }
        }),
        (t.prototype._copy = function (e) {
          var t = e.date ? a({}, e.date) : e.date;
          return a({}, e, { date: t });
        }),
        (t.prototype._format = function (e) {
          var t = this.s,
            n = [];
          if (!t) return '';
          if ('date' === t.select) {
            var a = e.date;
            for (var i in a) a[i] !== N && null !== a[i] && n.push(rn(this._valueFormat, a[i], t));
            return t.selectMultiple ? n.join(', ') : n[0];
          }
          if ((e.start && n.push(rn(this._valueFormat, tn(t, e.start), t)), e.end)) {
            n.length || n.push('');
            var s = tn(t, e.end - (t.exclusiveEndDates && !this._hasTime ? 1 : 0));
            n.push(rn(this._valueFormat, s, t));
          }
          return (this._tempStartText = n[0] || ''), (this._tempEndText = n[1] || ''), n.join(za);
        }),
        (t.prototype._parse = function (e, t) {
          var n = this.s,
            a = {},
            i = 'date' !== n.select,
            s = n.selectMultiple,
            r = [];
          if (W(e)) {
            var o = n.defaultSelection;
            e = s || i ? o : null === o || (this._live && 'inline' !== n.display) ? null : o || new Date();
          }
          if ((F(e) && (i || s) ? (r = e.split(i ? za : ',')) : z(e) ? (r = e) : e && !z(e) && (r = [e]), i)) {
            var l = r[0],
              c = r[1],
              h = nn(l, n, this._valueFormat, this._iso),
              u = nn(c, n, this._valueFormat, this._iso);
            (a.start = h ? +h : N), (a.end = u ? +u : N);
          } else {
            a.date = {};
            for (var d = 0, _ = r; d < _.length; d++) {
              var p = _[d];
              if (!W(p)) {
                var m = nn(p, n, this._valueFormat, this._iso, t);
                if (m) {
                  t && (m = Qt(n, m));
                  var f = +Bt(m);
                  (a.date[f] = m), this._hasTime && (this._selectedTime = new Date(m));
                }
              }
            }
          }
          return a;
        }),
        (t.prototype._getDate = function (e) {
          var t = this.s;
          if ('date' !== t.select) {
            var n = e.start ? tn(t, e.start) : null,
              a = e.end ? tn(t, e.end) : null;
            return n || a ? [n, a] : [];
          }
          if (t.selectMultiple) {
            var i = [],
              s = e.date;
            if (s)
              for (var r = 0, o = Object.keys(s); r < o.length; r++) {
                var l = o[r];
                i.push(tn(t, +l));
              }
            return i;
          }
          var c = Object.keys(e.date || {});
          return c.length ? tn(t, e.date[c[0]]) : null;
        }),
        (t.prototype._get = function (e) {
          var t = this,
            n = this.s,
            a = this._valueFormat,
            i = this._iso,
            s = this._getDate(e);
          return z(s)
            ? s.map(function (e) {
                return e ? an(e, n, a, i, t._hasTime) : null;
              })
            : null === s
            ? null
            : an(s, n, a, i, this._hasTime);
        }),
        (t.prototype._onClosed = function () {
          (this._active = this._activeSelect = N), this._hasTimegrid && (this._selectedTime = N);
        }),
        (t.prototype._onOpen = function () {
          this._newSelection = !0;
        }),
        (t.prototype._resetInputs = function () {
          this._resetStartInput && (this._resetStartInput(), (this._resetStartInput = N)),
            this._resetEndInput && (this._resetEndInput(), (this._resetEndInput = N));
        }),
        (t.prototype._getValueText = function (e) {
          return this._valueText.split(za)['start' === e ? 0 : 1] || '';
        }),
        (t.prototype._selectionNotReady = function () {
          var e = !1;
          if ('range' === this.s.select) {
            var t = (this._get(this._tempValueRep || {}) || []).filter(function (e) {
              return e;
            });
            (e = !t.length) ||
              (e =
                (this._hasCalendar && !this._hasTime) || this._renderControls
                  ? t.length < 2
                  : !this._tempValueRep[this._activeSelect]);
          }
          return e;
        }),
        (t.prototype._setActiveSelect = function (e, t) {
          var n = this;
          this._activeSelect !== e &&
            (t
              ? setTimeout(function () {
                  return n._hook('onActiveDateChange', { active: e });
                })
              : this._hook('onActiveDateChange', { active: e })),
            (this._activeSelect = e);
        }),
        (t.defaults = a({}, Rt, wa.defaults, {
          activeElm: '.mbsc-calendar-cell[tabindex="0"]',
          controls: Ya,
          dateText: 'Date',
          inRangeInvalid: !1,
          inputTyping: !0,
          rangeEndHelp: 'Please select',
          rangeEndLabel: 'End',
          rangeHighlight: !0,
          rangeStartHelp: 'Please select',
          rangeStartLabel: 'Start',
          select: 'date',
          selectSize: 7,
          selectedText: '{count} selected',
          showOnClick: !0,
          timeText: 'Time',
        })),
        (t._name = 'Datepicker'),
        t
      );
    })(wa),
    ja = (function () {
      function e() {
        (this.pageSize = 0), (this._prevS = {}), (this._s = {});
      }
      return (
        (e.prototype.options = function (e, t) {
          var n = (this._s = a({}, this._s, e)),
            i = this._prevS,
            s = n.getDate,
            r = n.getYear,
            o = n.getMonth,
            l = n.showCalendar,
            c = n.calendarType,
            h = n.startDay,
            u = n.endDay,
            d = n.firstDay,
            _ = 'week' === c,
            p = l ? (_ ? n.weeks : 6) : 0,
            m = n.min === i.min && this.minDate ? this.minDate : W(n.min) ? -1 / 0 : nn(n.min),
            f = n.max === i.max && this.maxDate ? this.maxDate : W(n.max) ? 1 / 0 : nn(n.max),
            v = n.activeDate || +new Date(),
            g = R(v, +m, +f),
            y = this.forcePageChange || g !== v,
            b = new Date(g),
            x = g !== i.activeDate,
            C =
              n.calendarType !== i.calendarType ||
              n.eventRange !== i.eventRange ||
              n.firstDay !== i.firstDay ||
              n.eventRangeSize !== i.eventRangeSize ||
              n.refDate !== i.refDate ||
              l !== i.showCalendar ||
              n.size !== i.size ||
              n.weeks !== i.weeks,
            w =
              y ||
              this.pageIndex === N ||
              C ||
              (!this.preventPageChange && x && (g < +this.firstDay || g >= +this.lastDay))
                ? gn(b, n)
                : this.pageIndex,
            T = 'year' === c ? 12 : n.size || 1,
            k = T > 1 && !_,
            S = k ? 1 : Cn(n.pages, this.pageSize),
            D = 'vertical' === n.calendarScroll && 'auto' !== n.pages && (n.pages === N || 1 === n.pages),
            I = n.showOuterDays !== N ? n.showOuterDays : !D && S < 2 && (_ || !T || T < 2),
            M = k ? 0 : 1,
            E = vn(w, n),
            O = vn(w + S, n);
          l ||
            'week' !== n.eventRange ||
            h === N ||
            u === N ||
            ((E = cn(E, h - d + (h < d ? 7 : 0))), (O = cn(E, 7 * n.eventRangeSize + u - h + 1 - (u < h ? 0 : 7))));
          var V = l && I ? Kt(E, n) : E,
            P = k ? s(r(O), o(O) - 1, 1) : vn(w + S - 1, n),
            L = l && I ? cn(Kt(P, n), 7 * p) : O,
            H = l ? Kt(vn(w - M, n), n) : E,
            z = l ? Kt(vn(w + S + M - 1, n), n) : O,
            Y = l ? cn(k ? Kt(P, n) : z, 7 * p) : O,
            A = this.pageIndex === N,
            F = H,
            U = Y;
          if (!l && 'week' === n.resolution && ('year' === n.eventRange || 'month' === n.eventRange)) {
            var j = u - h + 1 + (u < h ? 7 : 0);
            if (E.getDay() !== h) F = (q = cn((B = Kt(E, n, h)), j)) <= E ? cn(B, 7) : B;
            if (O.getDay() !== h) {
              var B,
                q = cn((B = Kt(O, n, h)), j);
              U = B > O ? cn(q, -7) : q;
            }
          }
          var X = !1;
          w !== N && ((X = +F != +this.viewStart || +U != +this.viewEnd), (this.pageIndex = w)),
            (this.firstDay = E),
            (this.lastDay = O),
            (this.firstPageDay = V),
            (this.lastPageDay = L),
            (this.viewStart = F),
            (this.viewEnd = U),
            (this.forcePageChange = !1),
            (this.preventPageChange = !1),
            (this.minDate = m),
            (this.maxDate = f),
            (this._prevS = n),
            w !== N && (X || t) && (X && !A && this.pageChange(), this.pageLoading(X));
        }),
        (e.prototype.pageChange = function () {
          this._s.onPageChange &&
            this._s.onPageChange(
              {
                firstDay: this.firstPageDay,
                lastDay: this.lastPageDay,
                month: 'month' === this._s.calendarType ? this.firstDay : N,
                type: 'onPageChange',
                viewEnd: this.viewEnd,
                viewStart: this.viewStart,
              },
              null,
            );
        }),
        (e.prototype.pageLoading = function (e) {
          this._s.onPageLoading &&
            this._s.onPageLoading(
              {
                firstDay: this.firstPageDay,
                lastDay: this.lastPageDay,
                month: 'month' === this._s.calendarType ? this.firstDay : N,
                type: 'onPageLoading',
                viewChanged: e,
                viewEnd: this.viewEnd,
                viewStart: this.viewStart,
              },
              null,
            );
        }),
        e
      );
    })(),
    Ba = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t._navService = new ja()),
          (t._onDayClick = function (e) {
            var n = t.s,
              i = Qt(n, e.date),
              s = +i;
            if (!e.disabled) {
              if (n.selectMultiple) {
                var r = t._tempValueRep;
                r[s] ? delete r[s] : (n.selectMax === N || Object.keys(r).length < n.selectMax) && (r[s] = i),
                  (t._tempValueRep = a({}, r));
              } else n.selectRange || (t._tempValueRep = {}), (t._tempValueRep[s] = i);
              (t._navService.preventPageChange = n.selectRange), t._hook('onCellClick', e), t._setOrUpdate();
            }
          }),
          (t._onTodayClick = function () {
            var e = new Date(),
              n = +e;
            t.s.selectRange ||
              t.s.selectMultiple ||
              ((t._tempValueRep = {}), (t._tempValueRep[n] = e), t._setOrUpdate());
          }),
          (t._onActiveChange = function (e) {
            (t._navService.forcePageChange = e.pageChange), t._hook('onActiveChange', e);
          }),
          (t._setCal = function (e) {
            t._calendarView = e;
          }),
          t
        );
      }
      return (
        n(t, e),
        (t.prototype._valueEquals = function (e, t) {
          return ln(e, t, this.s);
        }),
        (t.prototype._shouldValidate = function (e, t) {
          return e.dataTimezone !== t.dataTimezone || e.displayTimezone !== t.displayTimezone;
        }),
        (t.prototype._render = function (t, n) {
          e.prototype._render.call(this, t, n),
            this._navService.options({
              activeDate: t.active,
              calendarType: t.calendarType,
              firstDay: t.firstDay,
              getDate: t.getDate,
              getDay: t.getDay,
              getMonth: t.getMonth,
              getYear: t.getYear,
              max: t.max,
              min: t.min,
              onPageChange: t.onPageChange,
              onPageLoading: t.onPageLoading,
              pages: t.pages,
              refDate: t.refDate,
              showCalendar: !0,
              showOuterDays: t.showOuterDays,
              size: t.size,
              weeks: t.weeks,
            });
        }),
        (t.prototype._copy = function (e) {
          return a({}, e);
        }),
        (t.prototype._format = function (e) {
          var t = this.s,
            n = [];
          for (var a in e) e[a] !== N && null !== e[a] && n.push(rn(t.dateFormat, new Date(+e[a]), t));
          return t.selectMultiple || t.selectRange ? n.join(', ') : n[0];
        }),
        (t.prototype._parse = function (e) {
          var t = this.s,
            n = t.selectRange,
            a = {},
            i = [];
          F(e) ? (i = e.split(',')) : z(e) ? (i = e) : e && !z(e) && (i = [e]);
          for (var s = 0, r = i; s < r.length; s++) {
            var o = r[s];
            if (null !== o) {
              var l = nn(o, t, t.dateFormat);
              a[n ? +l : +Bt(l)] = l;
            }
          }
          return a;
        }),
        (t.prototype._get = function (e) {
          var t = this.s,
            n = t.selectRange;
          if (this.s.selectMultiple || n) {
            for (var a = [], i = 0, s = Object.keys(e); i < s.length; i++) {
              var r = s[i];
              a.push(tn(t, +e[r]));
            }
            return a;
          }
          var o = Object.keys(e || {});
          return o.length ? tn(t, e[o[0]]) : null;
        }),
        (t.defaults = a({}, fn, {
          calendarScroll: 'horizontal',
          calendarType: 'month',
          selectedText: '{count} selected',
          showControls: !0,
          showOnClick: !0,
          weeks: 1,
        })),
        (t._name = 'Calendar'),
        t
      );
    })(wa),
    qa = (function () {
      function e() {
        (this.onInstanceReady = new o()), (this.onComponentChange = new o());
      }
      return (
        Object.defineProperty(e.prototype, 'instance', {
          get: function () {
            return this.inst;
          },
          set: function (e) {
            (this.inst = e), this.onInstanceReady.next(e);
          },
          enumerable: !0,
          configurable: !0,
        }),
        e
      );
    })(),
    Xa = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype._render = function (e) {
          (this._hasChildren = !F(e.name)),
            (this._cssClass =
              this._className +
              ' mbsc-icon' +
              this._theme +
              (e.name && !this._hasChildren
                ? -1 !== e.name.indexOf(' ')
                  ? ' ' + e.name
                  : ' mbsc-font-icon mbsc-icon-' + e.name
                : '')),
            (this._svg = e.svg ? this._safeHtml(e.svg) : N);
        }),
        t
      );
    })(En);
  var Ka,
    Ga,
    Ja = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype._template = function (e) {
          return (function (e, t) {
            return je(
              'span',
              { onClick: e.onClick, className: t._cssClass, dangerouslySetInnerHTML: t._svg, 'v-html': N },
              t._hasChildren && e.name,
            );
          })(e, this);
        }),
        t
      );
    })(Xa),
    Za = 0;
  function $a(e, t, n) {
    var a = (n ? 'page' : 'client') + t;
    return e.targetTouches && e.targetTouches[0]
      ? e.targetTouches[0][a]
      : e.changedTouches && e.changedTouches[0]
      ? e.changedTouches[0][a]
      : e[a];
  }
  function Qa(e, t) {
    if (!t.mbscClick) {
      var n = (e.originalEvent || e).changedTouches[0],
        a = document.createEvent('MouseEvents');
      a.initMouseEvent('click', !0, !0, window, 1, n.screenX, n.screenY, n.clientX, n.clientY, !1, !1, !1, !1, 0, null),
        (a.isMbscTap = !0),
        (a.isIonicTap = !0),
        (Ka = !0),
        (t.mbscChange = !0),
        (t.mbscClick = !0),
        t.dispatchEvent(a),
        (Ka = !1),
        Za++,
        setTimeout(function () {
          Za--;
        }, 500),
        setTimeout(function () {
          delete t.mbscClick;
        });
    }
  }
  function ei(e) {
    !Za ||
      Ka ||
      e.isMbscTap ||
      ('TEXTAREA' === e.target.nodeName && e.type === Fn) ||
      (e.stopPropagation(), e.preventDefault());
  }
  function ti(e) {
    Ie(e.target).__mbscFocusVisible = !1;
  }
  function ni(e) {
    Ie(e.target).__mbscFocusVisible = !0;
  }
  function ai(e) {
    Te(e.target).__mbscMoveObs.next(e);
  }
  function ii(e) {
    e &&
      setTimeout(function () {
        (e.style.opacity = '0'),
          (e.style.transition = 'opacity linear .4s'),
          setTimeout(function () {
            e && e.parentNode && e.parentNode.removeChild(e);
          }, 400);
      }, 200);
  }
  function si(e, t) {
    var n,
      a,
      i,
      s,
      r,
      l,
      c,
      h,
      u,
      d,
      _,
      p,
      m,
      f,
      v,
      g,
      y = {},
      b = Ie(e),
      x = Te(e);
    function C(e) {
      if (e.type === Gn) Ga = !0;
      else if (Ga) return e.type === Fn && (Ga = !1), !0;
      return !1;
    }
    function w() {
      c &&
        (ii(s),
        (s = (function (e, t, n) {
          var a = e.getBoundingClientRect(),
            i = t - a.left,
            s = n - a.top,
            r = Math.max(i, e.offsetWidth - i),
            o = Math.max(s, e.offsetHeight - s),
            l = 2 * Math.sqrt(Math.pow(r, 2) + Math.pow(o, 2)),
            c = ie.createElement('span');
          c.classList.add('mbsc-ripple');
          var h = c.style;
          return (
            (h.backgroundColor = getComputedStyle(e).color),
            (h.width = l + 'px'),
            (h.height = l + 'px'),
            (h.top = n - a.top - l / 2 + 'px'),
            (h.left = t - a.left - l / 2 + 'px'),
            e.appendChild(c),
            setTimeout(function () {
              (h.opacity = '.2'),
                (h.transform = 'scale(1)'),
                (h.transition = 'opacity linear .1s, transform cubic-bezier(0, 0, 0.2, 1) .4s');
            }, 30),
            c
          );
        })(e, p, m))),
        t.onPress(),
        (n = !0);
    }
    function T(e, s) {
      (a = !1),
        ii(e),
        clearTimeout(i),
        (i = setTimeout(function () {
          n && (t.onRelease(), (n = !1));
        }, s));
    }
    function k(e) {
      if (!C(e) && (e.type !== Fn || (0 === e.button && !e.ctrlKey))) {
        if (
          ((d = $a(e, 'X')),
          (_ = $a(e, 'Y')),
          (p = d),
          (m = _),
          (n = !1),
          (a = !1),
          (h = !1),
          (g = !0),
          (y.moved = h),
          (y.startX = d),
          (y.startY = _),
          (y.endX = p),
          (y.endY = m),
          (y.deltaX = 0),
          (y.deltaY = 0),
          (y.domEvent = e),
          (y.isTouch = Ga),
          ii(s),
          t.onStart)
        ) {
          var r = t.onStart(y);
          c = r && r.ripple;
        }
        t.onPress && ((a = !0), clearTimeout(i), (i = setTimeout(w, 50))),
          e.type === Fn && (Ce(x, Wn, S), Ce(x, Un, D)),
          Ce(x, Ln, H);
      }
    }
    function S(e) {
      g &&
        ((p = $a(e, 'X')),
        (m = $a(e, 'Y')),
        (f = p - d),
        (v = m - _),
        !h && (Math.abs(f) > 9 || Math.abs(v) > 9) && ((h = !0), T(s)),
        (y.moved = h),
        (y.endX = p),
        (y.endY = m),
        (y.deltaX = f),
        (y.deltaY = v),
        (y.domEvent = e),
        (y.isTouch = e.type === Jn),
        t.onMove && t.onMove(y));
    }
    function D(e) {
      g &&
        (a && !n && (clearTimeout(i), w()),
        (y.domEvent = e),
        (y.isTouch = e.type === Zn),
        t.onEnd && t.onEnd(y),
        T(s, 75),
        (g = !1),
        e.type === Zn && t.click && ge && !h && Qa(e, e.target),
        e.type === Un && (we(x, Wn, S), we(x, Un, D)),
        we(x, Ln, H));
    }
    function I(e) {
      C(e) || ((l = !0), t.onHoverIn(e));
    }
    function M(e) {
      l && t.onHoverOut(e), (l = !1);
    }
    function E(e) {
      t.onKeyDown(e);
    }
    function O(e) {
      (t.keepFocus || b.__mbscFocusVisible) && ((r = !0), t.onFocus(e));
    }
    function V(e) {
      r && t.onBlur(e), (r = !1);
    }
    function N(e) {
      t.onChange(e);
    }
    function P(e) {
      t.onInput(e);
    }
    function L(e) {
      (y.domEvent = e), Ga || t.onDoubleClick(y);
    }
    function H(e) {
      Ga && e.preventDefault();
    }
    if ((Ce(e, Gn, k, { passive: !0 }), Ce(e, Fn, k), Ce(e, Zn, D), Ce(e, $n, D), x)) {
      var R = x.__mbscMoveCount || 0,
        z = x.__mbscMoveObs || new o();
      0 === R && Ce(x, Jn, ai, { passive: !1 }), (x.__mbscMoveObs = z), (x.__mbscMoveCount = ++R), (u = z.subscribe(S));
    }
    if (
      (t.onChange && Ce(e, Nn, N),
      t.onInput && Ce(e, Yn, P),
      t.onHoverIn && Ce(e, jn, I),
      t.onHoverOut && Ce(e, Bn, M),
      t.onKeyDown && Ce(e, An, E),
      t.onFocus && b && (Ce(e, Rn, O), !t.keepFocus))
    ) {
      var Y = b.__mbscFocusCount || 0;
      0 === Y && (Ce(b, Fn, ti, !0), Ce(b, An, ni, !0)), (b.__mbscFocusCount = ++Y);
    }
    return (
      t.onBlur && Ce(e, Vn, V),
      t.onDoubleClick && Ce(e, Hn, L),
      function () {
        if ((clearTimeout(i), t.onFocus && b && !t.keepFocus)) {
          var n = b.__mbscFocusCount || 0;
          (b.__mbscFocusCount = --n), n <= 0 && (we(b, Fn, ti), we(b, An, ni));
        }
        if (x) {
          var a = x.__mbscMoveCount || 0;
          (x.__mbscMoveCount = --a),
            x.__mbscMoveObs && x.__mbscMoveObs.unsubscribe(u),
            a <= 0 && (delete x.__mbscMoveCount, delete x.__mbscMoveObs, we(x, Jn, ai, { passive: !1 }));
        }
        we(e, Yn, P),
          we(e, Fn, k, { passive: !0 }),
          we(e, Zn, D),
          we(e, $n, D),
          we(x, Wn, S),
          we(x, Un, D),
          we(x, Ln, H),
          we(e, Nn, N),
          we(e, jn, I),
          we(e, Bn, M),
          we(e, An, E),
          we(e, Gn, k),
          we(e, Rn, O),
          we(e, Vn, V),
          we(e, Hn, L);
      }
    );
  }
  h &&
    (['mousedown', jn, Fn, Un, Pn].forEach(function (e) {
      ie.addEventListener(e, ei, !0);
    }),
    'android' === s &&
      v < 5 &&
      ie.addEventListener(
        Nn,
        function (e) {
          var t = e.target;
          Za && 'checkbox' === t.type && !t.mbscChange && (e.stopPropagation(), e.preventDefault()),
            delete t.mbscChange;
        },
        !0,
      ));
  var ri = (function (e) {
    function t() {
      return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
      n(t, e),
      (t.prototype._mounted = function () {
        var e = this;
        this._unlisten = si(this._el, {
          click: !0,
          onBlur: function () {
            e.setState({ hasFocus: !1 });
          },
          onFocus: function () {
            e.setState({ hasFocus: !0 });
          },
          onHoverIn: function () {
            e.s.disabled || e.setState({ hasHover: !0 });
          },
          onHoverOut: function () {
            e.setState({ hasHover: !1 });
          },
          onKeyDown: function (t) {
            switch (t.keyCode) {
              case ea:
              case ta:
                e._el.click(), t.preventDefault();
            }
          },
          onPress: function () {
            e.setState({ isActive: !0 });
          },
          onRelease: function () {
            e.setState({ isActive: !1 });
          },
          onStart: function () {
            return { ripple: e.s.ripple && !e.s.disabled };
          },
        });
      }),
      (t.prototype._render = function (e, t) {
        var n = this,
          a = e.disabled;
        (this._isIconOnly = !(!e.icon && !e.iconSvg)),
          (this._hasStartIcon = !(!e.startIcon && !e.startIconSvg)),
          (this._hasEndIcon = !(!e.endIcon && !e.endIconSvg)),
          (this._tabIndex = a ? N : e.tabIndex || 0),
          (this._cssClass =
            this._className +
            ' mbsc-reset mbsc-font mbsc-button' +
            this._theme +
            this._rtl +
            ' mbsc-button-' +
            e.variant +
            (this._isIconOnly ? ' mbsc-icon-button' : '') +
            (a ? ' mbsc-disabled' : '') +
            (e.color ? ' mbsc-button-' + e.color : '') +
            (t.hasFocus && !a ? ' mbsc-focus' : '') +
            (t.isActive && !a ? ' mbsc-active' : '') +
            (t.hasHover && !a ? ' mbsc-hover' : '')),
          (this._iconClass = 'mbsc-button-icon' + this._rtl),
          (this._startIconClass = this._iconClass + ' mbsc-button-icon-start'),
          (this._endIconClass = this._iconClass + ' mbsc-button-icon-end'),
          e.disabled &&
            t.hasHover &&
            setTimeout(function () {
              n.setState({ hasHover: !1 });
            });
      }),
      (t.prototype._destroy = function () {
        this._unlisten && this._unlisten();
      }),
      (t.defaults = { ripple: !1, role: 'button', tag: 'button', variant: 'standard' }),
      (t._name = 'Button'),
      t
    );
  })(En);
  var oi = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype._template = function (e) {
          return (function (e, t, n) {
            var s = t.props,
              r = s.ariaLabel;
            s.children, s.className, s.color;
            var o = s.endIcon;
            s.endIconSrc;
            var l = s.endIconSvg;
            s.hasChildren;
            var c = s.icon;
            s.iconSrc;
            var h = s.iconSvg;
            s.ripple, s.rtl;
            var u = s.role,
              d = s.startIcon;
            s.startIconSrc;
            var _ = s.startIconSvg;
            s.tag, s.tabIndex, s.theme, s.themeVariant, s.variant;
            var p = i(s, [
                'ariaLabel',
                'children',
                'className',
                'color',
                'endIcon',
                'endIconSrc',
                'endIconSvg',
                'hasChildren',
                'icon',
                'iconSrc',
                'iconSvg',
                'ripple',
                'rtl',
                'role',
                'startIcon',
                'startIconSrc',
                'startIconSvg',
                'tag',
                'tabIndex',
                'theme',
                'themeVariant',
                'variant',
              ]),
              m = a({ 'aria-label': r, className: t._cssClass, ref: t._setEl }, p),
              f = je(
                qe,
                null,
                t._isIconOnly && je(Ja, { className: t._iconClass, name: c, svg: h, theme: e.theme }),
                t._hasStartIcon && je(Ja, { className: t._startIconClass, name: d, svg: _, theme: e.theme }),
                n,
                t._hasEndIcon && je(Ja, { className: t._endIconClass, name: o, svg: l, theme: e.theme }),
              );
            return 'span' === e.tag
              ? je('span', a({ role: u, 'aria-disabled': e.disabled, tabIndex: t._tabIndex }, m), f)
              : 'a' === e.tag
              ? je('a', a({ 'aria-disabled': e.disabled, tabIndex: t._tabIndex }, m), f)
              : je('button', a({ role: u, tabIndex: t._tabIndex }, m), f);
          })(e, this, e.children);
        }),
        t
      );
    })(ri),
    li = ft({}),
    ci = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype.componentWillUnmount = function () {
          this._changes && this._changes.unsubscribe(this._handler);
        }),
        (t.prototype.render = function () {
          var e = this,
            t = this.props,
            n = t.host,
            s = t.component,
            r = t.view,
            o = i(t, ['host', 'component', 'view']),
            l = r || (n && n._calendarView);
          return (
            l &&
              !this._changes &&
              ((this._changes = l.s.instanceService.onComponentChange),
              (this._handler = this._changes.subscribe(function () {
                e.forceUpdate();
              }))),
            je(li.Consumer, null, function (e) {
              var t = e.instance || r || (n && n._calendarView);
              return t && je(s, a({ inst: t }, o));
            })
          );
        }),
        t
      );
    })(vt),
    hi = function (e) {
      var t = e.inst,
        n = e.className;
      return je(oi, {
        ariaLabel: t.s.prevPageText,
        className: 'mbsc-calendar-button ' + (n || ''),
        disabled: t._isPrevDisabled(),
        iconSvg: t._prevIcon,
        onClick: t.prevPage,
        theme: t.s.theme,
        themeVariant: t.s.themeVariant,
        type: 'button',
        variant: 'flat',
      });
    },
    ui = function (e) {
      var t = e.inst,
        n = e.className;
      return je(oi, {
        ariaLabel: t.s.nextPageText,
        disabled: t._isNextDisabled(),
        className: 'mbsc-calendar-button ' + (n || ''),
        iconSvg: t._nextIcon,
        onClick: t.nextPage,
        theme: t.s.theme,
        themeVariant: t.s.themeVariant,
        type: 'button',
        variant: 'flat',
      });
    },
    di = function (e) {
      var t = e.inst,
        n = e.className;
      return je(
        oi,
        {
          className: 'mbsc-calendar-button mbsc-calendar-button-today ' + (n || ''),
          onClick: t._onTodayClick,
          theme: t.s.theme,
          themeVariant: t.s.themeVariant,
          type: 'button',
          variant: 'flat',
        },
        t.s.todayText,
      );
    },
    _i = function (e) {
      var t = e.inst,
        n = e.className,
        a = t.s,
        i = t._theme,
        s = t._view;
      return je(
        'div',
        { 'aria-live': 'polite', className: (n || '') + i },
        t._title.map(function (e, n) {
          return (
            (1 === t._pageNr || 0 === n || t._hasPicker || s === dn) &&
            je(
              oi,
              {
                className: 'mbsc-calendar-button',
                'data-index': n,
                onClick: t._onPickerBtnClick,
                key: n,
                theme: a.theme,
                themeVariant: a.themeVariant,
                type: 'button',
                variant: 'flat',
              },
              (t._hasPicker || s === dn) &&
                (e.title
                  ? je('span', { className: 'mbsc-calendar-title' + i }, e.title)
                  : je(
                      qe,
                      null,
                      t._yearFirst &&
                        je('span', { className: 'mbsc-calendar-title mbsc-calendar-year' + i }, e.yearTitle),
                      je('span', { className: 'mbsc-calendar-title mbsc-calendar-month' + i }, e.monthTitle),
                      !t._yearFirst &&
                        je('span', { className: 'mbsc-calendar-title mbsc-calendar-year' + i }, e.yearTitle),
                    )),
              !t._hasPicker && s !== dn && je('span', { className: 'mbsc-calendar-title' + i }, t._viewTitle),
              a.downIcon && 1 === t._pageNr ? je(Ja, { svg: s === dn ? a.downIcon : a.upIcon, theme: a.theme }) : null,
            )
          );
        }),
      );
    },
    pi = function (e) {
      var t = e.calendar,
        n = e.view,
        s = i(e, ['calendar', 'view']);
      return je(ci, a({ component: hi, host: t, view: n }, s));
    };
  pi._name = 'CalendarPrev';
  var mi = function (e) {
    var t = e.calendar,
      n = e.view,
      s = i(e, ['calendar', 'view']);
    return je(ci, a({ component: ui, host: t, view: n }, s));
  };
  mi._name = 'CalendarNext';
  var fi = function (e) {
    var t = e.calendar,
      n = e.view,
      s = i(e, ['calendar', 'view']);
    return je(ci, a({ component: di, host: t, view: n }, s));
  };
  fi._name = 'CalendarToday';
  var vi = function (e) {
    var t = e.calendar,
      n = e.view,
      s = i(e, ['calendar', 'view']);
    return je(ci, a({ component: _i, host: t, view: n }, s));
  };
  vi._name = 'CalendarNav';
  var gi = (function (e) {
    function t() {
      var t = (null !== e && e.apply(this, arguments)) || this;
      return (
        (t.state = { height: 'sm', pageSize: 0, pickerSize: 0, width: 'sm' }),
        (t._dim = {}),
        (t._months = [1, 2, 3]),
        (t._title = []),
        (t.MONTH_VIEW = dn),
        (t.YEAR_VIEW = _n),
        (t.MULTI_YEAR_VIEW = pn),
        (t.nextPage = function () {
          switch ((t._prevDocClick(), t._view)) {
            case pn:
              t._activeYearsChange(1);
              break;
            case _n:
              t._activeYearChange(1);
              break;
            default:
              t._activeChange(1);
          }
        }),
        (t.prevPage = function () {
          switch ((t._prevDocClick(), t._view)) {
            case pn:
              t._activeYearsChange(-1);
              break;
            case _n:
              t._activeYearChange(-1);
              break;
            default:
              t._activeChange(-1);
          }
        }),
        (t._changeView = function (e) {
          var n = t.s,
            a = t._view,
            i = t._hasPicker,
            s = n.selectView,
            r = 'year' === (n.showCalendar ? n.calendarType : n.eventRange);
          if (!e) {
            switch (a) {
              case dn:
                e = pn;
                break;
              case pn:
                e = _n;
                break;
              default:
                e = i || s === _n ? pn : dn;
            }
            a === pn && r && (e = dn);
          }
          var o = i && e === s;
          t.setState({ view: e, viewClosing: o ? N : a, viewOpening: o ? N : e });
        }),
        (t._onDayHoverIn = function (e) {
          t._disableHover ||
            (t._hook('onDayHoverIn', e),
            (t._hoverTimer = setTimeout(function () {
              var n = jt(e.date);
              t._labels && (e.labels = t._labels[n]),
                t._marked && (e.marked = t._marked[n]),
                (t._isHover = !0),
                t._hook('onCellHoverIn', e);
            }, 150)));
        }),
        (t._onDayHoverOut = function (e) {
          if (!t._disableHover && (t._hook('onDayHoverOut', e), clearTimeout(t._hoverTimer), t._isHover)) {
            var n = jt(e.date);
            t._labels && (e.labels = t._labels[n]),
              t._marked && (e.marked = t._marked[n]),
              (t._isHover = !1),
              t._hook('onCellHoverOut', e);
          }
        }),
        (t._onLabelClick = function (e) {
          (t._isLabelClick = !0), t._hook('onLabelClick', e);
        }),
        (t._onDayClick = function (e) {
          (t._shouldFocus = !t._isLabelClick), (t._prevAnim = !1), (t._isLabelClick = !1), t._hook('onDayClick', e);
        }),
        (t._onTodayClick = function (e) {
          (t._prevAnim = !1), t._hook('onActiveChange', { date: +en(tn(t.s)), today: !0 }), t._hook('onTodayClick', {});
        }),
        (t._onMonthClick = function (e) {
          if (!e.disabled) {
            var n = e.date,
              a = t.s;
            if (a.selectView === _n) t._hook('onDayClick', e);
            else {
              var i = gn(n, a);
              t._prevDocClick(),
                t._changeView(dn),
                (t._shouldFocus = !0),
                (t._prevAnim = !t._hasPicker),
                t._hook('onActiveChange', { date: +n, nav: !0, pageChange: i !== t._pageIndex });
            }
          }
        }),
        (t._onYearClick = function (e) {
          if (!e.disabled) {
            var n = e.date,
              a = t.s,
              i = a.selectView;
            if (i === pn) t._hook('onDayClick', e);
            else if (
              ((t._shouldFocus = !0),
              (t._prevAnim = i === _n),
              (t._activeMonth = +n),
              t._prevDocClick(),
              t._changeView(),
              'year' === (a.showCalendar ? a.calendarType : a.eventRange))
            ) {
              var s = gn(n, a);
              t._hook('onActiveChange', { date: +n, pageChange: s !== t._pageIndex });
            }
          }
        }),
        (t._onPageChange = function (e) {
          (t._isSwipeChange = !0), t._activeChange(e.diff);
        }),
        (t._onYearPageChange = function (e) {
          t._activeYearChange(e.diff);
        }),
        (t._onYearsPageChange = function (e) {
          t._activeYearsChange(e.diff);
        }),
        (t._onAnimationEnd = function (e) {
          (t._disableHover = !1), t._isIndexChange && (t._pageLoaded(), (t._isIndexChange = !1));
        }),
        (t._onStart = function () {
          clearTimeout(t._hoverTimer);
        }),
        (t._onGestureStart = function (e) {
          (t._disableHover = !0), t._hook('onGestureStart', e);
        }),
        (t._onGestureEnd = function (e) {
          t._prevDocClick();
        }),
        (t._onPickerClose = function () {
          t.setState({ view: dn });
        }),
        (t._onPickerOpen = function () {
          var e = t._pickerCont.clientHeight,
            n = t._pickerCont.clientWidth;
          t.setState({ pickerSize: t._isVertical ? e : n });
        }),
        (t._onPickerBtnClick = function (e) {
          t._view === dn && (t._pickerBtn = e.currentTarget), t._prevDocClick(), t._changeView();
        }),
        (t._onDocClick = function () {
          var e = t.s.selectView;
          t._prevClick || t._hasPicker || t._view === e || t._changeView(e);
        }),
        (t._onViewAnimationEnd = function () {
          t.state.viewClosing && t.setState({ viewClosing: N }), t.state.viewOpening && t.setState({ viewOpening: N });
        }),
        (t._onResize = function () {
          if (t._body && h) {
            var e = t.s,
              n = t.state,
              a = e.showCalendar,
              i = a ? t._body.querySelector('.mbsc-calendar-body-inner') : t._body,
              s = t._el.offsetWidth,
              r = t._el.offsetHeight,
              o = i.clientHeight,
              l = i.clientWidth,
              c = t._isVertical ? o : l,
              u = t._hasPicker ? n.pickerSize : c,
              d = a !== N,
              _ = 'sm',
              p = 'sm',
              m = 1,
              f = !1,
              v = 0,
              g = 0;
            if (
              (e.responsiveStyle && !t._isGrid && (o > 300 && (p = 'md'), l > 767 && (_ = 'md')),
              _ !== n.width || p !== n.height)
            )
              (t._shouldCheckSize = !0), t.setState({ width: _, height: p });
            else {
              if (t._labels && a) {
                var y = i.querySelector('.mbsc-calendar-text'),
                  b = i.querySelector('.mbsc-calendar-day-inner'),
                  x = b.querySelector('.mbsc-calendar-labels'),
                  C = y ? ke(y, 'marginBottom') : 2,
                  w = y ? y.offsetHeight : 18;
                (v = x.offsetTop),
                  (f = i.scrollHeight > i.clientHeight),
                  (g = w + C),
                  (m = Math.max(1, $((b.clientHeight - v) / g)));
              }
              t._hook('onResize', { height: r, target: t._el, width: s }), (e.navigationService.pageSize = c);
              var T = t._shouldPageLoad ? (n.update || 0) + 1 : n.update;
              t.setState({
                cellTextHeight: v,
                hasScrollY: f,
                labelHeight: g,
                maxLabels: m,
                pageSize: c,
                pickerSize: u,
                ready: d,
                update: T,
              });
            }
          }
        }),
        (t._onKeyDown = function (e) {
          var n,
            a = t.s,
            i = t._view,
            s = i === dn ? t._active : t._activeMonth,
            r = new Date(s),
            o = a.getYear(r),
            l = a.getMonth(r),
            c = a.getDay(r),
            h = a.getDate,
            u = a.weeks,
            d = 'month' === a.calendarType;
          if (i === pn) {
            var _ = void 0;
            switch (e.keyCode) {
              case ra:
                _ = o - 1 * t._rtlNr;
                break;
              case la:
                _ = o + 1 * t._rtlNr;
                break;
              case oa:
                _ = o - 3;
                break;
              case ca:
                _ = o + 3;
                break;
              case sa:
                _ = t._getPageYears(t._yearsIndex);
                break;
              case ia:
                _ = t._getPageYears(t._yearsIndex) + 11;
                break;
              case na:
                _ = o - 12;
                break;
              case aa:
                _ = o + 12;
            }
            _ &&
              t._minYears <= _ &&
              t._maxYears >= _ &&
              (e.preventDefault(),
              (t._shouldFocus = !0),
              (t._prevAnim = !1),
              (t._activeMonth = +h(_, 0, 1)),
              t.forceUpdate());
          } else if (i === _n) {
            switch (e.keyCode) {
              case ra:
                n = h(o, l - 1 * t._rtlNr, 1);
                break;
              case la:
                n = h(o, l + 1 * t._rtlNr, 1);
                break;
              case oa:
                n = h(o, l - 3, 1);
                break;
              case ca:
                n = h(o, l + 3, 1);
                break;
              case sa:
                n = h(o, 0, 1);
                break;
              case ia:
                n = h(o, 11, 1);
                break;
              case na:
                n = h(o - 1, l, 1);
                break;
              case aa:
                n = h(o + 1, l, 1);
            }
            n &&
              t._minYear <= n &&
              t._maxYear >= n &&
              (e.preventDefault(), (t._shouldFocus = !0), (t._prevAnim = !1), (t._activeMonth = +n), t.forceUpdate());
          } else if (i === dn) {
            switch (e.keyCode) {
              case ra:
                n = h(o, l, c - 1 * t._rtlNr);
                break;
              case la:
                n = h(o, l, c + 1 * t._rtlNr);
                break;
              case oa:
                n = h(o, l, c - 7);
                break;
              case ca:
                n = h(o, l, c + 7);
                break;
              case sa:
                n = h(o, l, 1);
                break;
              case ia:
                n = h(o, l + 1, 0);
                break;
              case na:
                n = e.altKey ? h(o - 1, l, c) : d ? h(o, l - 1, c) : h(o, l, c - 7 * u);
                break;
              case aa:
                n = e.altKey ? h(o + 1, l, c) : d ? h(o, l + 1, c) : h(o, l, c + 7 * u);
            }
            if (n && t._minDate <= n && t._maxDate >= n) {
              e.preventDefault();
              var p = gn(n, a);
              (t._shouldFocus = !0),
                (t._prevAnim = !1),
                (t._pageChange = a.noOuterChange && p !== t._pageIndex),
                t._hook('onActiveChange', { date: +n, pageChange: t._pageChange });
            }
          }
        }),
        (t._setHeader = function (e) {
          t._headerElement = e;
        }),
        (t._setBody = function (e) {
          t._body = e;
        }),
        (t._setPickerCont = function (e) {
          t._pickerCont = e;
        }),
        t
      );
    }
    return (
      n(t, e),
      (t.prototype._getPageDay = function (e) {
        return +vn(e, this.s);
      }),
      (t.prototype._getPageStyle = function (e, t, n) {
        var a;
        return (
          ((a = {})[(ye ? ye + 'T' : 't') + 'ransform'] =
            'translate' + this._axis + '(' + 100 * (e - t) * this._rtlNr + '%)'),
          (a.width = 100 / (n || 1) + '%'),
          a
        );
      }),
      (t.prototype._getPageYear = function (e) {
        var t = this.s,
          n = t.refDate ? nn(t.refDate) : Lt;
        return t.getYear(n) + e;
      }),
      (t.prototype._getPageYears = function (e) {
        var t = this.s,
          n = t.refDate ? nn(t.refDate) : Lt;
        return t.getYear(n) + 12 * e;
      }),
      (t.prototype._getPickerClass = function (e) {
        var t,
          n = e === this.s.selectView ? ' mbsc-calendar-picker-main' : '',
          a = 'mbsc-calendar-picker',
          i = this._hasPicker,
          s = this.state,
          r = s.viewClosing,
          o = s.viewOpening;
        switch (e) {
          case dn:
            t = i ? '' : (o === dn ? 'in-down' : '') + (r === dn ? 'out-down' : '');
            break;
          case pn:
            t = i && r === dn ? '' : (o === pn ? 'in-up' : '') + (r === pn ? 'out-up' : '');
            break;
          default:
            t =
              i && o === dn
                ? ''
                : (o === _n ? (r === pn ? 'in-down' : 'in-up') : '') +
                  (r === _n ? (o === pn ? 'out-down' : 'out-up') : '');
        }
        return a + n + (me && t ? ' ' + a + '-' + t : '');
      }),
      (t.prototype._isNextDisabled = function (e) {
        if (!this._hasPicker || e) {
          var t = this._view;
          if (t === pn) return this._yearsIndex + 1 > this._maxYearsIndex;
          if (t === _n) return this._yearIndex + 1 > this._maxYearIndex;
        }
        return this._pageIndex + 1 > this._maxIndex;
      }),
      (t.prototype._isPrevDisabled = function (e) {
        if (!this._hasPicker || e) {
          var t = this._view;
          if (t === pn) return this._yearsIndex - 1 < this._minYearsIndex;
          if (t === _n) return this._yearIndex - 1 < this._minYearIndex;
        }
        return this._pageIndex - 1 < this._minIndex;
      }),
      (t.prototype._render = function (e, t) {
        var n = e.getDate,
          a = e.getYear,
          i = e.getMonth,
          s = e.showCalendar,
          r = e.calendarType,
          o = e.eventRange,
          l = e.eventRangeSize || 1,
          c = e.firstDay,
          h = 'week' === r,
          u = 'month' === r,
          d = 'year' === r ? 12 : +(e.size || 1),
          _ = d > 1 && !h,
          p = s ? (h ? e.weeks : 6) : 0,
          m = e.activeDate || this._active || +new Date(),
          f = m !== this._active,
          v = new Date(m),
          g = this._prevS,
          y = e.dateFormat,
          b = e.monthNames,
          x = e.yearSuffix,
          C = Y(e.labelList) ? +e.labelList + 1 : 'all' === e.labelList ? -1 : 0,
          w = e.labelList !== g.labelList,
          T = e.navigationService,
          k = T.pageIndex,
          S = T.firstDay,
          D = T.lastDay,
          I = T.viewStart,
          M = T.viewEnd;
        if (((this._minDate = T.minDate), (this._maxDate = T.maxDate), W(e.min)))
          (this._minIndex = -1 / 0),
            (this._minYears = -1 / 0),
            (this._minYearsIndex = -1 / 0),
            (this._minYear = -1 / 0),
            (this._minYearIndex = -1 / 0);
        else {
          var E = Bt(this._minDate);
          (this._minDate = Bt(E)),
            (this._minYear = n(a(E), i(E), 1)),
            (this._minYears = a(E)),
            (this._minIndex = gn(E, e)),
            (this._minYearIndex = bn(E, e)),
            (this._minYearsIndex = yn(E, e));
        }
        if (W(e.max))
          (this._maxIndex = 1 / 0),
            (this._maxYears = 1 / 0),
            (this._maxYearsIndex = 1 / 0),
            (this._maxYear = 1 / 0),
            (this._maxYearIndex = 1 / 0);
        else {
          var O = this._maxDate;
          (this._maxYear = n(a(O), i(O) + 1, 1)),
            (this._maxYears = a(O)),
            (this._maxIndex = gn(O, e)),
            (this._maxYearIndex = bn(O, e)),
            (this._maxYearsIndex = yn(O, e));
        }
        var V =
          r !== g.calendarType ||
          o !== g.eventRange ||
          c !== g.firstDay ||
          e.eventRangeSize !== g.eventRangeSize ||
          e.refDate !== g.refDate ||
          e.showCalendar !== g.showCalendar ||
          e.weeks !== g.weeks;
        if (
          (V && this._pageIndex !== N && (this._prevAnim = !0),
          f && (this._activeMonth = m),
          (this._view = t.view || e.selectView),
          (this._yearsIndex = yn(new Date(this._activeMonth), e)),
          (this._yearIndex = bn(new Date(this._activeMonth), e)),
          this._view === _n)
        )
          this._viewTitle = this._getPageYear(this._yearIndex) + '';
        else if (this._view === pn) {
          var P = this._getPageYears(this._yearsIndex);
          this._viewTitle = P + ' - ' + (P + 11);
        }
        var L = _ ? 1 : Cn(e.pages, t.pageSize),
          H = 'vertical' === e.calendarScroll && 'auto' !== e.pages && (e.pages === N || 1 === e.pages),
          R = e.showOuterDays !== N ? e.showOuterDays : !H && L < 2 && (h || !d || d < 2),
          z = y.search(/m/i),
          A = y.search(/y/i);
        if (_ && ((this._monthsMulti = []), k !== N)) {
          for (var F = $((0.96 * t.pageSize) / 325.6) || 1; d % F; ) F--;
          for (var U = 0; U < d / F; ++U) {
            for (var j = [], B = 0; B < F; ++B) j.push(+n(a(S), i(S) + U * F + B, 1));
            this._monthsMulti.push(j);
          }
        }
        (r !== g.calendarType ||
          e.theme !== g.theme ||
          e.calendarScroll !== g.calendarScroll ||
          e.hasContent !== g.hasContent ||
          e.showCalendar !== g.showCalendar ||
          e.showSchedule !== g.showSchedule ||
          e.showWeekNumbers !== g.showWeekNumbers ||
          e.weeks !== g.weeks ||
          w) &&
          (this._shouldCheckSize = !0),
          (g.width === e.width && g.height === e.height) || (this._dim = { height: X(e.height), width: X(e.width) }),
          (this._cssClass =
            'mbsc-calendar mbsc-font' +
            this._theme +
            this._rtl +
            (t.ready ? '' : ' mbsc-hidden') +
            (_ ? ' mbsc-calendar-grid-view' : ' mbsc-calendar-height-' + t.height + ' mbsc-calendar-width-' + t.width) +
            ' ' +
            e.cssClass),
          (this._dayNames = 'sm' === t.width || _ ? e.dayNamesMin : e.dayNamesShort),
          (this._isSwipeChange = !1),
          (this._yearFirst = A < z),
          (this._pageNr = L),
          (this._variableRow = C);
        var q = e.pageLoad !== g.pageLoad,
          K = +I != +this._viewStart || +M != +this._viewEnd;
        if (
          (this._pageIndex !== N && K && (this._isIndexChange = !this._isSwipeChange && !V),
          k !== N && (this._pageIndex = k),
          k !== N &&
            (e.marked !== g.marked ||
              e.colors !== g.colors ||
              e.labels !== g.labels ||
              e.invalid !== g.invalid ||
              e.valid !== g.valid ||
              t.maxLabels !== this._maxLabels ||
              K ||
              w ||
              q))
        ) {
          (this._maxLabels = t.maxLabels), (this._viewStart = I), (this._viewEnd = M);
          var G = e.labelsMap || Pa(e.labels, I, M, e),
            J =
              G &&
              (function (e, t, n, a, i, s, r, o, l, c, h, u, d, _) {
                t = t || {};
                for (var p = {}, m = new Map(), f = {}, v = n, g = 0, y = i, b = a; v < a; ) {
                  var x = jt(v),
                    C = v.getDay(),
                    w = e.getDay(v),
                    T = h && e.getDate(e.getYear(v), e.getMonth(v) + 1, 0),
                    k = (l && (C === o || (1 === w && h))) || +v == +n,
                    S = Kt(v, e),
                    D = wn(t[x] || [], c),
                    I = void 0,
                    M = void 0,
                    E = void 0,
                    O = 0,
                    V = 0,
                    P = 0;
                  k && ((f = {}), (b = l ? cn(S, s) : a)),
                    r &&
                      (D = D.filter(function (e) {
                        return e.allDay;
                      })),
                    -1 === i && (y = D.length + 1);
                  var L = D.length,
                    H = [];
                  for (u && (H.push({ id: 'count_' + +v, count: L, placeholder: 0 === L }), (O = y)); L && O < y; ) {
                    I = null;
                    for (var R = 0; R < D.length; R++) f[O] === D[R] && ((I = D[R]), (E = R));
                    if (((M = (I && m.get(I)) || []), O === y - 1 && (V < L - 1 || (P === L && !I)) && -1 !== i)) {
                      var z = L - V,
                        Y = d || '',
                        A = ((z > 1 && _) || Y).replace(/{count}/, z);
                      if ((z && H.push({ id: 'more_' + ++g, more: A, label: A }), I)) {
                        f[O] = null;
                        for (var F = 0, W = M; F < W.length; F++) {
                          var U = W[F],
                            j = Y.replace(/{count}/, '1');
                          p[jt(U)].data[O] = { id: 'more_' + ++g, more: j, label: j };
                        }
                      }
                      V++, O++;
                    } else if (I)
                      E === P && P++,
                        Gt(v, nn(I.end, I.allDay ? N : e)) && (f[O] = null),
                        H.push({ id: I.occurrenceId || I.id, event: I }),
                        O++,
                        V++,
                        M.push(v);
                    else if (P < L) {
                      var B = D[P],
                        q = B.allDay,
                        X = B.start && nn(B.start, q ? N : e);
                      if (!X || Gt(v, X) || k) {
                        var K = Ut(e, q, X, B.end && nn(B.end, q ? N : e), !0),
                          G = K && !Gt(X, K),
                          J = T && T < K ? T : K,
                          Z = X ? ', ' + e.fromText + ': ' + rn('DDDD, MMMM D, YYYY', X, e) : '',
                          $ = K ? ', ' + e.toText + ': ' + rn('DDDD, MMMM D, YYYY', K, e) : '';
                        B.id === N && (B.id = 'mbsc_' + un++),
                          G && (f[O] = B),
                          m.set(B, [v]),
                          H.push({
                            event: B,
                            id: B.occurrenceId || B.id,
                            label: (B.title || B.text || '') + Z + $,
                            lastDay: T ? cn(T, 1) : N,
                            multiDay: G,
                            showText: !0,
                            width: G ? 100 * Math.min(Xt(v, J) + 1, Xt(v, b)) : 100,
                          }),
                          O++,
                          V++;
                      }
                      P++;
                    } else V < L && H.push({ id: 'ph_' + ++g, placeholder: !0 }), O++;
                  }
                  (p[x] = { data: H, events: D }), (v = Bt(cn(v, 1)));
                }
                return p;
              })(
                e,
                G,
                I,
                M,
                this._variableRow || this._maxLabels || 1,
                7,
                !1,
                c,
                !0,
                e.eventOrder,
                !R,
                e.showLabelCount,
                e.moreEventsText,
                e.moreEventsPluralText,
              );
          J && !this._labels && (this._shouldCheckSize = !0),
            ((J && t.maxLabels) || !J) && (this._shouldPageLoad = !this._isIndexChange || this._prevAnim || !s || q),
            (this._labelsLayout = J),
            (this._labels = G),
            (this._marked = G ? N : e.marksMap || Pa(e.marked, I, M, e)),
            (this._colors = Pa(e.colors, I, M, e)),
            (this._valid = Pa(e.valid, I, M, e, !0)),
            (this._invalid = Pa(e.invalid, I, M, e, !0));
        }
        if (K || f || o !== g.eventRange || l !== g.eventRangeSize || e.monthNames !== g.monthNames) {
          this._title = [];
          var Z = cn(D, -1),
            Q = k === N ? v : S;
          if (h) {
            Q = v;
            for (var ee = 0, te = Object.keys(e.selectedDates); ee < te.length; ee++) {
              var ne = te[ee];
              if (+ne >= +S && +ne < +D) {
                Q = new Date(+ne);
                break;
              }
            }
          }
          if (this._pageNr > 1)
            for (U = 0; U < L; U++) {
              var ae = n(a(S), i(S) + U, 1),
                ie = a(ae) + x,
                se = b[i(ae)];
              this._title.push({ yearTitle: ie, monthTitle: se });
            }
          else {
            var re = { yearTitle: a(Q) + x, monthTitle: b[i(Q)] },
              oe = e.showSchedule && 1 === l ? o : s ? r : o,
              le = o && !s && (!e.showSchedule || l > 1);
            switch (oe) {
              case 'year':
                (re.title = a(S) + x), l > 1 && (re.title += ' - ' + (a(Z) + x));
                break;
              case 'month':
                if (l > 1 && !s) {
                  var ce = b[i(S)],
                    he = a(S) + x,
                    ue = this._yearFirst ? he + ' ' + ce : ce + ' ' + he,
                    de = b[i(Z)],
                    _e = a(Z) + x,
                    pe = this._yearFirst ? _e + ' ' + de : de + ' ' + _e;
                  re.title = ue + ' - ' + pe;
                } else _ && (re.title = a(S) + x);
                break;
              case 'day':
              case 'week':
                if (le) {
                  var me = y.search(/d/i) < z ? 'D MMM, YYYY' : 'MMM D, YYYY';
                  (re.title = rn(me, S, e)), ('week' === oe || l > 1) && (re.title += ' - ' + rn(me, Z, e));
                }
            }
            this._title.push(re);
          }
        }
        (this._active = m),
          (this._hasPicker = e.hasPicker || _ || !u || !s || ('md' === t.width && !1 !== e.hasPicker)),
          (this._axis = H ? 'Y' : 'X'),
          (this._rtlNr = !H && e.rtl ? -1 : 1),
          (this._weeks = p),
          (this._nextIcon = H ? e.nextIconV : e.rtl ? e.prevIconH : e.nextIconH),
          (this._prevIcon = H ? e.prevIconV : e.rtl ? e.nextIconH : e.prevIconH),
          (this._mousewheel = e.mousewheel === N ? H : e.mousewheel),
          (this._isGrid = _),
          (this._isVertical = H),
          (this._showOuter = R),
          (this._showDaysTop = H || (!!C && 1 === d));
      }),
      (t.prototype._mounted = function () {
        (this._observer = ua(this._el, this._onResize, this._zone)),
          (this._doc = Te(this._el)),
          Ce(this._doc, Pn, this._onDocClick);
      }),
      (t.prototype._updated = function () {
        var e = this;
        if (
          (this._shouldCheckSize
            ? (setTimeout(function () {
                e._onResize();
              }),
              (this._shouldCheckSize = !1))
            : this._shouldPageLoad && (this._pageLoaded(), (this._shouldPageLoad = !1)),
          this._shouldFocus &&
            setTimeout(function () {
              e._focusActive(), (e._shouldFocus = !1);
            }),
          this.s.instanceService && this.s.instanceService.onComponentChange.next({}),
          (this._pageChange = !1),
          this._variableRow && this.s.showCalendar)
        ) {
          var t = this._body.querySelector('.mbsc-calendar-body-inner'),
            n = t.scrollHeight > t.clientHeight;
          n !== this.state.hasScrollY && ((this._shouldCheckSize = !0), this.setState({ hasScrollY: n }));
        }
      }),
      (t.prototype._destroy = function () {
        this._observer && this._observer.detach(), we(this._doc, Pn, this._onDocClick), clearTimeout(this._hoverTimer);
      }),
      (t.prototype._getActiveCell = function () {
        var e = this._view,
          t = e === dn ? this._body : this._pickerCont,
          n = e === pn ? 'year' : e === _n ? 'month' : 'cell';
        return t && t.querySelector('.mbsc-calendar-' + n + '[tabindex="0"]');
      }),
      (t.prototype._focusActive = function () {
        var e = this._getActiveCell();
        e && e.focus();
      }),
      (t.prototype._pageLoaded = function () {
        var e = this.s.navigationService;
        this._hook('onPageLoaded', {
          activeElm: this._getActiveCell(),
          firstDay: e.firstPageDay,
          lastDay: e.lastPageDay,
          month: 'month' === this.s.calendarType ? e.firstDay : N,
          viewEnd: e.viewEnd,
          viewStart: e.viewStart,
        });
      }),
      (t.prototype._activeChange = function (e) {
        var t = this._pageIndex + e;
        this._minIndex <= t &&
          this._maxIndex >= t &&
          ((this._prevAnim = !1),
          (this._pageChange = !0),
          this._hook('onActiveChange', { date: this._getPageDay(t), dir: e, pageChange: !0 }));
      }),
      (t.prototype._activeYearsChange = function (e) {
        var t = this._yearsIndex + e;
        if (this._minYearsIndex <= t && this._maxYearsIndex >= t) {
          var n = this._getPageYears(t);
          (this._prevAnim = !1), (this._activeMonth = +this.s.getDate(n, 0, 1)), this.forceUpdate();
        }
      }),
      (t.prototype._activeYearChange = function (e) {
        var t = this._yearIndex + e;
        if (this._minYearIndex <= t && this._maxYearIndex >= t) {
          var n = this._getPageYear(t);
          (this._prevAnim = !1), (this._activeMonth = +this.s.getDate(n, 0, 1)), this.forceUpdate();
        }
      }),
      (t.prototype._prevDocClick = function () {
        var e = this;
        (this._prevClick = !0),
          setTimeout(function () {
            e._prevClick = !1;
          });
      }),
      t
    );
  })(En);
  function yi(e) {
    return (
      (this.getChildContext = function () {
        return e.context;
      }),
      e.children
    );
  }
  function bi(e) {
    var t = this,
      n = e._container;
    (t.componentWillUnmount = function () {
      pt(null, t._temp), (t._temp = null), (t._container = null);
    }),
      t._container && t._container !== n && t.componentWillUnmount(),
      e._vnode
        ? (t._temp ||
            ((t._container = n),
            (t._temp = {
              nodeType: 1,
              parentNode: n,
              childNodes: [],
              appendChild: function (e) {
                this.childNodes.push(e), t._container.appendChild(e);
              },
              insertBefore: function (e, n) {
                this.childNodes.push(e), t._container.appendChild(e);
              },
              removeChild: function (e) {
                this.childNodes.splice(this.childNodes.indexOf(e) >>> 1, 1), t._container.removeChild(e);
              },
            })),
          pt(je(yi, { context: t.context }, e._vnode), t._temp))
        : t._temp && t.componentWillUnmount();
  }
  function xi(e, t) {
    return je(bi, { _vnode: e, _container: t });
  }
  var Ci = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype.render = function () {
          var e = this.props.context;
          return e ? xi(this.props.children, e) : null;
        }),
        t
      );
    })(Xe),
    wi = Ci;
  var Ti = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype._template = function (e, t) {
          return (function (e, t, n, i) {
            var s,
              r,
              o = n._hb,
              l = n._rtl,
              c = n._theme,
              h = e.display,
              u = (((s = {}).onKeyDown = n._onKeyDown), s),
              d = (((r = {}).onAnimationEnd = n._onAnimationEnd), r);
            return n._isModal
              ? n._isVisible
                ? je(
                    wi,
                    { context: n._ctx },
                    je(
                      'div',
                      a(
                        {
                          className:
                            'mbsc-font mbsc-popup-wrapper mbsc-popup-wrapper-' +
                            h +
                            c +
                            l +
                            ' ' +
                            n._className +
                            (e.fullScreen ? ' mbsc-popup-wrapper-' + h + '-full' : '') +
                            (n._touchUi ? '' : ' mbsc-popup-pointer') +
                            (n._round ? ' mbsc-popup-round' : '') +
                            (n._hasContext ? ' mbsc-popup-wrapper-ctx' : '') +
                            (t.isReady ? '' : ' mbsc-popup-hidden'),
                          ref: n._setWrapper,
                        },
                        u,
                      ),
                      e.showOverlay &&
                        je('div', {
                          className:
                            'mbsc-popup-overlay mbsc-popup-overlay-' +
                            h +
                            c +
                            (n._isClosing ? ' mbsc-popup-overlay-out' : '') +
                            (n._isOpening && t.isReady ? ' mbsc-popup-overlay-in' : ''),
                          onClick: n._onOverlayClick,
                        }),
                      je('div', {
                        className: 'mbsc-popup-limits mbsc-popup-limits-' + h,
                        ref: n._setLimitator,
                        style: n._limits,
                      }),
                      je(
                        'div',
                        a(
                          {
                            className:
                              'mbsc-popup ' +
                              c +
                              o +
                              ' mbsc-popup-' +
                              h +
                              (e.fullScreen ? '-full' : '') +
                              (t.bubblePos && t.showArrow && 'anchored' === h
                                ? ' mbsc-popup-anchored-' + t.bubblePos
                                : '') +
                              (n._isClosing ? ' mbsc-popup-' + n._animation + '-out' : '') +
                              (n._isOpening && t.isReady ? ' mbsc-popup-' + n._animation + '-in' : ''),
                            role: 'dialog',
                            'aria-modal': 'true',
                            ref: n._setPopup,
                            style: n._style,
                            onClick: n._onPopupClick,
                          },
                          d,
                        ),
                        'anchored' === h &&
                          t.showArrow &&
                          je(
                            'div',
                            { className: 'mbsc-popup-arrow-wrapper mbsc-popup-arrow-wrapper-' + t.bubblePos + c },
                            je('div', {
                              className: 'mbsc-popup-arrow mbsc-popup-arrow-' + t.bubblePos + c,
                              style: t.arrowPos,
                            }),
                          ),
                        je('div', { className: 'mbsc-popup-focus', tabIndex: -1, ref: n._setActive }),
                        je(
                          'div',
                          {
                            className:
                              'mbsc-popup-body mbsc-popup-body-' +
                              h +
                              c +
                              o +
                              (e.fullScreen ? ' mbsc-popup-body-' + h + '-full' : '') +
                              (n._round ? ' mbsc-popup-body-round' : ''),
                          },
                          n._headerText &&
                            je('div', {
                              className:
                                'mbsc-popup-header mbsc-popup-header-' +
                                h +
                                c +
                                o +
                                (n._buttons ? '' : ' mbsc-popup-header-no-buttons'),
                              dangerouslySetInnerHTML: n._headerText,
                              'v-html': N,
                            }),
                          je(
                            'div',
                            {
                              className: 'mbsc-popup-content' + (e.contentPadding ? ' mbsc-popup-padding' : ''),
                              ref: n._setContent,
                            },
                            i,
                          ),
                          n._buttons &&
                            je(
                              'div',
                              {
                                className:
                                  'mbsc-popup-buttons mbsc-popup-buttons-' +
                                  h +
                                  c +
                                  l +
                                  o +
                                  (n._flexButtons ? ' mbsc-popup-buttons-flex' : '') +
                                  (e.fullScreen ? ' mbsc-popup-buttons-' + h + '-full' : ''),
                              },
                              n._buttons.map(function (t, a) {
                                return je(
                                  oi,
                                  {
                                    color: t.color,
                                    className:
                                      'mbsc-popup-button mbsc-popup-button-' +
                                      h +
                                      l +
                                      o +
                                      (n._flexButtons ? ' mbsc-popup-button-flex' : '') +
                                      ' ' +
                                      (t.cssClass || ''),
                                    icon: t.icon,
                                    disabled: t.disabled,
                                    key: a,
                                    theme: e.theme,
                                    themeVariant: e.themeVariant,
                                    variant: t.variant || e.buttonVariant,
                                    onClick: t.handler,
                                  },
                                  t.text,
                                );
                              }),
                            ),
                        ),
                      ),
                    ),
                  )
                : null
              : je(qe, null, i);
          })(e, t, this, e.children);
        }),
        t
      );
    })(ya),
    ki = {},
    Si = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t._onClick = function (e) {
            if (t._isDrag) e.stopPropagation();
            else {
              t._triggerEvent('onClick', e);
              var n = t.s,
                a = ki[n.id];
              a && n.selected && a.next({ hasFocus: !1 });
            }
          }),
          (t._onRightClick = function (e) {
            t._triggerEvent('onRightClick', e);
          }),
          (t._onDocTouch = function (e) {
            we(t._doc, Gn, t._onDocTouch),
              we(t._doc, Fn, t._onDocTouch),
              (t._isDrag = !1),
              t._hook('onDragModeOff', { data: t.s.event, domEvent: e });
          }),
          (t._updateState = function (e) {
            t.s.showText && t.setState(e);
          }),
          (t._triggerEvent = function (e, n) {
            t._hook(e, { domEvent: n, label: t.s.event, target: t._el });
          }),
          t
        );
      }
      return (
        n(t, e),
        (t.prototype._mounted = function () {
          var e,
            t = this,
            n = this.s,
            i = n.id,
            s = n.isPicker,
            r = ki[i];
          r || ((r = new o()), (ki[i] = r)),
            (this._unsubscribe = r.subscribe(this._updateState)),
            (this._doc = Te(this._el)),
            (this._unlisten = si(this._el, {
              keepFocus: !0,
              onBlur: function () {
                s || r.next({ hasFocus: !1 });
              },
              onDoubleClick: function (e) {
                e.domEvent.stopPropagation(),
                  t._hook('onDoubleClick', { domEvent: e.domEvent, label: t.s.event, target: t._el });
              },
              onEnd: function (n) {
                if (t._isDrag) {
                  var i = t.s,
                    s = a({}, n);
                  s.domEvent.preventDefault(),
                    (s.data = i.event),
                    i.resize && e ? ((s.resize = !0), (s.direction = e)) : i.drag && (s.drag = !0),
                    t._hook('onDragEnd', s),
                    i.isUpdate || (t._isDrag = !1);
                }
                clearTimeout(t._touchTimer), (e = N);
              },
              onFocus: function () {
                s || r.next({ hasFocus: !0 });
              },
              onHoverIn: function (e) {
                t._isDrag || s || (r.next({ hasHover: !0 }), t._triggerEvent('onHoverIn', e));
              },
              onHoverOut: function (e) {
                r.next({ hasHover: !1 }), t._triggerEvent('onHoverOut', e);
              },
              onKeyDown: function (e) {
                var n = t.s.event;
                switch (e.keyCode) {
                  case ea:
                  case ta:
                    t._el.click(), e.preventDefault();
                    break;
                  case 8:
                  case 46:
                    n && !1 !== n.editable && t._hook('onDelete', { domEvent: e, event: n, source: 'calendar' });
                }
              },
              onMove: function (n) {
                var i = t.s,
                  s = a({}, n);
                if (((s.data = i.event), e)) (s.resize = !0), (s.direction = e);
                else {
                  if (!i.drag) return;
                  s.drag = !0;
                }
                i.event &&
                  !1 !== i.event.editable &&
                  (t._isDrag
                    ? (s.domEvent.preventDefault(), t._hook('onDragMove', s))
                    : (Math.abs(s.deltaX) > 7 || Math.abs(s.deltaY) > 7) &&
                      (clearTimeout(t._touchTimer), s.isTouch || ((t._isDrag = !0), t._hook('onDragStart', s))));
              },
              onStart: function (n) {
                var i = t.s,
                  s = a({}, n),
                  r = s.domEvent.target;
                if (((s.data = i.event), i.resize && r.classList.contains('mbsc-calendar-label-resize')))
                  (e = r.classList.contains('mbsc-calendar-label-resize-start') ? 'start' : 'end'),
                    (s.resize = !0),
                    (s.direction = e);
                else {
                  if (!i.drag) return;
                  s.drag = !0;
                }
                i.event &&
                  !1 !== i.event.editable &&
                  ((!t._isDrag && s.isTouch) || s.domEvent.stopPropagation(),
                  t._isDrag
                    ? t._hook('onDragStart', s)
                    : s.isTouch &&
                      (t._touchTimer = setTimeout(function () {
                        t._hook('onDragModeOn', s), t._hook('onDragStart', s), (t._isDrag = !0);
                      }, 350)));
              },
            })),
            this._isDrag && (Ce(this._doc, Gn, this._onDocTouch), Ce(this._doc, Fn, this._onDocTouch));
        }),
        (t.prototype._destroy = function () {
          if (this._unsubscribe) {
            var e = this.s.id,
              t = ki[e];
            t && (t.unsubscribe(this._unsubscribe), t.nr || delete ki[e]);
          }
          this._unlisten && this._unlisten(), we(this._doc, Gn, this._onDocTouch), we(this._doc, Fn, this._onDocTouch);
        }),
        (t.prototype._render = function (e, t) {
          var n,
            a,
            i,
            s,
            r,
            o,
            l = e.event,
            c = new Date(e.date),
            h = e.render || e.renderContent,
            u = !1;
          if (
            ((this._isDrag = this._isDrag || e.isUpdate),
            (this._content = N),
            (this._title =
              e.more || e.count || !e.showEventTooltip
                ? N
                : (function (e) {
                    if (ie && e) {
                      var t = ie.createElement('div');
                      return (t.innerHTML = e), t.textContent.trim();
                    }
                    return e || '';
                  })(l.tooltip || l.title || l.text)),
            (this._tabIndex = e.isActiveMonth && e.showText && !e.count && !e.isPicker ? 0 : -1),
            l)
          ) {
            var d = l.allDay,
              _ = d ? N : e;
            (n = l.start ? nn(l.start, _) : null), (a = l.end ? nn(l.end, _) : null);
            var p = n && a && Ut(e, d, n, a, !0),
              m = cn(Kt(c, e), 7),
              f = e.lastDay && e.lastDay < m ? e.lastDay : m;
            (i = !(u = n && p && !Gt(n, p)) || (n && Gt(n, c))),
              (s = !u || (p && Gt(p, c))),
              (r = !u || (e.showText ? p < f : s)),
              (this._hasResizeStart = e.resize && i),
              (this._hasResizeEnd = e.resize && r);
            var v = l.color;
            if (!v && l.resource && e.resourcesMap) {
              var g = e.resourcesMap[z(l.resource) ? l.resource[0] : l.resource];
              v = g && g.color;
            }
            e.showText && (this._textColor = v ? Ee(v) : N),
              (this._color = e.render || e.template ? N : l.textColor && !v ? 'transparent' : v);
          }
          if (l && e.showText && (h || e.contentTemplate || e.template)) {
            var y = l.allDay || !n || (u && !i && !s);
            if (
              ((this._data = {
                end: !y && s && a ? rn(e.timeFormat, a, e) : '',
                id: l.id,
                isMultiDay: u,
                original: l,
                start: !y && i && n ? rn(e.timeFormat, n, e) : '',
                title: this._title,
              }),
              h)
            ) {
              var b = h(this._data);
              F(b) ? (o = b) : (this._content = b);
            }
          } else o = e.more || e.count || (e.showText && (l.title || l.text)) || '';
          o !== this._text &&
            ((this._text = o),
            (this._html = o ? this._safeHtml(o) : N),
            (this._shouldEnhance = o && l && e.showText && !!h)),
            (this._cssClass =
              'mbsc-calendar-text' +
              this._theme +
              this._rtl +
              ((t.hasFocus && !e.inactive && !e.selected) || (e.selected && e.showText)
                ? ' mbsc-calendar-label-active '
                : '') +
              (!t.hasHover || e.inactive || this._isDrag ? '' : ' mbsc-calendar-label-hover') +
              (e.more
                ? ' mbsc-calendar-text-more'
                : e.render || e.template
                ? ' mbsc-calendar-custom-label'
                : ' mbsc-calendar-label') +
              (e.inactive ? ' mbsc-calendar-label-inactive' : '') +
              (e.isUpdate ? ' mbsc-calendar-label-dragging' : '') +
              (e.hidden ? ' mbsc-calendar-label-hidden' : '') +
              (i ? ' mbsc-calendar-label-start' : '') +
              (r ? ' mbsc-calendar-label-end' : '') +
              (l && !1 === l.editable ? ' mbsc-readonly-event' : '') +
              (l && l.cssClass ? ' ' + l.cssClass : ''));
        }),
        t
      );
    })(En);
  var Di = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype._template = function (e) {
          return (function (e, t) {
            var n,
              i = e.event && !1 !== e.event.editable,
              s = (((n = {}).onContextMenu = t._onRightClick), n);
            return je(
              'div',
              a(
                {
                  'aria-hidden': e.showText ? N : 'true',
                  className: t._cssClass,
                  'data-id': e.showText && e.event ? e.event.id : null,
                  onClick: t._onClick,
                  ref: t._setEl,
                  role: e.showText ? 'button' : N,
                  style: { color: t._color },
                  tabIndex: t._tabIndex,
                  title: t._title,
                },
                s,
              ),
              t._hasResizeStart &&
                i &&
                je('div', {
                  className:
                    'mbsc-calendar-label-resize mbsc-calendar-label-resize-start' +
                    t._rtl +
                    (e.isUpdate ? ' mbsc-calendar-label-resize-start-touch' : ''),
                }),
              t._hasResizeEnd &&
                i &&
                je('div', {
                  className:
                    'mbsc-calendar-label-resize mbsc-calendar-label-resize-end' +
                    t._rtl +
                    (e.isUpdate ? ' mbsc-calendar-label-resize-end-touch' : ''),
                }),
              e.showText &&
                !e.more &&
                !e.render &&
                je('div', { className: 'mbsc-calendar-label-background' + t._theme }),
              e.showText && !e.more && e.render
                ? t._html
                  ? je('div', { dangerouslySetInnerHTML: t._html, 'v-html': N })
                  : t._content
                : je(
                    'div',
                    { className: 'mbsc-calendar-label-inner' + t._theme, style: { color: t._textColor } },
                    je(
                      'div',
                      {
                        'aria-hidden': 'true',
                        className: 'mbsc-calendar-label-text' + t._theme,
                        dangerouslySetInnerHTML: t._html,
                        'v-html': N,
                        style: { color: e.event && e.event.textColor },
                      },
                      t._content,
                    ),
                    e.label && je('div', { className: 'mbsc-hidden-content' }, e.label),
                  ),
            );
          })(e, this);
        }),
        t
      );
    })(Si),
    Ii = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t._onClick = function (e) {
            t._cellClick('onDayClick', e);
          }),
          (t._onRightClick = function (e) {
            t._cellClick('onDayRightClick', e);
          }),
          (t._onLabelClick = function (e) {
            t._labelClick('onLabelClick', e);
          }),
          (t._onLabelDoubleClick = function (e) {
            t._labelClick('onLabelDoubleClick', e);
          }),
          (t._onLabelRightClick = function (e) {
            t._labelClick('onLabelRightClick', e);
          }),
          (t._onLabelHoverIn = function (e) {
            t._labelClick('onLabelHoverIn', e);
          }),
          (t._onLabelHoverOut = function (e) {
            t._labelClick('onLabelHoverOut', e);
          }),
          t
        );
      }
      return (
        n(t, e),
        (t.prototype._mounted = function () {
          var e,
            t,
            n,
            a = this;
          this._unlisten = si(this._el, {
            click: !0,
            onBlur: function () {
              a.setState({ hasFocus: !1 });
            },
            onDoubleClick: function (e) {
              var t = a.s;
              t.clickToCreate &&
                'single' !== t.clickToCreate &&
                t.labels &&
                !t.disabled &&
                t.display &&
                (a._hook('onLabelUpdateStart', e), a._hook('onLabelUpdateEnd', e)),
                a._cellClick('onDayDoubleClick', e.domEvent);
            },
            onEnd: function (i) {
              e && (i.domEvent.preventDefault(), a._hook('onLabelUpdateEnd', i), (e = !1)),
                clearTimeout(n),
                (e = !1),
                (t = !1);
            },
            onFocus: function () {
              a.setState({ hasFocus: !0 });
            },
            onHoverIn: function (e) {
              var t = a.s;
              t.disabled || a.setState({ hasHover: !0 }),
                a._hook('onHoverIn', {
                  date: new Date(t.date),
                  domEvent: e,
                  hidden: !t.display,
                  outer: t.outer,
                  target: a._el,
                });
            },
            onHoverOut: function (e) {
              var t = a.s;
              a.setState({ hasHover: !1 }),
                a._hook('onHoverOut', {
                  date: new Date(t.date),
                  domEvent: e,
                  hidden: !t.display,
                  outer: t.outer,
                  target: a._el,
                });
            },
            onKeyDown: function (e) {
              switch (e.keyCode) {
                case ea:
                case ta:
                  e.preventDefault(), a._onClick(e);
              }
            },
            onMove: function (i) {
              e && a.s.dragToCreate
                ? (i.domEvent.preventDefault(), a._hook('onLabelUpdateMove', i))
                : t && a.s.dragToCreate && (Math.abs(i.deltaX) > 7 || Math.abs(i.deltaY) > 7)
                ? ((e = !i.isTouch), a._hook('onLabelUpdateStart', i))
                : clearTimeout(n);
            },
            onStart: function (i) {
              var s = a.s;
              ((i.create = !0), s.disabled || (!s.dragToCreate && !s.clickToCreate) || !s.labels || e) ||
                Le(i.domEvent.target, '.mbsc-calendar-text', a._el) ||
                (i.isTouch && s.dragToCreate
                  ? (n = setTimeout(function () {
                      a._hook('onLabelUpdateStart', i), a._hook('onLabelUpdateModeOn', i), (e = !0);
                    }, 350))
                  : 'single' === s.clickToCreate
                  ? (a._hook('onLabelUpdateStart', i), (e = !0))
                  : (t = !i.isTouch));
            },
          });
        }),
        (t.prototype._render = function (e, t) {
          var n = tn(e),
            a = e.date,
            i = e.colors,
            s = e.display,
            r = e.dragData,
            o = e.hoverEnd,
            l = e.hoverStart,
            c = e.labels,
            h = e.rangeEnd,
            u = e.rangeStart,
            d = new Date(a),
            _ = jt(d),
            p = Gt(n, d),
            m = c && c.events,
            f = i && i[0],
            v = f && f.background,
            g = f && f.highlight,
            y = '',
            b = '';
          (this._draggedLabel = r && r.draggedDates && r.draggedDates[_]),
            (this._draggedLabelOrig = r && r.originDates && r.originDates[_]),
            (this._todayClass = p ? ' mbsc-calendar-today' : ''),
            (this._cellStyles = v && s ? { backgroundColor: v, color: Ee(v) } : N),
            (this._circleStyles = g ? { backgroundColor: g, color: Ee(f.highlight) } : N),
            (this._ariaLabel =
              'day' === e.type
                ? (p ? e.todayText + ', ' : '') + e.day + ', ' + e.month + ' ' + e.text + ', ' + e.year
                : 'month' === e.type
                ? e.month
                : ''),
            s &&
              (((u && a >= u && a <= (h || u)) || (h && a <= h && a >= (u || h))) &&
                (b =
                  ' mbsc-range-day' +
                  (a === (u || h) ? ' mbsc-range-day-start' : '') +
                  (a === (h || u) ? ' mbsc-range-day-end' : '')),
              l &&
                o &&
                a >= l &&
                a <= o &&
                (b +=
                  ' mbsc-range-hover' +
                  (a === l ? ' mbsc-range-hover-start mbsc-hover' : '') +
                  (a === o ? ' mbsc-range-hover-end mbsc-hover' : ''))),
            e.marks &&
              e.marks.forEach(function (e) {
                y += e.cellCssClass ? ' ' + e.cellCssClass : '';
              }),
            i &&
              i.forEach(function (e) {
                y += e.cellCssClass ? ' ' + e.cellCssClass : '';
              }),
            m &&
              m.forEach(function (e) {
                y += e.cellCssClass ? ' ' + e.cellCssClass : '';
              }),
            (this._cssClass =
              'mbsc-calendar-cell mbsc-flex-1-0-0 mbsc-calendar-' +
              e.type +
              this._theme +
              this._rtl +
              this._hb +
              y +
              (c ? ' mbsc-calendar-day-labels' : '') +
              (i ? ' mbsc-calendar-day-colors' : '') +
              (e.outer ? ' mbsc-calendar-day-outer' : '') +
              (e.hasMarks ? ' mbsc-calendar-day-marked' : '') +
              (e.disabled ? ' mbsc-disabled' : '') +
              (s ? '' : ' mbsc-calendar-day-empty') +
              (e.selected ? ' mbsc-selected' : '') +
              (t.hasFocus ? ' mbsc-focus' : '') +
              (!t.hasHover || (a !== l && a !== o && (l || o)) ? '' : ' mbsc-hover') +
              (this._draggedLabel ? ' mbsc-calendar-day-highlight' : '') +
              b),
            (this._data = { date: d, events: e.events || [], selected: e.selected });
        }),
        (t.prototype._destroy = function () {
          this._unlisten && this._unlisten();
        }),
        (t.prototype._cellClick = function (e, t) {
          var n = this.s;
          n.display &&
            this._hook(e, {
              date: new Date(n.date),
              disabled: n.disabled,
              domEvent: t,
              outer: n.outer,
              selected: n.selected,
              source: 'calendar',
              target: this._el,
            });
        }),
        (t.prototype._labelClick = function (e, t) {
          var n = this.s;
          (t.date = new Date(n.date)), (t.labels = n.labels.events), this._hook(e, t);
        }),
        t
      );
    })(En);
  function Mi(e, t, n, a, i, s, r) {
    return je(Di, {
      key: r,
      amText: t.amText,
      count: n.count ? n.count + ' ' + (n.count > 1 ? t.eventsText : t.eventText) : N,
      date: t.date,
      dataTimezone: t.dataTimezone,
      displayTimezone: t.displayTimezone,
      drag: t.dragToMove,
      resize: t.dragToResize,
      event: n.event,
      exclusiveEndDates: t.exclusiveEndDates,
      firstDay: t.firstDay,
      hidden: i,
      id: n.id,
      inactive: !s && n.event && t.dragData && t.dragData.draggedEvent && n.event.id === t.dragData.draggedEvent.id,
      isActiveMonth: t.isActiveMonth,
      isPicker: t.isPicker,
      isUpdate: s,
      label: n.label,
      lastDay: n.lastDay,
      more: n.more,
      pmText: t.pmText,
      resourcesMap: t.resourcesMap,
      rtl: t.rtl,
      selected: n.event && t.selectedEventsMap && !(!t.selectedEventsMap[n.id] && !t.selectedEventsMap[n.event.id]),
      showEventTooltip: t.showEventTooltip,
      showText: a,
      theme: t.theme,
      timeFormat: t.timeFormat,
      timezonePlugin: t.timezonePlugin,
      render: t.renderLabel,
      renderContent: t.renderLabelContent,
      onClick: e._onLabelClick,
      onDoubleClick: e._onLabelDoubleClick,
      onRightClick: e._onLabelRightClick,
      onHoverIn: e._onLabelHoverIn,
      onHoverOut: e._onLabelHoverOut,
      onDelete: t.onLabelDelete,
      onDragStart: t.onLabelUpdateStart,
      onDragMove: t.onLabelUpdateMove,
      onDragEnd: t.onLabelUpdateEnd,
      onDragModeOn: t.onLabelUpdateModeOn,
      onDragModeOff: t.onLabelUpdateModeOff,
    });
  }
  function Ei(e, t) {
    var n,
      i,
      s = t._draggedLabel,
      r = t._draggedLabelOrig,
      o = t._theme,
      l = (((n = {}).onContextMenu = t._onRightClick), n);
    return (
      e.renderDay && (i = e.renderDay(t._data)),
      e.renderDayContent && (i = e.renderDayContent(t._data)),
      F(i) && ((i = je('div', { dangerouslySetInnerHTML: t._safeHtml(i) })), (t._shouldEnhance = !0)),
      je(
        'div',
        a(
          {
            ref: t._setEl,
            className: t._cssClass,
            onClick: t._onClick,
            style: t._cellStyles,
            tabIndex: e.disabled ? N : e.active ? 0 : -1,
          },
          l,
        ),
        je(
          'div',
          {
            className:
              'mbsc-calendar-cell-inner mbsc-calendar-' +
              e.type +
              '-inner' +
              o +
              ('day' === e.type ? '' : t._hb) +
              (e.display ? '' : ' mbsc-calendar-day-hidden'),
          },
          e.renderDay
            ? i
            : je(
                qe,
                null,
                1 === e.text &&
                  je(
                    'div',
                    { 'aria-hidden': 'true', className: 'mbsc-calendar-month-name' + o + t._rtl },
                    e.monthShort,
                  ),
                je(
                  'div',
                  {
                    'aria-label': t._ariaLabel,
                    role: 'button',
                    'aria-pressed': e.selected,
                    className: 'mbsc-calendar-cell-text mbsc-calendar-' + e.type + '-text' + o + t._todayClass,
                    style: t._circleStyles,
                  },
                  e.text,
                ),
                e.marks &&
                  je(
                    'div',
                    null,
                    je(
                      'div',
                      { className: 'mbsc-calendar-marks' + o + t._rtl },
                      e.marks.map(function (e, t) {
                        return je('div', {
                          className: 'mbsc-calendar-mark ' + (e.markCssClass || '') + o,
                          key: t,
                          style: { background: e.color },
                        });
                      }),
                    ),
                  ),
                e.renderDayContent && i,
              ),
          e.labels &&
            je(
              'div',
              null,
              r &&
                r.event &&
                je(
                  'div',
                  { className: 'mbsc-calendar-labels mbsc-calendar-labels-dragging' },
                  je(
                    'div',
                    { style: { width: r.width + '%' || '100%' } },
                    Mi(t, e, { id: 0, event: r.event }, !0, !!e.dragData.draggedDates, !0),
                  ),
                ),
              s &&
                s.event &&
                je(
                  'div',
                  { className: 'mbsc-calendar-labels mbsc-calendar-labels-dragging' },
                  je(
                    'div',
                    { className: 'mbsc-calendar-label-wrapper', style: { width: s.width + '%' || '100%' } },
                    Mi(t, e, { id: 0, event: s.event }, !0, !1, !0),
                  ),
                ),
              je(
                'div',
                { className: 'mbsc-calendar-labels' },
                e.labels.data.map(function (n) {
                  return (function (e, t, n) {
                    var a = n.id;
                    return n.placeholder
                      ? je('div', { className: 'mbsc-calendar-text mbsc-calendar-text-placeholder', key: a })
                      : n.more || n.count
                      ? Mi(e, t, n, !0, !1, !1, a)
                      : n.multiDay
                      ? [
                          je(
                            'div',
                            { className: 'mbsc-calendar-label-wrapper', style: { width: n.width + '%' }, key: a },
                            Mi(e, t, n, !0),
                          ),
                          Mi(e, t, n, !1, !1, !1, '-' + a),
                        ]
                      : Mi(e, t, n, n.showText, !1, !1, a);
                  })(t, e, n);
                }),
              ),
              je('div', { className: 'mbsc-calendar-text mbsc-calendar-text-placeholder' }),
            ),
        ),
      )
    );
  }
  var Oi = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype._template = function (e) {
          return Ei(e, this);
        }),
        t
      );
    })(Ii),
    Vi = function (e) {
      var t = e.firstDay,
        n = e.hidden,
        a = e.rtl,
        i = e.theme,
        s = e.dayNamesShort,
        r = e.showWeekNumbers,
        o = e.hasScroll;
      return je(
        'div',
        { 'aria-hidden': 'true', className: 'mbsc-calendar-week-days mbsc-flex' + (n ? ' mbsc-hidden' : '') },
        r && je('div', { className: 'mbsc-calendar-week-day mbsc-flex-none mbsc-calendar-week-nr' + i + a }),
        H.map(function (e, n) {
          return je('div', { className: 'mbsc-calendar-week-day mbsc-flex-1-0-0' + i + a, key: n }, s[(n + t) % 7]);
        }),
        o && je('div', { className: 'mbsc-schedule-fake-scroll-y' }),
      );
    },
    Ni = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype._isActive = function (e) {
          return this.s.isActive && e === this.s.activeDate;
        }),
        (t.prototype._isInvalid = function (e) {
          var t = this.s;
          return La(t, Qt(t, new Date(e)), t.invalid, t.valid, +t.min, +t.max);
        }),
        (t.prototype._isSelected = function (e) {
          var t = new Date(e),
            n = Qt(this.s, t);
          return !!this.s.selectedDates[+n];
        }),
        (t.prototype._getWeekNr = function (e, t) {
          var n = new Date(t);
          return (
            '' + e.getWeekNumber(e.getDate(n.getFullYear(), n.getMonth(), n.getDate() + ((7 - e.firstDay + 1) % 7)))
          );
        }),
        (t.prototype._render = function (e) {
          var t = e.weeks,
            n = e.firstDay,
            a = new Date(e.firstPageDay),
            i = e.getYear(a),
            s = e.getMonth(a),
            r = e.getDay(a),
            o = e.getDate(i, s, r).getDay(),
            l = n - o > 0 ? 7 : 0,
            c = [],
            h = 0;
          (this._rowHeights = []), (this._rows = []), (this._days = H);
          for (var u = 0; u < 7 * t; u++) {
            var d = e.getDate(i, s, u + n - l - o + r),
              _ = jt(d),
              p = e.getMonth(d),
              m = p !== s && 'week' !== e.calendarType,
              f = e.marked && e.marked[_],
              v = f ? (e.showSingleMark ? [{}] : f) : null,
              g = e.labels && e.labels[_],
              y = g ? g.data.length : 0,
              b = u % 7 == 0;
            if (e.variableRow) {
              if (b && m && u) break;
              y > h && (h = y),
                u % 7 == 6 && (this._rowHeights.push(h * (e.labelHeight || 20) + (e.cellTextHeight || 0) + 3), (h = 0));
            }
            b && ((c = []), this._rows.push(c)),
              c.push({
                colors: e.colors && e.colors[_],
                date: +d,
                day: e.dayNames[d.getDay()],
                display: !m || e.showOuter,
                events: e.events && e.events[_],
                labels: g,
                marks: v,
                month: e.monthNames[p],
                monthShort: e.monthNamesShort[p],
                outer: m,
                text: e.getDay(d),
                year: e.getYear(d),
              });
          }
        }),
        t
      );
    })(En);
  var Pi = (function (e) {
    function t() {
      return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
      n(t, e),
      (t.prototype._template = function (e) {
        return (function (e, t) {
          var n = e.showWeekNumbers,
            a = e.showWeekDays
              ? je(Vi, {
                  dayNamesShort: e.dayNamesShort,
                  firstDay: e.firstDay,
                  rtl: t._rtl,
                  showWeekNumbers: n,
                  theme: t._theme,
                })
              : null;
          return je(
            'div',
            {
              'aria-hidden': e.isActive ? N : 'true',
              className:
                'mbsc-calendar-table mbsc-flex-col mbsc-flex-1-1' + (e.isActive ? ' mbsc-calendar-table-active' : ''),
            },
            a,
            t._rows.map(function (a, i) {
              var s = n ? t._getWeekNr(e, a[0].date) : '';
              return je(
                'div',
                {
                  className: 'mbsc-calendar-row mbsc-flex mbsc-flex-1-0',
                  key: i,
                  style: { minHeight: t._rowHeights[i] },
                },
                n &&
                  je(
                    'div',
                    {
                      className: 'mbsc-calendar-cell mbsc-flex-none mbsc-calendar-day mbsc-calendar-week-nr' + t._theme,
                    },
                    je('div', { 'aria-hidden': 'true' }, s),
                    je('div', { className: 'mbsc-hidden-content' }, e.weekText.replace('{count}', s)),
                  ),
                a.map(function (n, a) {
                  return je(Oi, {
                    active: n.display && t._isActive(n.date),
                    amText: e.amText,
                    clickToCreate: e.clickToCreate,
                    colors: n.colors,
                    date: n.date,
                    day: n.day,
                    disabled: t._isInvalid(n.date),
                    display: n.display,
                    dataTimezone: e.dataTimezone,
                    displayTimezone: e.displayTimezone,
                    dragData: e.dragData,
                    dragToCreate: e.dragToCreate,
                    dragToResize: e.dragToResize,
                    dragToMove: e.dragToMove,
                    eventText: e.eventText,
                    events: n.events,
                    eventsText: e.eventsText,
                    exclusiveEndDates: e.exclusiveEndDates,
                    firstDay: e.firstDay,
                    hasMarks: e.hasMarks,
                    hoverEnd: e.hoverEnd,
                    hoverStart: e.hoverStart,
                    isActiveMonth: e.isActive,
                    isPicker: e.isPicker,
                    key: n.date,
                    labels: n.labels,
                    pmText: e.pmText,
                    marks: n.marks,
                    month: n.month,
                    monthShort: n.monthShort,
                    onDayClick: e.onDayClick,
                    onDayDoubleClick: e.onDayDoubleClick,
                    onDayRightClick: e.onDayRightClick,
                    onLabelClick: e.onLabelClick,
                    onLabelDoubleClick: e.onLabelDoubleClick,
                    onLabelRightClick: e.onLabelRightClick,
                    onLabelHoverIn: e.onLabelHoverIn,
                    onLabelHoverOut: e.onLabelHoverOut,
                    onLabelDelete: e.onLabelDelete,
                    onLabelUpdateStart: e.onLabelUpdateStart,
                    onLabelUpdateMove: e.onLabelUpdateMove,
                    onLabelUpdateEnd: e.onLabelUpdateEnd,
                    onLabelUpdateModeOn: e.onLabelUpdateModeOn,
                    onLabelUpdateModeOff: e.onLabelUpdateModeOff,
                    outer: n.outer,
                    renderDay: e.renderDay,
                    renderDayContent: e.renderDayContent,
                    renderLabel: e.renderLabel,
                    renderLabelContent: e.renderLabelContent,
                    rangeEnd: e.rangeEnd,
                    rangeStart: e.rangeStart,
                    resourcesMap: e.resourcesMap,
                    selectedEventsMap: e.selectedEventsMap,
                    rtl: e.rtl,
                    showEventTooltip: e.showEventTooltip,
                    selected: t._isSelected(n.date),
                    text: n.text,
                    theme: e.theme,
                    timeFormat: e.timeFormat,
                    timezonePlugin: e.timezonePlugin,
                    todayText: e.todayText,
                    type: 'day',
                    year: n.year,
                    onHoverIn: e.onDayHoverIn,
                    onHoverOut: e.onDayHoverOut,
                  });
                }),
              );
            }),
          );
        })(e, this);
      }),
      t
    );
  })(Ni);
  function Li(e, t, n, a) {
    var i;
    if (!(t < n || t > a)) {
      if (z(e)) {
        var s = e.length,
          r = t % s;
        i = e[r >= 0 ? r : r + s];
      } else i = e(t);
      return i;
    }
  }
  var Hi = (function (e) {
    function t() {
      var t = (null !== e && e.apply(this, arguments)) || this;
      return (
        (t._currPos = 0),
        (t._delta = 0),
        (t._endPos = 0),
        (t._lastRaf = 0),
        (t._maxSnapScroll = 0),
        (t._margin = 0),
        (t._scrollEnd = Q(function () {
          pe(t._raf), (t._raf = !1), t._onEnd(), (t._hasScrolled = !1);
        }, 200)),
        (t._setInnerEl = function (e) {
          t._innerEl = e;
        }),
        (t._setScrollEl = function (e) {
          t._scrollEl = e;
        }),
        (t._setScrollEl3d = function (e) {
          t._scrollEl3d = e;
        }),
        (t._setScrollbarEl = function (e) {
          t._scrollbarEl = e;
        }),
        (t._setScrollbarContEl = function (e) {
          t._scrollbarContEl = e;
        }),
        (t._onStart = function (e) {
          var n = t.s;
          t._hook('onStart', {}),
            (n.changeOnEnd && t._isScrolling) ||
              (!n.mouseSwipe && !e.isTouch) ||
              !n.swipe ||
              ((t._started = !0),
              (t._hasScrolled = t._isScrolling),
              (t._currX = e.startX),
              (t._currY = e.startY),
              (t._delta = 0),
              (t._velocityX = 0),
              (t._velocityY = 0),
              (t._startPos = Me(t._scrollEl, t._isVertical)),
              (t._timestamp = +new Date()),
              t._isScrolling && (pe(t._raf), (t._raf = !1), t._scroll(t._startPos)));
        }),
        (t._onMove = function (e) {
          var n = e.domEvent,
            a = t.s;
          t._isVertical || a.scrollLock || t._hasScrolled
            ? n.cancelable && n.preventDefault()
            : n.type === Jn && (Math.abs(e.deltaY) > 7 || !a.swipe) && (t._started = !1),
            t._started &&
              ((t._delta = t._isVertical ? e.deltaY : e.deltaX),
              (t._hasScrolled || Math.abs(t._delta) > t._threshold) &&
                (t._hasScrolled || t._hook('onGestureStart', {}),
                (t._hasScrolled = !0),
                (t._isScrolling = !0),
                t._raf ||
                  (t._raf = _e(function () {
                    return t._move(e);
                  }))));
        }),
        (t._onEnd = function () {
          if (((t._started = !1), t._hasScrolled)) {
            var e,
              n = t.s,
              a = 17 * (t._isVertical ? t._velocityY : t._velocityX),
              i = t._maxSnapScroll,
              s = t._delta;
            (s += a * a * 0.5 * (a < 0 ? -1 : 1)), i && (s = R(s, -t._round * i, t._round * i));
            var r = R(J((t._startPos + s) / t._round) * t._round, t._min, t._max),
              o = J((-r * t._rtlNr) / n.itemSize) + t._offset,
              l = s > 0 ? (t._isVertical ? 270 : 360) : t._isVertical ? 90 : 180,
              c = o - n.selectedIndex;
            (e = n.time || Math.max(1e3, 3 * Math.abs(r - t._currPos))),
              t._hook('onGestureEnd', { direction: l, index: o }),
              (t._delta = 0),
              t._scroll(r, e),
              c &&
                !n.changeOnEnd &&
                (t._hook('onIndexChange', { index: o, diff: c }),
                n.selectedIndex === t._prevIndex && n.selectedIndex !== o && t.forceUpdate());
          }
        }),
        (t._onClick = function (e) {
          t._hasScrolled && ((t._hasScrolled = !1), e.stopPropagation(), e.preventDefault());
        }),
        (t._onScroll = function (e) {
          (e.target.scrollTop = 0), (e.target.scrollLeft = 0);
        }),
        (t._onMouseWheel = function (e) {
          var n = t._isVertical ? (e.deltaY === N ? e.wheelDelta || e.detail : e.deltaY) : e.deltaX;
          if (t._el.contains(e.target) && n && t.s.mousewheel) {
            if (
              (e.preventDefault(),
              t._hook('onStart', {}),
              t._started ||
                ((t._delta = 0),
                (t._velocityX = 0),
                (t._velocityY = 0),
                (t._startPos = t._currPos),
                t._hook('onGestureStart', {})),
              e.deltaMode && 1 === e.deltaMode && (n *= 15),
              (n = R(-n, -t._scrollSnap, t._scrollSnap)),
              (t._delta += n),
              t._maxSnapScroll && Math.abs(t._delta) > t._round * t._maxSnapScroll && (n = 0),
              t._startPos + t._delta < t._min && ((t._startPos = t._min), (t._delta = 0), (n = 0)),
              t._startPos + t._delta > t._max && ((t._startPos = t._max), (t._delta = 0), (n = 0)),
              t._raf ||
                (t._raf = _e(function () {
                  return t._move();
                })),
              !n && t._started)
            )
              return;
            (t._hasScrolled = !0), (t._isScrolling = !0), (t._started = !0), t._scrollEnd();
          }
        }),
        (t._onTrackStart = function (e) {
          e.stopPropagation();
          var n = { domEvent: e, startX: $a(e, 'X', !0), startY: $a(e, 'Y', !0) };
          if ((t._onStart(n), (t._trackStartX = n.startX), (t._trackStartY = n.startY), e.target === t._scrollbarEl))
            Ce(t._doc, Un, t._onTrackEnd), Ce(t._doc, Wn, t._onTrackMove);
          else {
            var a = Ne(t._scrollbarContEl).top,
              i = (n.startY - a) / t._barContSize;
            (t._startPos = t._currPos = t._max + (t._min - t._max) * i), (t._hasScrolled = !0), t._onEnd();
          }
        }),
        (t._onTrackMove = function (e) {
          var n = t._barContSize,
            a = $a(e, 'X', !0),
            i = $a(e, 'Y', !0),
            s = (t._isVertical ? i - t._trackStartY : a - t._trackStartX) / n;
          t._isInfinite
            ? (t._delta = -(t._maxSnapScroll * t._round * 2 + n) * s)
            : (t._delta = (t._min - t._max - n) * s),
            (t._hasScrolled || Math.abs(t._delta) > t._threshold) &&
              (t._hasScrolled || t._hook('onGestureStart', {}),
              (t._hasScrolled = !0),
              (t._isScrolling = !0),
              t._raf ||
                (t._raf = _e(function () {
                  return t._move({ endX: a, endY: i }, !t._isInfinite);
                })));
        }),
        (t._onTrackEnd = function () {
          (t._delta = 0),
            (t._startPos = t._currPos),
            t._onEnd(),
            we(t._doc, Un, t._onTrackEnd),
            we(t._doc, Wn, t._onTrackMove);
        }),
        (t._onTrackClick = function (e) {
          e.stopPropagation();
        }),
        t
      );
    }
    return (
      n(t, e),
      (t.prototype._render = function (e, t) {
        var n = this._prevS,
          a = e.batchSize,
          i = e.batchSize3d,
          s = e.itemNr || 1,
          r = e.itemSize,
          o = e.selectedIndex,
          l = n.selectedIndex,
          c = t.index === N ? o : t.index,
          h = [],
          u = [],
          d = o - l,
          _ = c - this._currIndex,
          p = e.minIndex,
          m = e.maxIndex,
          f = e.items,
          v = e.offset;
        (this._currIndex = c),
          (this._isVertical = 'Y' === e.axis),
          (this._threshold = this._isVertical ? e.thresholdY : e.thresholdX),
          (this._rtlNr = !this._isVertical && e.rtl ? -1 : 1),
          (this._round = e.snap ? r : 1);
        for (var g = this._round; g > 44; ) g /= 2;
        if (((this._scrollSnap = J(44 / g) * g), f)) {
          for (var y = c - a; y < c + s + a; y++) h.push({ key: y, data: Li(f, y, p, m) });
          if (e.scroll3d) for (y = c - i; y < c + s + i; y++) u.push({ key: y, data: Li(f, y, p, m) });
          (this.visibleItems = h),
            (this.visible3dItems = u),
            (this._maxSnapScroll = a),
            (this._isInfinite = 'function' == typeof f);
        }
        this._offset === N && (this._offset = o);
        var b = -(o - this._offset) * r * this._rtlNr;
        if (Math.abs(d) > a && b !== this._endPos) {
          var x = d + a * (d > 0 ? -1 : 1);
          (this._offset += x), (this._margin -= x);
        }
        if (
          (v && v !== n.offset && ((this._offset += v), (this._margin -= v)),
          _ && (this._margin += _),
          (this._max = p !== N ? -(p - this._offset) * r * this._rtlNr : 1 / 0),
          (this._min = m !== N ? -(m - this._offset - (e.spaceAround ? 0 : s - 1)) * r * this._rtlNr : -1 / 0),
          -1 === this._rtlNr)
        ) {
          var C = this._min;
          (this._min = this._max), (this._max = C);
        }
        this._min > this._max && (this._min = this._max);
        var w = e.visibleSize * r;
        (this._barContSize = w),
          (this._barSize = Math.max(20, (w * w) / (this._max - this._min + w))),
          (this._cssClass = this._className + ' mbsc-ltr');
      }),
      (t.prototype._mounted = function () {
        (this._doc = Te(this._el)),
          Ce(this._el, Pn, this._onClick, !0),
          Ce(this.s.scroll3d ? this._innerEl : this._el, Kn, this._onScroll),
          Ce(this._doc, qn, this._onMouseWheel, { passive: !1, capture: !0 }),
          Ce(this._doc, Qn, this._onMouseWheel, { passive: !1, capture: !0 }),
          Ce(this._scrollbarContEl, Fn, this._onTrackStart),
          Ce(this._scrollbarContEl, Pn, this._onTrackClick),
          (this._unlisten = si(this._el, {
            onEnd: this._onEnd,
            onMove: this._onMove,
            onStart: this._onStart,
            prevDef: !0,
          }));
      }),
      (t.prototype._updated = function () {
        var e = this.s,
          t = e.batchSize,
          n = e.itemSize,
          a = e.selectedIndex,
          i = this._prevIndex,
          s = !e.prevAnim && ((i !== N && i !== a) || this._isAnimating),
          r = -(a - this._offset) * n * this._rtlNr;
        e.margin && (this._scrollEl.style.marginTop = this._isVertical ? (this._margin - t) * n + 'px' : ''),
          this._started || this._scroll(r, s ? this._isAnimating || e.time || 1e3 : 0),
          (this._prevIndex = a);
      }),
      (t.prototype._destroy = function () {
        we(this._el, Pn, this._onClick, !0),
          we(this.s.scroll3d ? this._innerEl : this._el, Kn, this._onScroll),
          we(this._doc, qn, this._onMouseWheel, { passive: !1, capture: !0 }),
          we(this._doc, Qn, this._onMouseWheel, { passive: !1, capture: !0 }),
          we(this._scrollbarContEl, Fn, this._onTrackStart),
          we(this._scrollbarContEl, Pn, this._onTrackClick),
          pe(this._raf),
          (this._raf = !1),
          this._scroll(0),
          this._unlisten();
      }),
      (t.prototype._anim = function (e) {
        var t = this;
        return (this._raf = _e(function () {
          var n = t.s,
            a = +new Date();
          if (t._raf) {
            if ((t._currPos - t._endPos) * -e < 4)
              return (
                (t._currPos = t._endPos),
                (t._raf = !1),
                (t._isAnimating = 0),
                (t._isScrolling = !1),
                t._infinite(t._currPos),
                t._hook('onAnimationEnd', {}),
                void t._scrollbarContEl.classList.remove('mbsc-scroller-bar-started')
              );
            a - t._lastRaf > 100 &&
              ((t._lastRaf = a),
              (t._currPos = Me(t._scrollEl, t._isVertical)),
              n.changeOnEnd || t._infinite(t._currPos)),
              (t._raf = t._anim(e));
          }
        }));
      }),
      (t.prototype._infinite = function (e) {
        var t = this.s;
        if (t.itemSize) {
          var n = J((-e * this._rtlNr) / t.itemSize) + this._offset,
            a = n - this._currIndex;
          a && (t.changeOnEnd ? this._hook('onIndexChange', { index: n, diff: a }) : this.setState({ index: n }));
        }
      }),
      (t.prototype._scroll = function (e, t) {
        var n = this.s,
          a = n.itemSize,
          i = this._isVertical,
          s = this._scrollEl.style,
          r = ye ? ye + 'T' : 't',
          o = t ? be + 'transform ' + J(t) + 'ms ' + n.easing : '';
        if (
          ((s[r + 'ransform'] = 'translate3d(' + (i ? '0,' + e + 'px,' : e + 'px,0,') + '0)'),
          (s[r + 'ransition'] = o),
          (this._endPos = e),
          n.scroll3d)
        ) {
          var l = this._scrollEl3d.style,
            c = 360 / (2 * n.batchSize3d);
          (l[r + 'ransform'] = 'translateY(-50%) rotateX(' + (-e / a) * c + 'deg)'), (l[r + 'ransition'] = o);
        }
        if (this._scrollbarEl) {
          var h = this._scrollbarEl.style,
            u = this._isInfinite
              ? (this._maxSnapScroll * this._round - this._delta) / (this._maxSnapScroll * this._round * 2)
              : (e - this._max) / (this._min - this._max),
            d = R((this._barContSize - this._barSize) * u, 0, this._barContSize - this._barSize);
          (h[r + 'ransform'] = 'translate3d(' + (i ? '0,' + d + 'px,' : d + 'px,0,') + '0)'), (h[r + 'ransition'] = o);
        }
        t
          ? (pe(this._raf),
            (this._isAnimating = t),
            this._scrollbarContEl.classList.add('mbsc-scroller-bar-started'),
            (this._raf = this._anim(e > this._currPos ? 1 : -1)))
          : ((this._currPos = e), n.changeOnEnd || this._infinite(e));
      }),
      (t.prototype._move = function (e, t) {
        var n = this._currX,
          a = this._currY,
          i = this._timestamp,
          s = this._maxSnapScroll;
        if (e) {
          (this._currX = e.endX), (this._currY = e.endY), (this._timestamp = +new Date());
          var r = this._timestamp - i;
          if (r > 0 && r < 100) {
            var o = (this._currX - n) / r,
              l = (this._currY - a) / r;
            (this._velocityX = 0.7 * o + 0.3 * this._velocityX), (this._velocityY = 0.7 * l + 0.3 * this._velocityY);
          }
        }
        s && !t && (this._delta = R(this._delta, -this._round * s, this._round * s)),
          this._scroll(R(this._startPos + this._delta, this._min - this.s.itemSize, this._max + this.s.itemSize)),
          (this._raf = !1);
      }),
      (t.defaults = {
        axis: 'Y',
        batchSize: 40,
        easing: 'cubic-bezier(0.190, 1.000, 0.220, 1.000)',
        mouseSwipe: !0,
        mousewheel: !0,
        prevDef: !0,
        selectedIndex: 0,
        spaceAround: !0,
        stopProp: !0,
        swipe: !0,
        thresholdX: 10,
        thresholdY: 5,
      }),
      t
    );
  })(En);
  var Ri = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype._template = function (e) {
          return (function (e, t, n) {
            var a;
            return (
              e.itemRenderer &&
                ((n = t.visibleItems.map(function (n) {
                  return e.itemRenderer(n, t._offset);
                })),
                e.scroll3d &&
                  (a = t.visible3dItems.map(function (n) {
                    return e.itemRenderer(n, t._offset, !0);
                  }))),
              je(
                'div',
                { ref: t._setEl, className: t._cssClass, style: e.styles },
                je(
                  'div',
                  { ref: t._setInnerEl, className: e.innerClass, style: e.innerStyles },
                  je('div', { ref: t._setScrollEl, className: 'mbsc-scrollview-scroll' + t._rtl }, n),
                ),
                e.scroll3d &&
                  je(
                    'div',
                    {
                      ref: t._setScrollEl3d,
                      style: { height: e.itemSize + 'px' },
                      className: 'mbsc-scroller-items-3d',
                    },
                    a,
                  ),
                je(
                  'div',
                  {
                    ref: t._setScrollbarContEl,
                    className:
                      'mbsc-scroller-bar-cont ' +
                      t._rtl +
                      (e.scrollBar && t._barSize !== t._barContSize ? '' : ' mbsc-scroller-bar-hidden') +
                      (t._started ? ' mbsc-scroller-bar-started' : ''),
                  },
                  je('div', {
                    className: 'mbsc-scroller-bar' + t._theme,
                    ref: t._setScrollbarEl,
                    style: { height: t._barSize + 'px' },
                  }),
                ),
              )
            );
          })(e, this, e.children);
        }),
        t
      );
    })(Hi),
    zi = 0;
  var Yi = (function (e) {
    function t() {
      return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
      n(t, e),
      (t.prototype._template = function (e, t) {
        return (function (e, t, n, i) {
          var s, r;
          zi++;
          var o = n._variableRow,
            l = n._view !== dn,
            c = (((s = {}).onAnimationEnd = n._onViewAnimationEnd), s),
            h = (((r = {}).onKeyDown = n._onKeyDown), r),
            u = function (i, s) {
              return je(
                Pi,
                a({}, s, {
                  activeDate: n._active,
                  amText: e.amText,
                  calendarType: e.calendarType,
                  cellTextHeight: t.cellTextHeight,
                  clickToCreate: e.clickToCreate,
                  colors: n._colors,
                  dayNames: e.dayNames,
                  dayNamesShort: n._dayNames,
                  dataTimezone: e.dataTimezone,
                  displayTimezone: e.displayTimezone,
                  eventText: e.eventText,
                  events: e.eventMap,
                  eventsText: e.eventsText,
                  exclusiveEndDates: e.exclusiveEndDates,
                  firstDay: e.firstDay,
                  firstPageDay: i,
                  getDate: e.getDate,
                  getDay: e.getDay,
                  getMonth: e.getMonth,
                  getWeekNumber: e.getWeekNumber,
                  getYear: e.getYear,
                  hasMarks: !!n._marked,
                  hoverEnd: e.hoverEnd,
                  hoverStart: e.hoverStart,
                  isPicker: e.isPicker,
                  invalid: n._invalid,
                  labels: n._labelsLayout,
                  labelHeight: t.labelHeight,
                  marked: n._marked,
                  max: n._maxDate,
                  min: n._minDate,
                  monthNames: e.monthNames,
                  monthNamesShort: e.monthNamesShort,
                  onDayClick: n._onDayClick,
                  onDayDoubleClick: e.onDayDoubleClick,
                  onDayRightClick: e.onDayRightClick,
                  onDayHoverIn: n._onDayHoverIn,
                  onDayHoverOut: n._onDayHoverOut,
                  onLabelClick: n._onLabelClick,
                  onLabelDoubleClick: e.onLabelDoubleClick,
                  onLabelRightClick: e.onLabelRightClick,
                  onLabelHoverIn: e.onLabelHoverIn,
                  onLabelHoverOut: e.onLabelHoverOut,
                  onLabelDelete: e.onLabelDelete,
                  pmText: e.pmText,
                  rangeEnd: e.rangeEnd,
                  rangeStart: e.rangeStart,
                  resourcesMap: e.resourcesMap,
                  rtl: e.rtl,
                  selectedDates: e.selectedDates,
                  selectedEventsMap: e.selectedEventsMap,
                  showEventTooltip: e.showEventTooltip,
                  showOuter: n._showOuter,
                  showWeekDays: !n._showDaysTop,
                  showWeekNumbers: e.showWeekNumbers,
                  showSingleMark: !!e.marksMap,
                  todayText: e.todayText,
                  theme: e.theme,
                  timeFormat: e.timeFormat,
                  timezonePlugin: e.timezonePlugin,
                  valid: n._valid,
                  weeks: n._weeks,
                  weekText: e.weekText,
                  renderDay: e.renderDay,
                  renderDayContent: e.renderDayContent,
                  renderLabel: e.renderLabel,
                  renderLabelContent: e.renderLabelContent,
                  variableRow: n._variableRow,
                }),
              );
            },
            d =
              n._showDaysTop && e.showCalendar
                ? je(Vi, {
                    dayNamesShort: n._dayNames,
                    rtl: n._rtl,
                    theme: n._theme,
                    firstDay: e.firstDay,
                    hasScroll: t.hasScrollY,
                    hidden: n._view !== dn && !n._hasPicker,
                    showWeekNumbers: e.showWeekNumbers,
                  })
                : null,
            _ = {
              axis: n._axis,
              batchSize: 1,
              changeOnEnd: !0,
              className: 'mbsc-calendar-scroll-wrapper' + n._theme,
              data: zi,
              easing: 'ease-out',
              itemSize: t.pickerSize,
              items: n._months,
              mousewheel: n._mousewheel,
              prevAnim: n._prevAnim,
              rtl: e.rtl,
              snap: !0,
              time: 200,
            },
            p = je(
              'div',
              { ref: n._setPickerCont, className: n._hasPicker ? 'mbsc-calendar-picker-wrapper' : '' },
              (t.view === pn || t.viewClosing === pn || e.selectView === pn) &&
                je(
                  'div',
                  a({ className: n._getPickerClass(pn) }, c),
                  je(
                    Ri,
                    a(
                      {
                        key: 'years',
                        itemRenderer: function (t, a) {
                          var i = t.key,
                            s = n._getPageYears(i),
                            r = e.getYear(new Date(n._active)),
                            o = e.getYear(new Date(n._activeMonth));
                          return je(
                            'div',
                            {
                              'aria-hidden': n._yearsIndex === i ? N : 'true',
                              className: 'mbsc-calendar-picker-slide mbsc-calendar-slide' + n._theme + n._rtl,
                              key: i,
                              style: n._getPageStyle(i, a),
                            },
                            je(
                              'div',
                              { className: 'mbsc-calendar-table mbsc-flex-col' },
                              L.map(function (t, a) {
                                return je(
                                  'div',
                                  { className: 'mbsc-calendar-row mbsc-flex mbsc-flex-1-0', key: a },
                                  P.map(function (t, i) {
                                    var l = s + 3 * a + i,
                                      c = +e.getDate(l, 0, 1);
                                    return je(Oi, {
                                      active: l === o,
                                      date: c,
                                      display: !0,
                                      selected: l === r,
                                      disabled: l < n._minYears || l > n._maxYears,
                                      rtl: e.rtl,
                                      text: l + e.yearSuffix,
                                      theme: e.theme,
                                      type: 'year',
                                      onDayClick: n._onYearClick,
                                      key: l,
                                    });
                                  }),
                                );
                              }),
                            ),
                          );
                        },
                        maxIndex: n._maxYearsIndex,
                        minIndex: n._minYearsIndex,
                        onGestureEnd: n._onGestureEnd,
                        onIndexChange: n._onYearsPageChange,
                        selectedIndex: n._yearsIndex,
                      },
                      _,
                    ),
                  ),
                ),
              (t.view === _n || t.viewClosing === _n || e.selectView === _n) &&
                je(
                  'div',
                  a({ className: n._getPickerClass(_n) }, c),
                  je(
                    Ri,
                    a(
                      {
                        key: 'year',
                        itemRenderer: function (t, a) {
                          var i = t.key,
                            s = n._getPageYear(i),
                            r = new Date(n._activeMonth),
                            o = e.getYear(r),
                            l = e.getMonth(r),
                            c = new Date(n._active),
                            h = e.getYear(c),
                            u = e.getMonth(c);
                          return je(
                            'div',
                            {
                              'aria-hidden': n._yearIndex === i ? N : 'true',
                              className: 'mbsc-calendar-picker-slide mbsc-calendar-slide' + n._theme + n._rtl,
                              key: i,
                              style: n._getPageStyle(i, a),
                            },
                            je(
                              'div',
                              { className: 'mbsc-calendar-table mbsc-flex-col' },
                              L.map(function (t, a) {
                                return je(
                                  'div',
                                  { className: 'mbsc-calendar-row mbsc-flex mbsc-flex-1-0', key: a },
                                  P.map(function (t, i) {
                                    var r = e.getDate(s, 3 * a + i, 1),
                                      c = e.getYear(r),
                                      d = e.getMonth(r);
                                    return je(Oi, {
                                      active: c === o && d === l,
                                      date: +r,
                                      display: !0,
                                      selected: c === h && d === u,
                                      disabled: r < n._minYear || r >= n._maxYear,
                                      month: e.monthNames[d],
                                      rtl: e.rtl,
                                      text: e.monthNamesShort[d],
                                      theme: e.theme,
                                      type: 'month',
                                      onDayClick: n._onMonthClick,
                                      key: +r,
                                    });
                                  }),
                                );
                              }),
                            ),
                          );
                        },
                        maxIndex: n._maxYearIndex,
                        minIndex: n._minYearIndex,
                        onGestureEnd: n._onGestureEnd,
                        onIndexChange: n._onYearPageChange,
                        selectedIndex: n._yearIndex,
                      },
                      _,
                    ),
                  ),
                ),
            );
          return je(
            'div',
            { className: n._cssClass, ref: n._setEl, style: n._dim, onClick: K },
            je(
              'div',
              {
                className:
                  'mbsc-calendar-wrapper mbsc-flex-col mbsc-flex-1-1' +
                  n._theme +
                  n._hb +
                  (e.hasContent || !e.showCalendar ? ' mbsc-calendar-wrapper-fixed' : ''),
              },
              je(
                'div',
                {
                  className:
                    'mbsc-calendar-header' +
                    n._theme +
                    n._hb +
                    (n._showDaysTop ? ' mbsc-calendar-header-vertical' : ''),
                  ref: n._setHeader,
                },
                e.showControls &&
                  (function () {
                    var t, a;
                    if (e.renderHeader)
                      F((t = e.renderHeader())) &&
                        (t !== n._headerHTML && ((n._headerHTML = t), (n._shouldEnhanceHeader = !0)),
                        (a = n._safeHtml(t)));
                    else {
                      var i = n._pageNr > 1;
                      t = je(
                        qe,
                        null,
                        je(vi, {
                          className: 'mbsc-calendar-title-wrapper' + (i ? ' mbsc-calendar-title-wrapper-multi' : ''),
                        }),
                        je(pi, {
                          className: 'mbsc-calendar-button-prev' + (i ? ' mbsc-calendar-button-prev-multi' : ''),
                        }),
                        e.showToday && je(fi, { className: 'mbsc-calendar-header-today' }),
                        je(mi, {
                          className: 'mbsc-calendar-button-next' + (i ? ' mbsc-calendar-button-next-multi' : ''),
                        }),
                      );
                    }
                    var s = je(
                      'div',
                      { className: 'mbsc-calendar-controls' + n._theme, dangerouslySetInnerHTML: a },
                      t,
                    );
                    return je(li.Provider, { children: s, value: { instance: n } });
                  })(),
                d,
              ),
              je(
                'div',
                a({ className: 'mbsc-calendar-body mbsc-flex-col mbsc-flex-1-1' + n._theme, ref: n._setBody }, h),
                e.showCalendar &&
                  je(
                    'div',
                    {
                      className:
                        'mbsc-calendar-body-inner mbsc-flex-col mbsc-flex-1-1' +
                        (o ? ' mbsc-calendar-body-inner-variable' : ''),
                    },
                    n._isGrid
                      ? je(
                          'div',
                          {
                            'aria-hidden': l ? 'true' : N,
                            className: 'mbsc-calendar-grid mbsc-flex-1-1 mbsc-flex-col' + n._theme + n._hb,
                          },
                          n._monthsMulti.map(function (t, a) {
                            return je(
                              'div',
                              { key: a, className: 'mbsc-calendar-grid-row mbsc-flex mbsc-flex-1-1' },
                              t.map(function (t, a) {
                                return je(
                                  'div',
                                  {
                                    key: a,
                                    className: 'mbsc-calendar-grid-item mbsc-flex-col mbsc-flex-1-1' + n._theme,
                                  },
                                  je(
                                    'div',
                                    { className: 'mbsc-calendar-month-title' + n._theme },
                                    e.monthNames[new Date(t).getMonth()],
                                  ),
                                  u(t, { isActive: !0 }),
                                );
                              }),
                            );
                          }),
                        )
                      : o
                      ? je(
                          'div',
                          {
                            'aria-hidden': l ? 'true' : N,
                            className: 'mbsc-calendar-slide mbsc-calendar-slide-active ' + n._getPickerClass(dn),
                          },
                          u(+e.navigationService.firstDay, {
                            dragData: e.dragData,
                            dragToCreate: e.dragToCreate,
                            dragToMove: e.dragToMove,
                            dragToResize: e.dragToResize,
                            isActive: !0,
                            onLabelUpdateEnd: e.onLabelUpdateEnd,
                            onLabelUpdateModeOff: e.onLabelUpdateModeOff,
                            onLabelUpdateModeOn: e.onLabelUpdateModeOn,
                            onLabelUpdateMove: e.onLabelUpdateMove,
                            onLabelUpdateStart: e.onLabelUpdateStart,
                          }),
                        )
                      : e.selectView === dn &&
                        je(
                          'div',
                          a({ 'aria-hidden': l ? 'true' : N, className: n._getPickerClass(dn) }, c),
                          je(
                            Ri,
                            a({}, _, {
                              itemNr: n._pageNr,
                              itemSize: t.pageSize / n._pageNr,
                              itemRenderer: function (t, a) {
                                var i = t.key,
                                  s = i >= n._pageIndex && i < n._pageIndex + n._pageNr && n._view === dn,
                                  r = {
                                    dragData: e.dragData,
                                    dragToCreate: e.dragToCreate,
                                    dragToMove: e.dragToMove,
                                    dragToResize: e.dragToResize,
                                    isActive: s,
                                    onLabelUpdateEnd: e.onLabelUpdateEnd,
                                    onLabelUpdateModeOff: e.onLabelUpdateModeOff,
                                    onLabelUpdateModeOn: e.onLabelUpdateModeOn,
                                    onLabelUpdateMove: e.onLabelUpdateMove,
                                    onLabelUpdateStart: e.onLabelUpdateStart,
                                  };
                                return je(
                                  'div',
                                  {
                                    className:
                                      'mbsc-calendar-slide' +
                                      (s ? ' mbsc-calendar-slide-active' : '') +
                                      n._theme +
                                      n._rtl,
                                    key: i,
                                    style: n._getPageStyle(i, a, n._pageNr),
                                  },
                                  u(n._getPageDay(i), r),
                                );
                              },
                              maxIndex: n._maxIndex,
                              minIndex: n._minIndex,
                              mouseSwipe: e.mouseSwipe,
                              onAnimationEnd: n._onAnimationEnd,
                              onGestureStart: n._onGestureStart,
                              onIndexChange: n._onPageChange,
                              onStart: n._onStart,
                              selectedIndex: n._pageIndex,
                              swipe: e.swipe,
                            }),
                          ),
                        ),
                    !n._hasPicker && p,
                  ),
              ),
            ),
            i,
            n._hasPicker &&
              je(
                Ti,
                {
                  anchor: n._pickerBtn,
                  closeOnScroll: !0,
                  contentPadding: !1,
                  context: e.context,
                  cssClass: 'mbsc-calendar-popup',
                  display: 'anchored',
                  isOpen: n._view !== dn,
                  locale: e.locale,
                  onClose: n._onPickerClose,
                  onOpen: n._onPickerOpen,
                  rtl: e.rtl,
                  scrollLock: !1,
                  showOverlay: !1,
                  theme: e.theme,
                  themeVariant: e.themeVariant,
                },
                je(
                  'div',
                  a({}, h),
                  je(
                    'div',
                    { className: 'mbsc-calendar-controls' + n._theme },
                    je(
                      'div',
                      {
                        'aria-live': 'polite',
                        className: 'mbsc-calendar-picker-button-wrapper mbsc-calendar-title-wrapper' + n._theme,
                      },
                      je(
                        oi,
                        {
                          className: 'mbsc-calendar-button',
                          onClick: n._onPickerBtnClick,
                          theme: e.theme,
                          themeVariant: e.themeVariant,
                          type: 'button',
                          variant: 'flat',
                        },
                        n._viewTitle,
                        e.downIcon && je(Ja, { svg: t.view === pn ? e.downIcon : e.upIcon, theme: e.theme }),
                      ),
                    ),
                    je(oi, {
                      className: 'mbsc-calendar-button',
                      ariaLabel: e.prevPageText,
                      disabled: n._isPrevDisabled(!0),
                      iconSvg: n._prevIcon,
                      onClick: n.prevPage,
                      theme: e.theme,
                      themeVariant: e.themeVariant,
                      type: 'button',
                      variant: 'flat',
                    }),
                    je(oi, {
                      className: 'mbsc-calendar-button',
                      ariaLabel: e.nextPageText,
                      disabled: n._isNextDisabled(!0),
                      iconSvg: n._nextIcon,
                      onClick: n.nextPage,
                      theme: e.theme,
                      themeVariant: e.themeVariant,
                      type: 'button',
                      variant: 'flat',
                    }),
                  ),
                  p,
                ),
              ),
          );
        })(e, t, this, e.children);
      }),
      (t.prototype._updated = function () {
        e.prototype._updated.call(this),
          this._shouldEnhanceHeader && (Tt(this._headerElement, { view: this }), (this._shouldEnhanceHeader = !1));
      }),
      t
    );
  })(gi);
  var Ai = (function (e) {
    function t() {
      var t = (null !== e && e.apply(this, arguments)) || this;
      return (t._instanceService = new qa()), t;
    }
    return (
      n(t, e),
      (t.prototype._template = function (e) {
        return (function (e, t) {
          return je(Yi, {
            ref: t._setCal,
            refDate: e.refDate,
            activeDate: e.active,
            amText: e.amText,
            cssClass: t._className + ' mbsc-flex-1-1 mbsc-calendar-' + e.display,
            calendarScroll: e.calendarScroll,
            calendarType: e.calendarType,
            colors: e.colors,
            context: e.context,
            dataTimezone: e.dataTimezone,
            displayTimezone: e.displayTimezone,
            timezonePlugin: e.timezonePlugin,
            downIcon: e.downIcon,
            exclusiveEndDates: e.exclusiveEndDates,
            hoverEnd: e.hoverEnd,
            hoverStart: e.hoverStart,
            invalid: e.invalid,
            instanceService: t._instanceService,
            isPicker: !0,
            labels: e.labels,
            marked: e.marked,
            max: e.max,
            min: e.min,
            mousewheel: e.mousewheel,
            navigationService: t._navService,
            nextIconH: e.nextIconH,
            nextIconV: e.nextIconV,
            nextPageText: e.nextPageText,
            noOuterChange: e.selectRange,
            onActiveChange: t._onActiveChange,
            onCellHoverIn: e.onCellHoverIn,
            onCellHoverOut: e.onCellHoverOut,
            onDayClick: t._onDayClick,
            onDayHoverIn: e.onDayHoverIn,
            onDayHoverOut: e.onDayHoverOut,
            onLabelClick: e.onLabelClick,
            onPageChange: e.onPageChange,
            onPageLoaded: e.onPageLoaded,
            onPageLoading: e.onPageLoading,
            onTodayClick: t._onTodayClick,
            pages: e.pages,
            pmText: e.pmText,
            prevIconH: e.prevIconH,
            prevIconV: e.prevIconV,
            prevPageText: e.prevPageText,
            renderDay: e.renderDay,
            renderDayContent: e.renderDayContent,
            renderHeader: e.renderCalendarHeader,
            rangeEnd: e.rangeEnd,
            rangeStart: e.rangeStart,
            rtl: e.rtl,
            selectedDates: t._tempValueRep,
            selectView: e.selectView,
            showCalendar: !0,
            showControls: e.showControls,
            showOuterDays: e.showOuterDays,
            showToday: !1,
            showWeekNumbers: e.showWeekNumbers,
            size: e.size,
            theme: e.theme,
            themeVariant: e.themeVariant,
            upIcon: e.upIcon,
            valid: e.valid,
            weeks: e.weeks,
            width: e.width,
            getDate: e.getDate,
            getDay: e.getDay,
            getMaxDayOfMonth: e.getMaxDayOfMonth,
            getMonth: e.getMonth,
            getWeekNumber: e.getWeekNumber,
            getYear: e.getYear,
            dateFormat: e.dateFormat,
            dayNames: e.dayNames,
            dayNamesMin: e.dayNamesMin,
            dayNamesShort: e.dayNamesShort,
            eventText: e.eventText,
            eventsText: e.eventsText,
            firstDay: e.firstDay,
            fromText: e.fromText,
            monthNames: e.monthNames,
            monthNamesShort: e.monthNamesShort,
            moreEventsPluralText: e.moreEventsPluralText,
            moreEventsText: e.moreEventsText,
            todayText: e.todayText,
            toText: e.toText,
            weekText: e.weekText,
            yearSuffix: e.yearSuffix,
          });
        })(e, this);
      }),
      t
    );
  })(Ba);
  function Fi(e, t, n, a) {
    var i = e.min === N ? -1 / 0 : e.min,
      s = e.max === N ? 1 / 0 : e.max,
      r = ji(e, t),
      o = Bi(e, r),
      l = o,
      c = o,
      h = 0,
      u = 0;
    if (n && n.get(o)) {
      for (; r - h >= i && n.get(l) && h < 100; ) l = Bi(e, r - ++h);
      for (; r + u < s && n.get(c) && u < 100; ) c = Bi(e, r + ++u);
      if (n.get(l) && n.get(c)) return o;
      o = ((u < h && u && -1 !== a) || !h || r - h < 0 || 1 === a) && !n.get(c) ? c : l;
    }
    return o;
  }
  function Wi(e) {
    return e !== N ? (e.value !== N ? e.value : e.display !== N ? e.display : e) : e;
  }
  function Ui(e, t) {
    if (e.getItem) return e.getItem(t);
    var n = e.data || [],
      a = n.length,
      i = t % a;
    return e._circular ? n[i >= 0 ? i : i + a] : n[R(t, 0, a - 1)];
  }
  function ji(e, t) {
    var n = e.multiple ? (t && t.length && t[0]) || N : t;
    return (e.getIndex ? +e.getIndex(t) : e._map.get(n)) || 0;
  }
  function Bi(e, t) {
    return Wi(Ui(e, t));
  }
  var qi = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t._indexes = []),
          (t._activeIndexes = []),
          (t._wheels = []),
          (t._batches = []),
          (t._lastIndexes = []),
          (t._onSet = function () {
            t._setOrUpdate();
          }),
          (t._onActiveChange = function (e) {
            var n = e.wheel,
              a = e.index,
              i = n._key;
            t._activeIndexes[i] = a;
            var s = t._indexes,
              r = s[i];
            t._scroll3d ? (r = a) : a - r >= t._rows ? r++ : a < r && r--, (s[i] = r), t.forceUpdate();
          }),
          (t._onWheelIndexChange = function (e) {
            var n = t.s,
              a = e.wheel,
              i = a._key,
              s = a.multiple,
              r = Bi(a, e.index),
              o = t._disabled && t._disabled[i] && t._disabled[i].get(r),
              l = [],
              c = n.selectOnScroll;
            (c || !e.click) &&
              ((t._lastIndexes[i] = t._indexes[i] = e.index),
              t._indexes.forEach(function (e, n) {
                var a = t._wheelMap[n],
                  i = a.data ? a.data.length : 0;
                (t._batches[n] = i ? $(e / i) : 0), (l[n] = i);
              })),
              (t._activeIndexes[i] = e.index);
            var h = t._get(t._tempValueRep),
              u = !!e.click && !o,
              d = c || u;
            if (s) {
              if (u) {
                var _ = (t._tempValueRep[i] || []).slice();
                !1 === e.selected ? _.push(r) : !0 === e.selected && _.splice(_.indexOf(r), 1),
                  (t._tempValueRep[i] = _);
              }
            } else d && (t._tempValueRep[i] = r);
            if (n.onWheelMove && e.index !== N) {
              var p = n.onWheelMove({ dataItem: Ui(a, e.index), selection: d, wheelIndex: i });
              p &&
                p.forEach(function (e, n) {
                  if ((e !== N && (t._tempValueRep[n] = e), !d)) {
                    var a = t._wheelMap[n],
                      i = ji(a, e);
                    t._constrainIndex(i, a);
                  }
                });
            }
            d && t._validate(i, e.diff > 0 ? 1 : -1),
              c &&
                t._tempValueRep.forEach(function (e, n) {
                  var a = t._wheelMap[n],
                    i = a.data ? a.data.length : 0,
                    s = t._indexes[n],
                    r = ji(a, e) + t._batches[n] * i;
                  (t._activeIndexes[n] = t._lastIndexes[n] = t._indexes[n] = r), (a._offset = i !== l[n] ? r - s : 0);
                });
            var m = t._get(t._tempValueRep),
              f = !t._valueEquals(h, m);
            f || (e.click && t._live && !t._valueEquals(t.value, m)) ? t._setOrUpdate(!f) : t.forceUpdate(),
              t._live && u && a.closeOnTap && t.close();
          }),
          t
        );
      }
      return (
        n(t, e),
        (t.prototype._initWheels = function () {
          var e = this,
            t = 0,
            n = this.s.wheels || [];
          (this._wheelMap = []),
            n.forEach(function (n) {
              n.forEach(function (n) {
                e._initWheel(n, t), (e._wheelMap[t] = n), t++;
              });
            }),
            (this._wheels = n);
        }),
        (t.prototype._shouldValidate = function (e, t) {
          return !!e.shouldValidate && e.shouldValidate(e, t);
        }),
        (t.prototype._valueEquals = function (e, t) {
          return this.s.valueEquality ? this.s.valueEquality(e, t) : e === t;
        }),
        (t.prototype._render = function (t, n) {
          var a = this,
            i = this.props || {},
            s = this._respProps || {},
            r = this._prevS,
            o = !!this._touchUi && t.circular,
            l = this._touchUi ? t.rows : s.rows || i.rows || 7;
          if (
            ((this._displayStyle = t.displayStyle || t.display),
            (this._scroll3d = t.scroll3d && this._touchUi && xe),
            (t.itemHeight !== r.itemHeight || l !== this._rows) &&
              ((this._rows = l), (this._lineStyle = { height: t.itemHeight + 'px' }), this._scroll3d))
          ) {
            var c = 'translateZ(' + ((t.itemHeight * l) / 2 + 3) + 'px';
            (this._overlayStyle = {}),
              (this._overlayStyle[be + 'transform'] = c),
              (this._lineStyle[be + 'transform'] = 'translateY(-50%) ' + c);
          }
          (t.wheels === r.wheels && o === this._circular) ||
            ((this._batches = []), (this._shouldSetIndex = !0), (this._circular = o), this._initWheels()),
            e.prototype._render.call(this, t, n),
            this._shouldSetIndex && (this._setIndexes(), (this._shouldSetIndex = this._indexFromValue = !1)),
            t.wheels !== r.wheels &&
              r.wheels !== N &&
              setTimeout(function () {
                for (var e = 0, t = a._wheelMap; e < t.length; e++) {
                  var n = t[e];
                  a._onWheelIndexChange({ diff: 0, index: a._indexes[n._key], wheel: n });
                }
              });
        }),
        (t.prototype._writeValue = function (t, n, a) {
          return this.s.writeValue ? this.s.writeValue(t, n, a) : e.prototype._writeValue.call(this, t, n, a);
        }),
        (t.prototype._copy = function (e) {
          return e.slice(0);
        }),
        (t.prototype._format = function (e) {
          return this.s.formatValue ? this.s.formatValue(e) : e.join(' ');
        }),
        (t.prototype._get = function (e) {
          return this.s.getValue ? this.s.getValue(e) : e;
        }),
        (t.prototype._parse = function (e) {
          if (this.s.parseValue) return this.s.parseValue(e);
          var t = [],
            n = [],
            a = 0;
          return (
            null !== e && e !== N && (n = (e + '').split(' ')),
            this._wheels.forEach(function (e) {
              e.forEach(function (e) {
                for (var i = e.data || [], s = i.length, r = Wi(i[0]), o = 0; r != n[a] && o < s; ) (r = Wi(i[o])), o++;
                t.push(r), a++;
              });
            }),
            t
          );
        }),
        (t.prototype._validate = function (e, t) {
          var n = this;
          if (this.s.validate) {
            var a = this.s.validate.call(this._el, {
              direction: t,
              index: e,
              values: this._tempValueRep.slice(0),
              wheels: this._wheelMap,
            });
            (this._disabled = a.disabled),
              a.init && this._initWheels(),
              a.indexes &&
                a.indexes.forEach(function (e, t) {
                  if (e !== N) {
                    var a = n._wheelMap[t],
                      i = ji(a, e);
                    n._constrainIndex(i, a);
                  }
                }),
              a.valid
                ? (this._tempValueRep = a.valid.slice(0))
                : this._wheelMap.forEach(function (e, a) {
                    n._tempValueRep[a] = Fi(e, n._tempValueRep[a], n._disabled && n._disabled[a], t);
                  });
          }
        }),
        (t.prototype._onOpen = function () {
          (this._batches = []), (this._shouldSetIndex = !0), (this._indexFromValue = !0);
        }),
        (t.prototype._onParse = function () {
          this._shouldSetIndex = !0;
        }),
        (t.prototype._initWheel = function (e, t) {
          var n = this._circular;
          (e._key = t),
            (e._map = new Map()),
            (e._circular =
              n === N ? (e.circular === N ? e.data && e.data.length > this._rows : e.circular) : z(n) ? n[t] : n),
            e.data &&
              ((e.min = e._circular ? N : 0),
              (e.max = e._circular ? N : e.data.length - 1),
              e.data.forEach(function (t, n) {
                e._map.set(Wi(t), n);
              }));
        }),
        (t.prototype._setIndexes = function () {
          var e = this,
            t = this._indexes || [];
          (this._indexes = []),
            (this._activeIndexes = []),
            this._tempValueRep.forEach(function (n, a) {
              var i = e._wheelMap[a],
                s = i.data ? i.data.length : 0,
                r = ji(i, n);
              if (e.s.selectOnScroll) e._activeIndexes[a] = e._indexes[a] = r + (e._batches[a] || 0) * s;
              else {
                var o = r;
                e._indexFromValue ||
                  ((o = t[a]) !== N &&
                    (o =
                      (function (e, t) {
                        if (e.getItem && e.getIndex) return e.getIndex(Wi(e.getItem(t)));
                        var n = (e.data || []).length,
                          a = t % n;
                        return n ? (a >= 0 ? a : a + n) : 0;
                      })(i, o) +
                      (e._batches[a] || 0) * s)),
                  e._constrainIndex(o, i);
              }
            });
        }),
        (t.prototype._constrainIndex = function (e, t) {
          var n = t._key;
          e !== N && t.data
            ? (t.spaceAround || (e = R(e, 0, Math.max(t.data.length - this._rows, 0))),
              (this._activeIndexes[n] = this._indexes[n] = e))
            : (this._activeIndexes[n] = this._indexes[n] = this._lastIndexes[n] || 0);
        }),
        (t.defaults = { itemHeight: 40, rows: 5, selectOnScroll: !0, showOnClick: !0 }),
        (t._name = 'Scroller'),
        t
      );
    })(wa),
    Xi = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t._onClick = function () {
            var e = t.s;
            e.text === N ||
              e.isGroup ||
              t._hook('onClick', { index: e.index, selected: e.selected, disabled: e.disabled });
          }),
          t
        );
      }
      return (
        n(t, e),
        (t.prototype._mounted = function () {
          var e = this;
          this._unlisten = si(this._el, {
            click: !0,
            keepFocus: !1,
            onBlur: function () {
              e.setState({ hasFocus: !1 });
            },
            onFocus: function () {
              e.setState({ hasFocus: !0 });
            },
            onHoverIn: function () {
              e.s.text !== N && e.setState({ hasHover: !0 });
            },
            onHoverOut: function () {
              e.s.text !== N && e.setState({ hasHover: !1 });
            },
            onKeyDown: function (t) {
              (t.keyCode === ta || (!e.s.multiple && t.keyCode === ea)) && e._onClick();
            },
            onPress: function () {
              e.s.text !== N && e.setState({ isActive: !0 });
            },
            onRelease: function () {
              e.s.text !== N && e.setState({ isActive: !1 });
            },
          });
        }),
        (t.prototype._destroy = function () {
          this._unlisten();
        }),
        (t.prototype._render = function (e, t) {
          var n = e.height;
          (this._cssClass =
            'mbsc-scroller-wheel-' +
            (e.isGroup ? 'header' : 'item') +
            this._theme +
            this._rtl +
            (e.checkmark && !e.isGroup ? ' mbsc-wheel-item-checkmark' : '') +
            (e.is3d ? ' mbsc-scroller-wheel-item-3d' : '') +
            (e.scroll3d && !e.is3d ? ' mbsc-scroller-wheel-item-2d' : '') +
            (e.selected && !e.is3d ? ' mbsc-selected' : '') +
            (e.selected && e.is3d ? ' mbsc-selected-3d' : '') +
            (e.disabled ? ' mbsc-disabled' : '') +
            (e.multiple && !e.isGroup ? ' mbsc-wheel-item-multi' : '') +
            (t.hasHover ? ' mbsc-hover' : '') +
            (t.hasFocus ? ' mbsc-focus' : '') +
            (t.isActive ? ' mbsc-active' : '')),
            (this._style = { height: n + 'px', lineHeight: n + 'px' }),
            (this._checkmarkClass =
              this._theme + this._rtl + ' mbsc-wheel-checkmark' + (e.selected ? ' mbsc-selected' : '')),
            e.is3d &&
              ((this._transform =
                'rotateX(' +
                (((e.offset - e.index) * e.angle3d) % 360) +
                'deg) translateZ(' +
                (n * e.rows) / 2 +
                'px)'),
              (this._style[be + 'transform'] = this._transform));
        }),
        t
      );
    })(En);
  var Ki = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype._template = function (e) {
          return (function (e, t) {
            var n;
            if (e.renderItem && e.data !== N) {
              var a = e.renderItem(e.data),
                i = F(a) ? { __html: a } : N;
              n = i ? je('div', { dangerouslySetInnerHTML: i }) : je('div', null, a);
            } else n = e.text;
            return je(
              'div',
              {
                'aria-disabled': e.disabled ? 'true' : N,
                'aria-hidden': n === N || e.is3d ? 'true' : N,
                'aria-selected': e.selected ? 'true' : N,
                ref: t._setEl,
                tabIndex: e.active ? 0 : N,
                className: t._cssClass,
                role: 'option',
                style: t._style,
                onClick: t._onClick,
              },
              e.checkmark && je('span', { className: t._checkmarkClass }),
              n,
            );
          })(e, this);
        }),
        t
      );
    })(Xi),
    Gi = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t._onIndexChange = function (e) {
            (e.wheel = t.s.wheel), t._hook('onIndexChange', e);
          }),
          (t._onItemClick = function (e) {
            t._hook('onIndexChange', { click: !0, index: e.index, wheel: t.s.wheel, selected: e.selected });
          }),
          (t._onKeyDown = function (e) {
            var n = 0;
            e.keyCode === oa ? (n = -1) : e.keyCode === ca && (n = 1);
            var a = t.s,
              i = a.activeIndex + n,
              s = !(i < a.minIndex || i > a.maxIndex);
            if ((n && e.preventDefault(), n && s)) {
              var r = a.selectOnScroll ? 'onIndexChange' : 'onActiveChange';
              (t._shouldFocus = !0), t._hook(r, { diff: n, index: i, wheel: a.wheel });
            } else e.keyCode === ea && a.multiple && t._hook('onSet', {});
          }),
          t
        );
      }
      return (
        n(t, e),
        (t.prototype._getText = function (e) {
          return e !== N ? (e.display !== N ? e.display : e) : N;
        }),
        (t.prototype._getValue = function (e) {
          return e ? (e.value !== N ? e.value : e.display !== N ? e.display : e) : e;
        }),
        (t.prototype._isActive = function (e, t, n) {
          var a = this.s,
            i = a.scroll3d && a.multiple ? n : !n;
          return a.activeIndex === e.key && t && i;
        }),
        (t.prototype._isSelected = function (e) {
          var t = this.s,
            n = t.selectedValues,
            a = this._getValue(e.data);
          return t.multiple
            ? !(!n || !n.indexOf) && n.indexOf(a) >= 0
            : t.selectOnScroll
            ? e.key === t.selectedIndex
            : a !== N && a === n;
        }),
        (t.prototype._isDisabled = function (e) {
          var t = this.s.disabled,
            n = e && e.disabled,
            a = this._getValue(e);
          return !!(n || (t && t.get(a)));
        }),
        (t.prototype._render = function (e) {
          var t = e.rows,
            n = e.itemHeight,
            a = e.wheel._key,
            i = 2 * J((n - 0.03 * ((n * t) / 2 + 3)) / 2);
          (this._items = e.wheel.getItem || e.wheel.data || []),
            (this._batchSize3d = J(1.8 * t)),
            (this._angle3d = 360 / (2 * this._batchSize3d)),
            (this._style = { height: 2 * J((t * n * (e.scroll3d ? 1.1 : 1)) / 2) + 'px' }),
            (this._itemNr = e.wheel.spaceAround ? 1 : t),
            (this._innerStyle = { height: (e.scroll3d ? i : e.wheel.spaceAround ? n : n * t) + 'px' }),
            (this._wheelStyle = e.wheelWidth
              ? { width: (z(e.wheelWidth) ? e.wheelWidth[a] : e.wheelWidth) + 'px' }
              : {
                  maxWidth: (z(e.maxWheelWidth) ? e.maxWheelWidth[a] : e.maxWheelWidth) + 'px',
                  minWidth: (z(e.minWheelWidth) ? e.minWheelWidth[a] : e.minWheelWidth) + 'px',
                }),
            e.scroll3d &&
              (this._innerStyle[be + 'transform'] = 'translateY(-50%) translateZ(' + ((n * t) / 2 + 3) + 'px');
        }),
        (t.prototype._updated = function () {
          if (this._shouldFocus) {
            var e = this._el.querySelector('[tabindex="0"]');
            e &&
              setTimeout(function () {
                e.focus();
              }),
              (this._shouldFocus = !1);
          }
        }),
        t
      );
    })(En);
  var Ji,
    Zi = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype._template = function (e) {
          return (function (e, t) {
            var n,
              i = (((n = {}).onKeyDown = t._onKeyDown), n);
            return je(
              'div',
              a(
                {
                  'aria-multiselectable': e.multiple ? 'true' : N,
                  className:
                    'mbsc-scroller-wheel-wrapper mbsc-scroller-wheel-wrapper-' +
                    e.wheel._key +
                    ' ' +
                    (e.wheel.cssClass || '') +
                    (e.scroll3d ? ' mbsc-scroller-wheel-wrapper-3d' : '') +
                    t._theme +
                    t._rtl,
                  ref: t._setEl,
                  role: 'listbox',
                  style: t._wheelStyle,
                },
                i,
              ),
              je(Ri, {
                batchSize3d: t._batchSize3d,
                className: 'mbsc-scroller-wheel' + (e.scroll3d ? ' mbsc-scroller-wheel-3d' : '') + t._theme,
                innerClass:
                  'mbsc-scroller-wheel-cont mbsc-scroller-wheel-cont-' +
                  e.display +
                  (e.scroll3d ? ' mbsc-scroller-wheel-cont-3d' : '') +
                  (e.multiple ? ' mbsc-scroller-wheel-multi' : '') +
                  t._theme,
                innerStyles: t._innerStyle,
                items: t._items,
                itemSize: e.itemHeight,
                itemRenderer: function (n, a, i) {
                  if (n !== N) {
                    var s = t._getText(n.data);
                    return je(Ki, {
                      active: t._isActive(n, s, i),
                      angle3d: t._angle3d,
                      data: n.data,
                      disabled: t._isDisabled(n.data),
                      height: e.itemHeight,
                      index: n.key,
                      is3d: i,
                      isGroup: n.data && n.data.isGroup,
                      key: n.key,
                      multiple: e.multiple,
                      onClick: t._onItemClick,
                      offset: a,
                      checkmark: e.wheel.checkmark,
                      renderItem: e.renderItem,
                      rows: e.rows,
                      rtl: e.rtl,
                      scroll3d: e.scroll3d,
                      selected: t._isSelected(n),
                      text: s,
                      theme: e.theme,
                    });
                  }
                  return null;
                },
                itemNr: t._itemNr,
                margin: !0,
                maxIndex: e.maxIndex,
                minIndex: e.minIndex,
                onIndexChange: t._onIndexChange,
                offset: e.wheel._offset,
                rtl: e.rtl,
                scroll3d: e.scroll3d,
                scrollBar: !t._touchUi,
                selectedIndex: e.selectedIndex,
                snap: !0,
                spaceAround: e.wheel.spaceAround,
                styles: t._style,
                visibleSize: e.rows,
              }),
            );
          })(e, this);
        }),
        t
      );
    })(Gi),
    $i = new o(),
    Qi = 0;
  function es() {
    clearTimeout(Ji),
      (Ji = setTimeout(function () {
        $i.next();
      }, 100));
  }
  function ts(e) {
    try {
      return Pe(e, '*:-webkit-autofill');
    } catch (e) {
      return !1;
    }
  }
  var ns = (function (e) {
    function t() {
      var t = (null !== e && e.apply(this, arguments)) || this;
      return (
        (t._tag = 'input'),
        (t._onClick = function () {
          t._hidePass = !t._hidePass;
        }),
        (t._onMouseDown = function (e) {
          t.s.tags && (t._preventFocus = !0);
        }),
        (t._onTagClear = function (e, n) {
          if ((e.stopPropagation(), e.preventDefault(), !t.s.disabled)) {
            var a = t.s.pickerValue.slice();
            a.splice(n, 1), He(t._el, Nn, a);
          }
        }),
        (t._sizeTextArea = function () {
          var e,
            n,
            a,
            i = t._el,
            s = t.s.rows;
          i.offsetHeight &&
            ((i.style.height = ''),
            (a = i.scrollHeight - i.offsetHeight),
            (e = i.offsetHeight + (a > 0 ? a : 0)),
            (n = Math.round(e / 24)) > s
              ? ((e = 24 * s + (e - 24 * n)), (i.style.overflow = 'auto'))
              : (i.style.overflow = ''),
            e && (i.style.height = e + 'px'));
        }),
        (t._onAutoFill = function () {
          'floating' === t.s.labelStyle && ts(t._el) && t.setState({ isFloatingActive: !0 });
        }),
        t
      );
    }
    return (
      n(t, e),
      (t.prototype._change = function (e) {}),
      (t.prototype._checkFloating = function () {
        var e = this,
          t = this._el,
          n = this.s,
          a = ts(t),
          i = this.state.hasFocus || a || !W(this.value);
        if (t && 'floating' === n.labelStyle) {
          if ('select' === this._tag) {
            var s = t,
              r = s.options[0];
            i = !!(i || s.multiple || s.value || (s.selectedIndex > -1 && r && r.label));
          } else if (this.value === N) {
            i = !(!i && !t.value);
          }
          (this._valueChecked = !0),
            ee(this, function () {
              e.setState({ isFloatingActive: i });
            });
        }
      }),
      (t.prototype._mounted = function () {
        var e,
          t = this,
          n = this.s,
          a = this._el;
        Ce(a, On, this._onAutoFill),
          'textarea' === this._tag &&
            (Ce(a, Yn, this._sizeTextArea),
            (this._unsubscribe = ((e = this._sizeTextArea), Qi || Ce(se, Xn, es), Qi++, $i.subscribe(e)))),
          (this._unlisten = si(a, {
            keepFocus: !0,
            onBlur: function () {
              t.setState({ hasFocus: !1, isFloatingActive: !!a.value });
            },
            onChange: function (e) {
              if ('file' === n.type) {
                for (var a = [], i = 0, s = e.target.files; i < s.length; i++) {
                  var r = s[i];
                  a.push(r.name);
                }
                t.setState({ files: a.join(', ') });
              }
              n.tags && n.value === N && n.defaultValue === N && t.setState({ value: e.target.value }),
                t._checkFloating(),
                t._change(e.target.value),
                t._emit('onChange', e);
            },
            onFocus: function () {
              t._preventFocus || t.setState({ hasFocus: !0, isFloatingActive: !0 }), (t._preventFocus = !1);
            },
            onHoverIn: function () {
              t._disabled || t.setState({ hasHover: !0 });
            },
            onHoverOut: function () {
              t.setState({ hasHover: !1 });
            },
            onInput: function (e) {
              t._change(e.target.value);
            },
          }));
      }),
      (t.prototype._render = function (e, t) {
        var n = !(!e.endIconSvg && !e.endIcon),
          a = e.pickerValue,
          i = !(!e.startIconSvg && !e.startIcon),
          s = e.label !== N || e.hasChildren,
          r = e.error,
          o = e.rtl ? 'right' : 'left',
          l = e.rtl ? 'left' : 'right',
          c = e.inputStyle,
          h = e.labelStyle,
          u = 'floating' === h,
          d = !(!u || !s || (!t.isFloatingActive && W(e.value))),
          _ = e.disabled === N ? t.disabled : e.disabled,
          p = this._prevS,
          m = e.modelValue !== N ? e.modelValue : e.value,
          f = m !== N ? m : t.value !== N ? t.value : e.defaultValue,
          v =
            this._theme +
            this._rtl +
            (r ? ' mbsc-error' : '') +
            (_ ? ' mbsc-disabled' : '') +
            (t.hasHover ? ' mbsc-hover' : '') +
            (t.hasFocus && !_ ? ' mbsc-focus' : '');
        'file' !== e.type ||
          n ||
          ((e.endIconSvg =
            '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/></svg>'),
          (n = !0)),
          e.tags &&
            (W(a) && (a = []),
            z(a) || (a = [a]),
            (this._tagsArray = e.pickerMap
              ? a.map(function (t) {
                  return e.pickerMap.get(t);
                })
              : W(f)
              ? []
              : f.split(', '))),
          e.passwordToggle &&
            ((n = !0),
            (this._passIconClass =
              v +
              ' mbsc-toggle-icon mbsc-textfield-icon mbsc-textfield-icon-' +
              c +
              ' mbsc-textfield-icon-' +
              l +
              ' mbsc-textfield-icon-' +
              c +
              '-' +
              l +
              (s ? ' mbsc-textfield-icon-' + h : '')),
            (this._hidePass = this._hidePass === N ? 'password' === e.type : this._hidePass)),
          (this._hasStartIcon = i),
          (this._hasEndIcon = n),
          (this._hasError = r),
          (this._disabled = _),
          (this._value = f),
          (this._cssClass =
            this._className +
            this._hb +
            v +
            ' mbsc-form-control-wrapper mbsc-textfield-wrapper mbsc-font mbsc-textfield-wrapper-' +
            c +
            (_ ? ' mbsc-disabled' : '') +
            (s ? ' mbsc-textfield-wrapper-' + h : '') +
            (i ? ' mbsc-textfield-wrapper-has-icon-' + o + ' ' : '') +
            (n ? ' mbsc-textfield-wrapper-has-icon-' + l + ' ' : '')),
          s &&
            (this._labelClass =
              v +
              ' mbsc-label mbsc-label-' +
              h +
              ' mbsc-label-' +
              c +
              '-' +
              h +
              (i ? ' mbsc-label-' + c + '-' + h + '-has-icon-' + o + ' ' : '') +
              (n ? ' mbsc-label-' + c + '-' + h + '-has-icon-' + l + ' ' : '') +
              (u && this._animateFloating ? ' mbsc-label-floating-animate' : '') +
              (d ? ' mbsc-label-floating-active' : '')),
          (this._innerClass =
            v + ' mbsc-textfield-inner mbsc-textfield-inner-' + c + (s ? ' mbsc-textfield-inner-' + h : '')),
          i &&
            (this._startIconClass =
              v +
              ' mbsc-textfield-icon mbsc-textfield-icon-' +
              c +
              ' mbsc-textfield-icon-' +
              o +
              ' mbsc-textfield-icon-' +
              c +
              '-' +
              o +
              (s ? ' mbsc-textfield-icon-' + h : '')),
          n &&
            (this._endIconClass =
              v +
              ' mbsc-textfield-icon mbsc-textfield-icon-' +
              c +
              ' mbsc-textfield-icon-' +
              l +
              ' mbsc-textfield-icon-' +
              c +
              '-' +
              l +
              (s ? ' mbsc-textfield-icon-' + h : '')),
          (this._nativeElmClass =
            v +
            ' ' +
            (e.inputClass || '') +
            ' mbsc-textfield mbsc-textfield-' +
            c +
            (e.dropdown ? ' mbsc-select' : '') +
            (s ? ' mbsc-textfield-' + h + ' mbsc-textfield-' + c + '-' + h : '') +
            (d ? ' mbsc-textfield-floating-active' : '') +
            (i
              ? ' mbsc-textfield-has-icon-' +
                o +
                ' mbsc-textfield-' +
                c +
                '-has-icon-' +
                o +
                (s ? ' mbsc-textfield-' + c + '-' + h + '-has-icon-' + o : '')
              : '') +
            (n
              ? ' mbsc-textfield-has-icon-' +
                l +
                ' mbsc-textfield-' +
                c +
                '-has-icon-' +
                l +
                (s ? ' mbsc-textfield-' + c + '-' + h + '-has-icon-' + l : '')
              : '')),
          ('select' === this._tag || e.dropdown) &&
            (this._selectIconClass =
              'mbsc-select-icon mbsc-select-icon-' +
              c +
              this._rtl +
              this._theme +
              (s ? ' mbsc-select-icon-' + h : '') +
              (i ? ' mbsc-select-icon-' + o : '') +
              (n ? ' mbsc-select-icon-' + l : '')),
          ('textarea' === this._tag || e.tags) &&
            ((this._cssClass += ' mbsc-textarea-wrapper'),
            (this._innerClass += ' mbsc-textarea-inner'),
            (this._nativeElmClass += ' mbsc-textarea'),
            'textarea' !== this._tag ||
              (f === this._prevValue &&
                e.inputStyle === p.inputStyle &&
                e.labelStyle === p.labelStyle &&
                e.rows === p.rows &&
                e.theme === p.theme) ||
              (this._shouldSize = !0),
            (this._prevValue = f)),
          e.tags && (this._innerClass += ' mbsc-textfield-tags-inner'),
          'file' === e.type &&
            ((this._dummyElmClass = this._nativeElmClass), (this._nativeElmClass += ' mbsc-textfield-file')),
          (this._errorClass =
            this._theme +
            this._rtl +
            ' mbsc-error-message mbsc-error-message-' +
            c +
            (s ? ' mbsc-error-message-' + h : '') +
            (i ? ' mbsc-error-message-has-icon-' + o : '') +
            (n ? ' mbsc-error-message-has-icon-' + l : '')),
          e.notch &&
            'outline' === c &&
            ((this._fieldSetClass =
              'mbsc-textfield-fieldset' +
              v +
              (i ? ' mbsc-textfield-fieldset-has-icon-' + o : '') +
              (n ? ' mbsc-textfield-fieldset-has-icon-' + l : '')),
            (this._legendClass =
              'mbsc-textfield-legend' +
              this._theme +
              (d || (s && 'stacked' === h) ? ' mbsc-textfield-legend-active' : ''))),
          e.ripple &&
            'outline' !== e.inputStyle &&
            (this._rippleClass =
              'mbsc-textfield-ripple' +
              this._theme +
              (r ? ' mbsc-error' : '') +
              (t.hasFocus ? ' mbsc-textfield-ripple-active' : '')),
          this._valueChecked && (this._animateFloating = !0);
      }),
      (t.prototype._updated = function () {
        var e = this;
        this._shouldSize &&
          ((this._shouldSize = !1),
          ee(this, function () {
            e._sizeTextArea();
          })),
          this._checkFloating();
      }),
      (t.prototype._destroy = function () {
        we(this._el, On, this._onAutoFill),
          we(this._el, Yn, this._sizeTextArea),
          this._unsubscribe &&
            (function (e) {
              Qi--, $i.unsubscribe(e), Qi || we(se, Xn, es);
            })(this._unsubscribe),
          this._unlisten && this._unlisten();
      }),
      (t.defaults = {
        dropdown: !1,
        dropdownIcon: I,
        hideIcon: 'eye-blocked',
        inputStyle: 'underline',
        labelStyle: 'stacked',
        placeholder: '',
        ripple: !1,
        rows: 6,
        showIcon: 'eye',
        type: 'text',
      }),
      (t._name = 'Input'),
      t
    );
  })(En);
  var as = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        Object.defineProperty(t.prototype, 'value', {
          get: function () {
            return this._el && this._el.value;
          },
          set: function (e) {
            (this._el.value = e), this._checkFloating(), 'textarea' === this._tag && this._sizeTextArea();
          },
          enumerable: !0,
          configurable: !0,
        }),
        (t.prototype._template = function (e, t) {
          return (function (e, t, n, s) {
            var r,
              o = n.props;
            o.children;
            var l = o.dropdown;
            o.dropdownIcon, o.endIcon, o.endIconSrc, o.endIconSvg, o.error;
            var c = o.errorMessage,
              h = o.hasChildren;
            o.hideIcon,
              o.hideIconSvg,
              o.inputClass,
              o.inputStyle,
              o.label,
              o.labelStyle,
              o.modelValue,
              o.notch,
              o.passwordToggle,
              o.pickerMap,
              o.pickerValue,
              o.ripple,
              o.rows,
              o.rtl,
              o.showIcon,
              o.showIconSvg,
              o.startIcon,
              o.startIconSrc,
              o.startIconSvg;
            var u = o.tags;
            o.theme, o.themeVariant;
            var d = o.type,
              _ = i(o, [
                'children',
                'dropdown',
                'dropdownIcon',
                'endIcon',
                'endIconSrc',
                'endIconSvg',
                'error',
                'errorMessage',
                'hasChildren',
                'hideIcon',
                'hideIconSvg',
                'inputClass',
                'inputStyle',
                'label',
                'labelStyle',
                'modelValue',
                'notch',
                'passwordToggle',
                'pickerMap',
                'pickerValue',
                'ripple',
                'rows',
                'rtl',
                'showIcon',
                'showIconSvg',
                'startIcon',
                'startIconSrc',
                'startIconSvg',
                'tags',
                'theme',
                'themeVariant',
                'type',
              ]),
              p = e.label,
              m = (((r = {}).onMouseDown = n._onMouseDown), r);
            return je(
              'label',
              a({ className: n._cssClass }, m),
              (p || h) && je('span', { className: n._labelClass }, h ? '' : p),
              je(
                'span',
                { className: n._innerClass },
                'input' === n._tag &&
                  je(
                    'input',
                    a({ value: N }, _, {
                      ref: n._setEl,
                      className: n._nativeElmClass + (e.tags ? ' mbsc-textfield-hidden' : ''),
                      disabled: n._disabled,
                      type: e.passwordToggle ? (n._hidePass ? 'password' : 'text') : d,
                    }),
                  ),
                'file' === d &&
                  je('input', {
                    className: n._dummyElmClass,
                    disabled: n._disabled,
                    placeholder: e.placeholder,
                    readOnly: !0,
                    type: 'text',
                    value: t.files || '',
                  }),
                'select' === n._tag &&
                  je(
                    'select',
                    a({ value: N }, _, {
                      ref: n._setEl,
                      className: 'mbsc-select' + n._nativeElmClass,
                      disabled: n._disabled,
                    }),
                    s,
                  ),
                'textarea' === n._tag &&
                  je(
                    'textarea',
                    a({ value: N }, _, { ref: n._setEl, className: n._nativeElmClass, disabled: n._disabled }),
                  ),
                u &&
                  je(
                    'span',
                    { className: 'mbsc-textfield-tags' + n._nativeElmClass },
                    n._tagsArray.length
                      ? n._tagsArray.map(function (t, a) {
                          return (
                            t &&
                            je(
                              'span',
                              { key: a, className: 'mbsc-textfield-tag' + n._theme + n._rtl },
                              je('span', { className: 'mbsc-textfield-tag-text' + n._theme }, t),
                              je(Ja, {
                                className: 'mbsc-textfield-tag-clear',
                                onClick: function (e) {
                                  return n._onTagClear(e, a);
                                },
                                svg: e.clearIcon,
                                theme: e.theme,
                              }),
                            )
                          );
                        })
                      : je('span', { className: 'mbsc-textfield-tags-placeholder' + n._theme }, e.placeholder),
                  ),
                ('select' === n._tag || l) &&
                  je(Ja, { className: n._selectIconClass, svg: e.dropdownIcon, theme: e.theme }),
                n._hasStartIcon &&
                  je(Ja, { className: n._startIconClass, name: e.startIcon, svg: e.startIconSvg, theme: e.theme }),
                n._hasEndIcon &&
                  !e.passwordToggle &&
                  je(Ja, { className: n._endIconClass, name: e.endIcon, svg: e.endIconSvg, theme: e.theme }),
                e.passwordToggle &&
                  je(Ja, {
                    onClick: n._onClick,
                    className: n._passIconClass,
                    name: n._hidePass ? e.showIcon : e.hideIcon,
                    svg: n._hidePass ? e.showIconSvg : e.hideIconSvg,
                    theme: e.theme,
                  }),
                n._hasError && je('span', { className: n._errorClass }, c),
                e.notch &&
                  'outline' === e.inputStyle &&
                  je(
                    'fieldset',
                    { 'aria-hidden': 'true', className: n._fieldSetClass },
                    je('legend', { className: n._legendClass }, p && 'inline' !== e.labelStyle ? p : '&nbsp;'),
                  ),
                e.ripple && 'outline' !== e.inputStyle && je('span', { className: n._rippleClass }),
              ),
            );
          })(e, t, this, e.children);
        }),
        t
      );
    })(ns),
    is = {
      hasChildren: !0,
      parentClass: 'mbsc-label',
      readAttrs: ['placeholder', 'rows'],
      readProps: ['disabled', 'type'],
      renderToParent: !0,
      slots: { endIcon: 'end-icon', label: 'label', startIcon: 'start-icon' },
      before: function (e, t, n) {
        var a = e.parentNode,
          i = ie.createElement('span');
        if (
          (a.insertBefore(i, e),
          i.appendChild(e),
          (t.inputClass = e.getAttribute('class') || ''),
          'SELECT' === e.nodeName && delete t.hasChildren,
          !t.label && t.hasChildren && (t.label = n[0].textContent),
          t.label)
        ) {
          var s = ie.createElement('span');
          a.insertBefore(s, i);
        }
      },
    };
  function ss(e, t, n) {
    var i = t.inputComponent,
      s = a(
        { defaultValue: (e._value && e._valueText) || '', placeholder: t.placeholder, ref: e._setInput },
        t.inputProps,
      );
    t.inputComponent ||
      ((i = as),
      (s = a(
        {
          'aria-expanded': !!e._isOpen,
          'aria-haspopup': 'dialog',
          disabled: t.disabled,
          dropdown: t.dropdown,
          endIcon: t.endIcon,
          endIconSrc: t.endIconSrc,
          endIconSvg: t.endIconSvg,
          error: t.error,
          errorMessage: t.errorMessage,
          inputStyle: t.inputStyle,
          label: t.label,
          labelStyle: t.labelStyle,
          name: t.name,
          pickerMap: t.valueMap,
          pickerValue: e._value,
          placeholder: t.placeholder,
          rtl: t.rtl,
          startIcon: t.startIcon,
          startIconSrc: t.startIconSrc,
          startIconSvg: t.startIconSvg,
          tags: t.tagInput === N ? t.selectMultiple : t.tagInput,
          theme: t.theme,
          themeVariant: t.themeVariant,
        },
        s,
      )));
    var r = je(i, s);
    return je(
      qe,
      null,
      e._showInput && r,
      je(
        Ti,
        {
          activeElm: t.activeElm,
          anchor: e._anchor,
          anchorAlign: e._anchorAlign,
          animation: t.animation,
          buttons: e._buttons,
          cancelText: t.cancelText,
          closeOnEsc: t.closeOnEsc,
          closeOnOverlayClick: t.closeOnOverlayClick,
          closeOnScroll: t.closeOnScroll,
          closeText: t.closeText,
          contentPadding: !1,
          context: t.context,
          cssClass: e._cssClass,
          disableLeftRight: !0,
          display: t.display,
          focusElm: e._focusElm,
          focusOnClose: t.focusOnClose,
          focusOnOpen: !e._allowTyping,
          focusTrap: t.focusTrap,
          fullScreen: t.fullScreen,
          headerText: e._headerText,
          height: t.height,
          isOpen: e._isOpen,
          maxHeight: t.maxHeight,
          maxWidth: e._maxWidth,
          onClose: e._onPopupClose,
          onClosed: e._onPopupClosed,
          onKeyDown: e._onPopupKey,
          onOpen: e._onPopupOpen,
          onResize: e._onResize,
          setText: t.setText,
          showArrow: t.showArrow,
          showOverlay: !e._allowTyping && t.showOverlay,
          ref: e._setPopup,
          rtl: t.rtl,
          scrollLock: e._scrollLock,
          theme: t.theme,
          themeVariant: t.themeVariant,
          touchUi: e._touchUi,
          windowWidth: e.state.width,
          width: t.width,
        },
        n,
      ),
    );
  }
  a({}, is, { hasValue: !0, parentClass: 'mbsc-select', useOwnChildren: !0 }), a({}, is, { hasValue: !0 });
  var rs = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype._template = function (e) {
          return ss(
            this,
            e,
            (function (e, t) {
              var n = e.renderPreContent ? e.renderPreContent(e.preContentData) : '',
                a = e.renderInContent ? e.renderInContent(e.preContentData) : '';
              return je(
                qe,
                null,
                n,
                je(
                  'div',
                  {
                    className:
                      'mbsc-scroller mbsc-scroller-' +
                      t._displayStyle +
                      t._theme +
                      t._rtl +
                      (t._touchUi ? ' mbsc-scroller-touch' : ' mbsc-scroller-pointer') +
                      ('inline' === e.display ? ' mbsc-font ' : ' ') +
                      t._className,
                  },
                  a,
                  t._wheels.map(function (n, a) {
                    return je(
                      'div',
                      {
                        key: a,
                        className:
                          'mbsc-scroller-wheel-group-cont' +
                          (e.scroll3d ? ' mbsc-scroller-wheel-group-cont-3d' : '') +
                          t._theme,
                      },
                      e.selectOnScroll &&
                        je('div', { className: 'mbsc-scroller-wheel-line' + t._theme, style: t._lineStyle }),
                      je(
                        'div',
                        {
                          className:
                            'mbsc-scroller-wheel-group' +
                            (e.scroll3d ? ' mbsc-scroller-wheel-group-3d' : '') +
                            t._theme,
                        },
                        je('div', {
                          className:
                            'mbsc-scroller-wheel-overlay mbsc-scroller-wheel-overlay-' + t._displayStyle + t._theme,
                          style: t._overlayStyle,
                        }),
                        n.map(function (n, a) {
                          return je(Zi, {
                            activeIndex: t._activeIndexes[n._key],
                            disabled: t._disabled && t._disabled[n._key],
                            display: t._displayStyle,
                            key: a,
                            itemHeight: e.itemHeight,
                            onActiveChange: t._onActiveChange,
                            onIndexChange: t._onWheelIndexChange,
                            onSet: t._onSet,
                            maxIndex: n.max,
                            maxWheelWidth: e.maxWheelWidth,
                            minIndex: n.min,
                            minWheelWidth: e.minWheelWidth,
                            multiple: n.multiple,
                            renderItem: e.renderItem,
                            rows: t._rows,
                            scroll3d: t._scroll3d,
                            selectedIndex: t._indexes[n._key],
                            selectedValues: t._tempValueRep[n._key],
                            selectOnScroll: e.selectOnScroll,
                            theme: e.theme,
                            touchUi: e.touchUi,
                            rtl: e.rtl,
                            wheel: n,
                            wheelWidth: e.wheelWidth,
                          });
                        }),
                      ),
                    );
                  }),
                ),
              );
            })(e, this),
          );
        }),
        t
      );
    })(qi),
    os = { ios: 50, material: 46, windows: 50 },
    ls = ['a', 'h', 'i', 's', 'tt'];
  function cs(e, t, n, a, i, s, r, o, l, c, h, u, d, _, p, m) {
    for (
      var f = Gt(d, _),
        v = f || !Gt(u, _) ? d : Ft(e, d),
        g = f || !Gt(u, d) ? _ : Wt(e, _),
        y = s.a(v),
        b = s.a(g),
        x = !0,
        C = !0,
        w = !1,
        T = 0,
        k = 0,
        S = 0;
      S < n;
      S++
    ) {
      var D = a[i[(E = ls[S])]];
      if (D !== N) {
        var I = x ? s[E](v) : 0,
          M = C ? s[E](g) : r[E];
        t && 1 === S && ((I += y ? 12 : 0), (M += b ? 12 : 0), (D += a[i.a] ? 12 : 0)),
          (x || C) && I < D && D < M && (w = !0),
          D !== I && (x = !1),
          D !== M && (C = !1);
      }
    }
    if (!p) {
      for (S = n + 1; S < 4; S++) {
        var E;
        i[(E = ls[S])] !== N && (s[E](v) > 0 && x && (T = o[l]), s[E](g) < r[E] && C && (k = o[l]));
      }
      C && m && !k && (k = 999 !== g.getMilliseconds() ? o[l] : 0);
    }
    if (x || C || w)
      for (I = x && !w ? s[l](v) + T : 0, M = C && !w ? s[l](g) - k : r[l], S = I; S <= M; S += o[l]) c[h].set(S, !p);
  }
  function hs(e, t) {
    var n = new Date(e);
    return t ? $(+n / 864e5) : n.getMonth() + 12 * (n.getFullYear() - 1970);
  }
  function us(e) {
    return e.getFullYear() + '-' + G(e.getMonth() + 1) + '-' + G(e.getDate());
  }
  function ds(e) {
    return e.getMilliseconds();
  }
  function _s(e) {
    return e.getHours() > 11 ? 1 : 0;
  }
  var ps = (function (e) {
    function t() {
      var t = (null !== e && e.apply(this, arguments)) || this;
      return (
        (t._preset = 'date'),
        (t._innerValues = {}),
        (t._onChange = function (e) {
          t.s.value === N && t.setState({ value: e.value }), t._hook('onChange', e);
        }),
        (t._parseDate = function (e) {
          var n = t.s;
          return e || (t._innerValues = {}), t._getArray(nn(e || n.defaultSelection || new Date(), n, t._format), !!e);
        }),
        (t._formatDate = function (e) {
          var n = t._getDate(e);
          return n ? rn(t._format, n, t.s) : '';
        }),
        (t._getDate = function (e) {
          var n,
            a,
            i = t.s,
            s = t._getArrayPart,
            r = t._wheelOrder,
            o = new Date(new Date().setHours(0, 0, 0, 0));
          if (null === e || e === N) return null;
          if (r.dd !== N) {
            var l = e[r.dd].split('-');
            n = new Date(l[0], l[1] - 1, l[2]);
          }
          r.tt !== N && ((a = n || o), (a = new Date(a.getTime() + (e[r.tt] % 86400) * 1e3)));
          var c = s(e, 'y', n, o),
            h = s(e, 'm', n, o),
            u = Math.min(s(e, 'd', n, o), i.getMaxDayOfMonth(c, h)),
            d = s(e, 'h', a, o);
          return i.getDate(
            c,
            h,
            u,
            t._hasAmPm && s(e, 'a', a, o) ? d + 12 : d,
            s(e, 'i', a, o),
            s(e, 's', a, o),
            s(e, 'u', a, o),
          );
        }),
        (t._validate = function (e) {
          var n = e.direction,
            a = e.index,
            i = e.values,
            s = e.wheels,
            r = [],
            o = t.s,
            l = o.stepHour,
            c = o.stepMinute,
            h = o.stepSecond,
            u = o.mode || t._preset,
            d = t._wheelOrder,
            _ = t._getDatePart,
            p = t._max,
            m = t._min,
            f = Qt(o, t._getDate(i)),
            v = o.getYear(f),
            g = o.getMonth(f),
            y = o.getDate(v, g - 1, 1),
            b = o.getDate(v, g + 2, 1);
          (a !== d.y && a !== d.m && a !== d.d && a !== d.dd && a !== N) ||
            ((t._valids = Pa(o.valid, y, b, o, !0)), (t._invalids = Pa(o.invalid, y, b, o, !0)));
          var x = t._valids,
            C = t._invalids,
            w = Ha(f, o, m ? +m : -1 / 0, p ? +p : 1 / 0, C, x, n),
            T = t._getArray(w),
            k = t._wheels && t._wheels[0][d.d],
            S = _.y(w),
            D = _.m(w),
            I = o.getMaxDayOfMonth(S, D),
            M = { y: m ? m.getFullYear() : -1 / 0, m: 0, d: 1, h: 0, i: 0, s: 0, a: 0, tt: 0 },
            E = {
              y: p ? p.getFullYear() : 1 / 0,
              m: 11,
              d: 31,
              h: Z(t._hasAmPm ? 11 : 23, l),
              i: Z(59, c),
              s: Z(59, h),
              a: 1,
              tt: 86400,
            },
            O = { y: 1, m: 1, d: 1, h: l, i: c, s: h, a: 1, tt: t._timeStep },
            V = !1,
            P = !0,
            L = !0;
          if (
            (['dd', 'y', 'm', 'd', 'tt', 'a', 'h', 'i', 's'].forEach(function (e) {
              var t = M[e],
                n = E[e],
                a = _[e](w),
                i = d[e];
              if (
                (P && m && (t = _[e](m)),
                L && p && (n = _[e](p)),
                a < t && (a = t),
                a > n && (a = n),
                'dd' === e || 'tt' === e || ('a' === e && i === N) || (P && (P = a === t), L && (L = a === n)),
                i !== N)
              ) {
                if (((r[i] = new Map()), 'y' !== e && 'dd' !== e))
                  for (var s = M[e]; s <= E[e]; s += O[e]) (s < t || s > n) && r[i].set(s, !0);
                if ('d' === e && C)
                  for (var l in C)
                    if (!x || !x[l]) {
                      var c = new Date(l),
                        h = o.getYear(c),
                        u = o.getMonth(c);
                      h === S && u === D && La(o, c, C, x) && r[i].set(o.getDay(c), !0);
                    }
              }
            }),
            /time/i.test(u))
          ) {
            var H = C && C[jt(w)],
              R = x && x[jt(w)];
            ls.forEach(function (e, a) {
              var i = d[e];
              if (i !== N) {
                var l = o.valid ? R : H;
                if (l) {
                  if (o.valid) for (var c = 0; c <= E[e]; c++) r[i].set(c, !0);
                  for (var h = 0, u = l; h < u.length; h++) {
                    var p = u[h],
                      m = p.start,
                      f = p.end;
                    m && f && cs(o, t._hasAmPm, a, T, d, _, E, O, e, r, i, w, m, f, !!o.valid, o.exclusiveEndDates);
                  }
                }
                T[i] = Fi(s[i], _[e](w), r[i], n);
              }
            });
          }
          var z = t._dateDisplay;
          if (k && (k.data.length !== I || /DDD/.test(z))) {
            for (
              var Y = [],
                A = z
                  .replace(/[my|]/gi, '')
                  .replace(/DDDD/, '{dddd}')
                  .replace(/DDD/, '{ddd}')
                  .replace(/DD/, '{dd}')
                  .replace(/D/, '{d}'),
                F = 1;
              F <= I;
              F++
            ) {
              var W = o.getDate(S, D, F).getDay(),
                U = A.replace(/{dddd}/, o.dayNames[W])
                  .replace(/{ddd}/, o.dayNamesShort[W])
                  .replace(/{dd}/, G(F) + o.daySuffix)
                  .replace(/{d}/, F + o.daySuffix);
              Y.push({ display: U, value: F });
            }
            (k.data = Y), (V = !0);
          }
          return { disabled: r, init: V, valid: T };
        }),
        (t._shouldValidate = function (e, t) {
          return (
            !!((e.min && +e.min != +t.min) || (e.max && +e.max != +t.max)) ||
            e.wheels !== t.wheels ||
            e.dataTimezone !== t.dataTimezone ||
            e.displayTimezone !== t.displayTimezone
          );
        }),
        (t._setScroller = function (e) {
          t._scroller = e;
        }),
        (t._getYearValue = function (e) {
          return { display: (/yy/i.test(t._dateDisplay) ? e : (e + '').substr(2, 2)) + t.s.yearSuffix, value: e };
        }),
        (t._getYearIndex = function (e) {
          return +e;
        }),
        (t._getDateIndex = function (e) {
          return hs(e, t._hasDay);
        }),
        (t._getDateItem = function (e) {
          var n = t.s,
            a = t._hasDay,
            i = new Date(new Date().setHours(0, 0, 0, 0)),
            s = a ? new Date(864e5 * e) : new Date(1970, e, 1);
          return (
            a && (s = new Date(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate())),
            {
              disabled: a && La(n, s, t._invalids, t._valids),
              display: i.getTime() === s.getTime() ? n.todayText : rn(t._dateTemplate, s, n),
              value: us(s),
            }
          );
        }),
        (t._getArrayPart = function (e, n, a, i) {
          var s;
          return t._wheelOrder[n] === N || ((s = +e[t._wheelOrder[n]]), isNaN(s))
            ? a
              ? t._getDatePart[n](a)
              : t._innerValues[n] !== N
              ? t._innerValues[n]
              : t._getDatePart[n](i)
            : s;
        }),
        (t._getHours = function (e) {
          var n = e.getHours();
          return Z((n = t._hasAmPm && n >= 12 ? n - 12 : n), t.s.stepHour);
        }),
        (t._getMinutes = function (e) {
          return Z(e.getMinutes(), t.s.stepMinute);
        }),
        (t._getSeconds = function (e) {
          return Z(e.getSeconds(), t.s.stepSecond);
        }),
        (t._getFullTime = function (e) {
          return Z(J((e.getTime() - new Date(e).setHours(0, 0, 0, 0)) / 1e3), t._timeStep || 1);
        }),
        t
      );
    }
    return (
      n(t, e),
      (t.prototype.getVal = function () {
        return this._value;
      }),
      (t.prototype.setVal = function (e) {
        (this._value = e), this.setState({ value: e });
      }),
      (t.prototype.position = function () {
        this._scroller && this._scroller.position();
      }),
      (t.prototype.isVisible = function () {
        return this._scroller && this._scroller.isVisible();
      }),
      (t.prototype._valueEquals = function (e, t) {
        return ln(e, t, this.s);
      }),
      (t.prototype._render = function (e, t) {
        var n = !1,
          a = this._prevS,
          i = e.dateFormat,
          s = e.timeFormat,
          r = e.mode || this._preset,
          o = 'datetime' === r ? i + e.separator + s : 'time' === r ? s : i;
        (this._value = e.value === N ? t.value : e.value),
          (this._minWheelWidth = e.minWheelWidth || ('datetime' === r ? os[e.baseTheme || e.theme] : N)),
          (this._dateWheels = e.dateWheels || ('datetime' === r ? e.dateWheelFormat : i)),
          (this._dateDisplay = e.dateWheels || e.dateDisplay),
          (this._timeWheels = e.timeWheels || s),
          (this._timeDisplay = this._timeWheels),
          (this._format = o),
          (this._hasAmPm = /h/.test(this._timeDisplay)),
          (this._getDatePart = {
            y: e.getYear,
            m: e.getMonth,
            d: e.getDay,
            h: this._getHours,
            i: this._getMinutes,
            s: this._getSeconds,
            u: ds,
            a: _s,
            dd: us,
            tt: this._getFullTime,
          }),
          +nn(a.min) != +nn(e.min) && ((n = !0), (this._min = W(e.min) ? N : nn(e.min, e, o))),
          +nn(a.max) != +nn(e.max) && ((n = !0), (this._max = W(e.max) ? N : nn(e.max, e, o))),
          (e.theme !== a.theme ||
            e.mode !== a.mode ||
            e.locale !== a.locale ||
            e.dateWheels !== a.dateWheels ||
            e.timeWheels !== a.timeWheels ||
            n) &&
            (this._wheels = this._getWheels());
      }),
      (t.prototype._getWheels = function () {
        this._wheelOrder = {};
        var e,
          t = this.s,
          n = t.mode || this._preset,
          a = this._hasAmPm,
          i = this._dateDisplay,
          s = this._timeDisplay,
          r = this._wheelOrder,
          o = [],
          l = [],
          c = [],
          h = 0;
        if (/date/i.test(n)) {
          for (var u = 0, d = this._dateWheels.split(/\|/.test(this._dateWheels) ? '|' : ''); u < d.length; u++) {
            var _ = 0;
            if ((y = d[u]).length)
              if ((/y/i.test(y) && _++, /m/i.test(y) && _++, /d/i.test(y) && _++, _ > 1 && r.dd === N))
                (r.dd = h), h++, l.push(this._getDateWheel(y)), (c = l);
              else if (/y/i.test(y) && r.y === N)
                (r.y = h),
                  h++,
                  l.push({
                    cssClass: 'mbsc-datetime-year-wheel',
                    getIndex: this._getYearIndex,
                    getItem: this._getYearValue,
                    max: this._max ? t.getYear(this._max) : N,
                    min: this._min ? t.getYear(this._min) : N,
                    spaceAround: !0,
                  });
              else if (/m/i.test(y) && r.m === N) {
                (r.m = h), (e = []), h++;
                for (
                  var p = i
                      .replace(/[dy|]/gi, '')
                      .replace(/MMMM/, '{mmmm}')
                      .replace(/MMM/, '{mmm}')
                      .replace(/MM/, '{mm}')
                      .replace(/M/, '{m}'),
                    m = 0;
                  m < 12;
                  m++
                ) {
                  var f = p
                    .replace(/{mmmm}/, t.monthNames[m])
                    .replace(/{mmm}/, t.monthNamesShort[m])
                    .replace(/{mm}/, G(m + 1) + (t.monthSuffix || ''))
                    .replace(/{m}/, m + 1 + (t.monthSuffix || ''));
                  e.push({ display: f, value: m });
                }
                l.push({ cssClass: 'mbsc-datetime-month-wheel', data: e, spaceAround: !0 });
              } else if (/d/i.test(y) && r.d === N) {
                (r.d = h), (e = []), h++;
                for (m = 1; m < 32; m++) e.push({ display: (/dd/i.test(i) ? G(m) : m) + t.daySuffix, value: m });
                l.push({ cssClass: 'mbsc-datetime-day-wheel', data: e, spaceAround: !0 });
              }
          }
          o.push(l);
        }
        if (/time/i.test(n)) {
          for (var v = 0, g = this._timeWheels.split(/\|/.test(this._timeWheels) ? '|' : ''); v < g.length; v++) {
            var y;
            _ = 0;
            if (
              ((y = g[v]).length &&
                (/h/i.test(y) && _++, /m/i.test(y) && _++, /s/i.test(y) && _++, /a/i.test(y) && _++),
              _ > 1 && r.tt === N)
            )
              (r.tt = h), h++, c.push(this._getTimeWheel(y));
            else if (/h/i.test(y) && r.h === N) {
              (e = []), (r.h = h), h++;
              for (m = 0; m < (a ? 12 : 24); m += t.stepHour)
                e.push({ display: a && 0 === m ? 12 : /hh/i.test(s) ? G(m) : m, value: m });
              c.push({ cssClass: 'mbsc-datetime-hour-wheel', data: e, spaceAround: !0 });
            } else if (/m/i.test(y) && r.i === N) {
              (e = []), (r.i = h), h++;
              for (m = 0; m < 60; m += t.stepMinute) e.push({ display: /mm/i.test(s) ? G(m) : m, value: m });
              c.push({ cssClass: 'mbsc-datetime-minute-wheel', data: e, spaceAround: !0 });
            } else if (/s/i.test(y) && r.s === N) {
              (e = []), (r.s = h), h++;
              for (m = 0; m < 60; m += t.stepSecond) e.push({ display: /ss/i.test(s) ? G(m) : m, value: m });
              c.push({ cssClass: 'mbsc-datetime-second-wheel', data: e, spaceAround: !0 });
            } else
              /a/i.test(y) &&
                r.a === N &&
                ((r.a = h),
                h++,
                c.push({
                  cssClass: 'mbsc-dt-whl-a',
                  data: /A/.test(y)
                    ? [
                        { display: t.amText.toUpperCase(), value: 0 },
                        { display: t.pmText.toUpperCase(), value: 1 },
                      ]
                    : [
                        { display: t.amText, value: 0 },
                        { display: t.pmText, value: 1 },
                      ],
                  spaceAround: !0,
                }));
          }
          c !== l && o.push(c);
        }
        return o;
      }),
      (t.prototype._getDateWheel = function (e) {
        var t = /d/i.test(e);
        return (
          (this._hasDay = t),
          (this._dateTemplate = e),
          {
            cssClass: 'mbsc-datetime-date-wheel',
            getIndex: this._getDateIndex,
            getItem: this._getDateItem,
            label: '',
            max: this._max ? hs(us(this._max), t) : N,
            min: this._min ? hs(us(this._min), t) : N,
            spaceAround: !0,
          }
        );
      }),
      (t.prototype._getTimeWheel = function (e) {
        var t = this.s,
          n = [],
          a = 1;
        /s/i.test(e)
          ? (a = t.stepSecond)
          : /m/i.test(e)
          ? (a = 60 * t.stepMinute)
          : /h/i.test(e) && (a = 3600 * t.stepHour),
          (this._timeStep = a);
        for (var i = 0; i < 86400; i += a) {
          var s = new Date(new Date().setHours(0, 0, 0, 0) + 1e3 * i);
          n.push({ display: rn(e, s, t), value: i });
        }
        return { data: n, label: '', spaceAround: !0 };
      }),
      (t.prototype._getArray = function (e, t) {
        var n = [],
          a = this._wheelOrder;
        if (null === e || e === N) return n;
        for (var i = 0, s = ['y', 'm', 'd', 'a', 'h', 'i', 's', 'u', 'dd', 'tt']; i < s.length; i++) {
          var r = s[i],
            o = this._getDatePart[r](e);
          a[r] !== N && (n[a[r]] = o), t && (this._innerValues[r] = o);
        }
        return n;
      }),
      (t.defaults = a({}, Rt, {
        dateDisplay: 'MMMMDDYYYY',
        dateWheelFormat: '|DDD MMM D|',
        stepHour: 1,
        stepMinute: 1,
        stepSecond: 1,
      })),
      (t._name = 'Datetime'),
      t
    );
  })(En);
  var ms = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype._template = function (e) {
          return (function (e, t) {
            return je(
              rs,
              {
                disabled: e.disabled,
                endIcon: e.endIcon,
                endIconSrc: e.endIconSrc,
                endIconSvg: e.endIconSvg,
                error: e.error,
                errorMessage: e.errorMessage,
                inputStyle: e.inputStyle,
                label: e.label,
                labelStyle: e.labelStyle,
                placeholder: e.placeholder,
                name: e.name,
                startIcon: e.startIcon,
                startIconSrc: e.startIconSrc,
                startIconSvg: e.startIconSvg,
                anchor: e.anchor,
                animation: e.animation,
                buttons: e.buttons,
                cancelText: e.cancelText,
                clearText: e.clearText,
                closeOnOverlayClick: e.closeOnOverlayClick,
                context: e.context,
                display: e.display,
                focusOnClose: e.focusOnClose,
                focusTrap: e.focusTrap,
                headerText: e.headerText,
                height: e.height,
                setText: e.setText,
                showArrow: e.showArrow,
                showOverlay: e.showOverlay,
                width: e.width,
                circular: e.circular,
                displayStyle: e.displayStyle,
                formatValue: t._formatDate,
                getValue: t._getDate,
                itemHeight: e.itemHeight,
                maxWheelWidth: e.maxWheelWidth,
                minWheelWidth: t._minWheelWidth,
                parseValue: t._parseDate,
                ref: t._setScroller,
                rows: e.rows,
                rtl: e.rtl,
                shouldValidate: t._shouldValidate,
                showOnClick: e.showOnClick,
                showOnFocus: e.showOnFocus,
                theme: e.theme,
                themeVariant: e.themeVariant,
                touchUi: t._touchUi,
                validate: t._validate,
                value: t._value,
                valueEquality: t._valueEquals,
                wheels: t._wheels,
                wheelWidth: e.wheelWidth,
                onChange: t._onChange,
              },
              e.children,
            );
          })(e, this);
        }),
        t
      );
    })(ps),
    fs = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (t._preset = 'datetime'), t;
      }
      return n(t, e), t;
    })(ms),
    vs = ft({}),
    gs = {};
  function ys(e, t, n) {
    var a = gs[e];
    a && (n !== N && (a.selectedIndex = n), t !== N && (a.value = t), a.change.next(a.value));
  }
  function bs(e) {
    return gs[e] && gs[e].selectedIndex;
  }
  var xs = 1,
    Cs = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t._id = 'mbsc-segmented-group' + xs++),
          (t._onChange = function (e, n) {
            var a = t.s,
              i = t.value;
            if ('multiple' === a.select) {
              if (i !== N) {
                var s = (i = i || []).indexOf(n);
                -1 !== s ? i.splice(s, 1) : i.push(n), (t.value = i.slice());
              }
            } else t.value = n;
            a.onChange && a.onChange(e);
          }),
          t
        );
      }
      return (
        n(t, e),
        (t.prototype._setupDrag = function () {
          var e,
            t,
            n,
            a,
            i,
            s,
            r = this,
            o = [],
            l = [];
          this._unlisten = si(this._el, {
            onEnd: function () {
              n && a !== i && !o[a] && r._el.querySelectorAll('.mbsc-segmented-input')[a].click();
              (n = !1), r.setState({ dragging: !1 });
            },
            onMove: function (i) {
              if (n) {
                for (var c = Math.min(Math.max(i.endX - t, 0), e), h = 0, u = l[0]; c > u && l.length > h + 1; )
                  h++, (u += l[h]);
                (h = r.s.rtl ? l.length - 1 - h : h) === a || o[h] || ys(s, N, (a = h));
              }
            },
            onStart: function (c) {
              var h = Le(c.domEvent.target, '.mbsc-segmented-item', r._el);
              if (h) {
                var u = h.querySelector('.mbsc-segmented-input');
                if (u.classList.contains('mbsc-selected')) {
                  (o = []),
                    Re(r._el.querySelectorAll('.mbsc-segmented-button'), function (e) {
                      o.push(e.classList.contains('mbsc-disabled'));
                    }),
                    (l = []),
                    Re(r._el.querySelectorAll('.mbsc-segmented-item'), function (e) {
                      l.push(e.clientWidth);
                    });
                  (e = r._el.clientWidth - 30),
                    (t = Ne(r._el).left + 15),
                    (s = u.name),
                    (a = bs(s)),
                    (i = a),
                    l.length && 'radio' === u.type && ((n = !0), r.setState({ dragging: !0 }));
                }
              }
            },
          });
        }),
        (t.prototype._cleanupDrag = function () {
          this._unlisten && (this._unlisten(), (this._unlisten = null));
        }),
        (t.prototype._render = function (e) {
          (this._name = e.name === N ? this._id : e.name),
            (this._groupClass =
              'mbsc-segmented ' +
              this._className +
              this._theme +
              this._rtl +
              (e.color ? ' mbsc-segmented-' + e.color : '') +
              (this.state.dragging ? ' mbsc-segmented-dragging' : '')),
            (this._groupOpt = {
              color: e.color,
              disabled: e.disabled,
              name: this._name,
              onChange: this._onChange,
              select: e.select,
              value: e.value,
            });
        }),
        (t.prototype._updated = function () {
          this.s.drag && 'multiple' !== this.s.select ? this._unlisten || this._setupDrag() : this._cleanupDrag();
        }),
        (t.prototype._destroy = function () {
          this._cleanupDrag();
        }),
        (t.defaults = { select: 'single' }),
        (t._name = 'SegmentedGroup'),
        t
      );
    })(En);
  var ws = (function (e) {
      function t() {
        return (null !== e && e.apply(this, arguments)) || this;
      }
      return (
        n(t, e),
        (t.prototype._template = function (e) {
          return je(vs.Provider, {
            children: ((t = this), (n = e.children), je('div', { className: t._groupClass, ref: t._setEl }, n)),
            value: this._groupOpt,
          });
          var t, n;
        }),
        t
      );
    })(Cs),
    Ts = 1,
    ks = (function (e) {
      function t() {
        var t = (null !== e && e.apply(this, arguments)) || this;
        return (
          (t._onChange = function (e) {
            var n = t.s,
              a = e.target.checked;
            a !== t._checked &&
              (t._change(a),
              t._onGroupChange && t._onGroupChange(e, t._value),
              t._toggle(a),
              n.onChange && n.onChange(e));
          }),
          (t._onValueChange = function (e) {
            var n = t.s,
              a = t._isMultiple ? e && -1 !== e.indexOf(t._value) : e === t._value;
            n.checked === N && a !== t.state.selected ? t.setState({ selected: a }) : t.forceUpdate(), t._change(a);
          }),
          (t._setBox = function (e) {
            t._box = e;
          }),
          t
        );
      }
      return (
        n(t, e),
        (t.prototype._change = function (e) {}),
        (t.prototype._groupOptions = function (e) {
          var t = this,
            n = e.color,
            a = e.disabled,
            i = e.name,
            s = e.onChange,
            r = e.select,
            l = e.value,
            c = this.s,
            h = this.state,
            u = this._checked,
            d = c.modelValue !== N ? c.modelValue === c.value : c.checked,
            _ = d !== N ? B(d) : h.selected === N ? B(c.defaultChecked) : h.selected;
          (this._id = c.id || 'mbsc-segmented-' + Ts++),
            (this._value = c.value === N ? this._id : c.value),
            (this._onGroupChange = s),
            (this._isMultiple = 'multiple' === (r || c.select)),
            (this._name = i === N ? c.name : i),
            (this._disabled = a === N ? (c.disabled === N ? h.disabled : B(c.disabled)) : B(a)),
            (this._color = n === N ? c.color : n),
            (this._checked = l === N ? _ : this._isMultiple ? l && -1 !== l.indexOf(this._value) : l === this._value),
            this._name &&
              !this._unsubscribe &&
              (this._unsubscribe = (function (e, t) {
                return gs[e] || (gs[e] = { change: new o(), selectedIndex: -1 }), gs[e].change.subscribe(t);
              })(this._name, this._onValueChange)),
            this._isMultiple ||
              u ||
              !this._checked ||
              setTimeout(function () {
                t._checked && ys(t._name, t._value, t._index);
              }),
            (this._selectedIndex = bs(this._name)),
            (this._cssClass =
              'mbsc-segmented-item ' +
              this._className +
              this._theme +
              this._rtl +
              (this._checked ? ' mbsc-segmented-item-checked' : '') +
              (h.hasFocus ? ' mbsc-focus' : '') +
              (this._index === this._selectedIndex ||
              (this._index === N && this._checked) ||
              (this._isMultiple && this._checked)
                ? ' mbsc-segmented-item-selected'
                : ''));
        }),
        (t.prototype._toggle = function (e) {
          this.s.checked === N && this.setState({ selected: e });
        }),
        (t.prototype._mounted = function () {
          var e = this;
          Ce(this._el, Pn, this._onChange),
            (this._unlisten = si(this._el, {
              onBlur: function () {
                e.setState({ hasFocus: !1 });
              },
              onFocus: function () {
                e.setState({ hasFocus: !0 });
              },
            }));
        }),
        (t.prototype._updated = function () {
          if (!this._isMultiple) {
            var e = Le(this._el, '.mbsc-segmented'),
              t = -1,
              n = -1;
            if (e)
              for (
                var a = e.querySelectorAll('.mbsc-segmented-input[name="' + this._name + '"]'), i = 0;
                i < a.length;
                i++
              )
                a[i] === this._el && (t = i), a[i].checked && (n = i);
            this._index !== t &&
              -1 !== n &&
              (function (e, t) {
                gs[e] && (gs[e].selectedIndex = t);
              })(this._name, n),
              -1 !== this._selectedIndex &&
                ((this._box.style.transform =
                  'translateX(' + (this.s.rtl ? -1 : 1) * (this._selectedIndex - t) * 100 + '%)'),
                (this._animate = !0)),
              -1 !== t && (this._index = t);
          }
        }),
        (t.prototype._destroy = function () {
          var e, t, n;
          we(this._el, Pn, this._onChange),
            this._unsubscribe &&
              ((e = this._name),
              (t = this._unsubscribe),
              (n = gs[e]) && (n.change.unsubscribe(t), n.change.nr || delete gs[e])),
            this._unlisten && this._unlisten();
        }),
        (t.defaults = { select: 'single' }),
        (t._name = 'Segmented'),
        t
      );
    })(En);
  var Ss = (function (e) {
    function t() {
      return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
      n(t, e),
      Object.defineProperty(t.prototype, 'checked', {
        get: function () {
          return this._checked;
        },
        set: function (e) {
          this._toggle(e);
        },
        enumerable: !0,
        configurable: !0,
      }),
      (t.prototype._template = function (e, t) {
        var n = this;
        return je(vs.Consumer, null, function (a) {
          return (function (e, t, n, a, i) {
            return (
              n._groupOptions(i),
              je(
                'label',
                { className: n._cssClass },
                je('input', {
                  ref: n._setEl,
                  'aria-labelledby': n._id,
                  checked: n._checked,
                  className:
                    'mbsc-segmented-input mbsc-reset ' +
                    (e.inputClass || '') +
                    n._theme +
                    (n._checked ? ' mbsc-selected' : ''),
                  disabled: n._disabled,
                  name: n._isMultiple ? e.name : n._name,
                  onChange: K,
                  type: n._isMultiple ? 'checkbox' : 'radio',
                  value: n._value,
                }),
                je(
                  'div',
                  {
                    ref: n._setBox,
                    className:
                      'mbsc-segmented-selectbox' +
                      n._theme +
                      (n._animate ? ' mbsc-segmented-selectbox-animate' : '') +
                      (n._checked ? ' mbsc-selected' : ''),
                  },
                  je('div', {
                    className:
                      'mbsc-segmented-selectbox-inner' +
                      n._theme +
                      (n._index === n._selectedIndex || n._checked ? ' mbsc-segmented-selectbox-inner-visible' : '') +
                      (n._checked ? ' mbsc-selected' : ''),
                  }),
                ),
                je(
                  oi,
                  {
                    'aria-hidden': !0,
                    ariaLabel: e.ariaLabel,
                    className:
                      'mbsc-segmented-button' +
                      (n._checked ? ' mbsc-selected' : '') +
                      (t.hasFocus ? ' mbsc-focus' : ''),
                    color: n._color,
                    disabled: n._disabled,
                    endIcon: e.endIcon,
                    endIconSrc: e.endIconSrc,
                    endIconSvg: e.endIconSvg,
                    icon: e.icon,
                    iconSrc: e.iconSrc,
                    iconSvg: e.iconSvg,
                    id: n._id,
                    ripple: e.ripple,
                    rtl: e.rtl,
                    startIcon: e.startIcon,
                    startIconSrc: e.startIconSrc,
                    startIconSvg: e.startIconSvg,
                    tag: 'span',
                    tabIndex: -1,
                    theme: e.theme,
                    themeVariant: e.themeVariant,
                  },
                  a,
                ),
              )
            );
          })(e, t, n, e.children, a);
        });
      }),
      t
    );
  })(ks);
  function Ds(e) {
    var t,
      n = e.disabled,
      i = e.selected,
      s = e.theme,
      r = e.timeSlot,
      o = e.onClick,
      l = e.onKeyDown,
      c = (((t = {}).onKeyDown = l), t);
    return je(
      'div',
      a(
        {
          className: 'mbsc-timegrid-item' + (i ? ' mbsc-selected' : '') + (n ? ' mbsc-disabled' : '') + s,
          onClick: function () {
            return o(r);
          },
          tabIndex: n ? N : 0,
          'data-timeslot': r.value,
        },
        c,
      ),
      r.formattedValue,
    );
  }
  var Is = (function (e) {
    function t() {
      var t = (null !== e && e.apply(this, arguments)) || this;
      return (
        (t._setTime = function (e) {
          t._hook('onChange', { value: tn(t.s, e.value) });
        }),
        (t._isDisabled = function (e) {
          if (e) {
            var n = jt(tn(t.s, e)),
              a = t._invalids && t._invalids[n],
              i = t._valids && t._valids[n],
              s = t.s.exclusiveEndDates;
            if (i) {
              for (var r = 0, o = i; r < o.length; r++) {
                var l = o[r],
                  c = l.end && (s ? e < +l.end : e <= +l.end);
                if ((l.start && e >= +l.start && c) || l.allDay) return !1;
              }
              return !0;
            }
            if (a) {
              for (var h = 0, u = a; h < u.length; h++) {
                var d = u[h];
                c = d.end && (s ? e < +d.end : e <= +d.end);
                if ((d.start && e >= +d.start && c) || d.allDay) return !0;
              }
              return !1;
            }
          }
          return !1;
        }),
        (t._onKeyDown = function (e) {
          if (e.keyCode === ta) e.target.click(), e.preventDefault();
        }),
        (t._setCont = function (e) {
          t._gridContEl = e && e.parentElement;
        }),
        t
      );
    }
    return (
      n(t, e),
      (t.prototype._render = function (e, t) {
        var n = this,
          a = this._prevS;
        this._cssClass = 'mbsc-timegrid-container mbsc-font' + this._theme + this._rtl;
        var i = e.min !== a.min,
          s = e.max !== a.max,
          r = e.timeFormat,
          o = (a.value && !e.value) || (e.value && +e.value !== this._value);
        i && (this._min = W(e.min) ? N : nn(e.min, e, r)), s && (this._max = W(e.max) ? N : nn(e.max, e, r));
        var l = Bt(e.value || tn(e)),
          c = cn(l, 1),
          h = this._selectedDate !== +l,
          u = e.invalid !== a.invalid,
          d = e.valid !== a.valid;
        (u || h) && (this._invalids = Pa(e.invalid, l, c, e, !0)),
          (d || h) && (this._valids = Pa(e.valid, l, c, e, !0)),
          o && (this._value = e.value && +e.value);
        var _ = h || u || i || s || r !== a.timeFormat;
        if (_) {
          this._selectedDate = +l;
          var p = Math.max(+l, +(this._min || -1 / 0)),
            m = Math.min(+c, +(this._max || 1 / 0) + 1),
            f = 36e5 * e.stepHour + 6e4 * e.stepMinute;
          (this._timeSlots = []), (this._validTimes = []);
          for (var v = [], g = 0, y = +l; y < +c; y += f)
            if (m >= p ? y >= p && y < m : y >= p || y < m) {
              var b = { formattedValue: rn(r, tn(e, y), e), value: y };
              v.push(b),
                2 === g && (this._timeSlots.push(v), (v = []), (g = -1)),
                this._isDisabled(y) || this._validTimes.push(b),
                g++;
            }
          v.length && this._timeSlots.push(v);
        }
        if (
          this._isDisabled(this._value) ||
          ((o || _) &&
            -1 ===
              (function (e, t) {
                return ne(e, t, !0);
              })(this._validTimes, function (e) {
                return e.value === n._value;
              }))
        ) {
          var x = (function (e, t) {
            if (null == t || !e.length) return null;
            for (var n = 0; n < e.length && t >= e[n]; ) n++;
            if (n === e.length) return e[n - 1];
            if (0 === n) return e[0];
            var a = e[n - 1],
              i = e[n];
            return t - a < i - t ? a : i;
          })(
            this._validTimes.map(function (e) {
              return e.value;
            }),
            this._value,
          );
          x &&
            (clearTimeout(this._validationHandle),
            (this._validationHandle = setTimeout(function () {
              var e = te(n._validTimes, function (e) {
                return e.value === x;
              });
              n._setTime(e);
            })));
        } else _ && clearTimeout(this._validationHandle);
        this._valueChanged = this._valueChanged || o;
      }),
      (t.prototype._updated = function () {
        if (this._value !== N && (this._valueChanged || (this._isOpen !== this.s.isOpen && this.s.isOpen))) {
          var e = this._lastValue !== N,
            t = this._gridContEl,
            n = t.querySelector('[data-timeslot="' + this._value + '"]');
          n &&
            setTimeout(function () {
              var a = n.getBoundingClientRect(),
                i = a.top,
                s = a.height,
                r = t.getBoundingClientRect(),
                o = r.top,
                l = r.height,
                c = De(t);
              (i + s > o + l || i < o) && Ve(t, N, i - o + c - 5, e);
            }),
            (this._valueChanged = !1),
            (this._lastValue = this._value);
        }
        this._isOpen = this.s.isOpen;
      }),
      (t.defaults = a({}, Rt, { stepHour: 0, stepMinute: 30 })),
      (t._name = 'Timegrid'),
      t
    );
  })(En);
  var Ms = (function (e) {
    function t() {
      return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
      n(t, e),
      (t.prototype._template = function (e) {
        return je(
          'div',
          { className: (t = this)._cssClass, ref: t._setCont },
          t._timeSlots.map(function (e, n) {
            return je(
              'div',
              { className: 'mbsc-timegrid-row', key: n },
              e.map(function (e, n) {
                var a = t._isDisabled(e.value);
                return je(
                  'div',
                  { className: 'mbsc-timegrid-cell' + (a ? ' mbsc-disabled' : ''), key: n },
                  je(Ds, {
                    disabled: a,
                    onKeyDown: t._onKeyDown,
                    selected: t._value === e.value,
                    timeSlot: e,
                    onClick: t._setTime,
                    theme: t._theme,
                  }),
                );
              }),
            );
          }),
        );
        var t;
      }),
      t
    );
  })(Is);
  (Ra[fs._name] = fs), (Ra[Ai._name] = Ai), (Ra[Ms._name] = Ms);
  var Es = (function (e) {
    function t() {
      return (null !== e && e.apply(this, arguments)) || this;
    }
    return (
      n(t, e),
      (t.prototype._template = function (e) {
        return ss(
          this,
          e,
          (function (e, t, n, i) {
            var s = t._renderTabs,
              r = t._controls,
              o = t._activeSelect,
              l = t._rtl,
              c = t._theme;
            return je(
              qe,
              null,
              je(
                'div',
                {
                  className:
                    'mbsc-datepicker mbsc-flex-col mbsc-datepicker-' +
                    e.display +
                    c +
                    ('inline' === e.display ? ' ' + t._className : '') +
                    t._controlsClass,
                },
                t._headerText &&
                  'inline' === e.display &&
                  je('div', { className: 'mbsc-picker-header' + c + t._hb }, t._headerText),
                s &&
                  je(
                    ws,
                    {
                      rtl: e.rtl,
                      theme: e.theme,
                      themeVariant: e.themeVariant,
                      value: t._activeTab,
                      onChange: t._changeActiveTab,
                    },
                    r.map(function (t, n) {
                      return je(
                        Ss,
                        { key: n, rtl: e.rtl, theme: e.theme, themeVariant: e.themeVariant, value: t.name },
                        t.title,
                      );
                    }),
                  ),
                t._renderControls &&
                  je(
                    'div',
                    { className: 'mbsc-range-control-wrapper' + c },
                    je(
                      ws,
                      {
                        theme: e.theme,
                        themeVariant: e.themeVariant,
                        rtl: e.rtl,
                        value: o,
                        onChange: t._changeActiveSelect,
                      },
                      je(
                        Ss,
                        {
                          rtl: e.rtl,
                          theme: e.theme,
                          themeVariant: e.themeVariant,
                          value: 'start',
                          className: 'mbsc-range-start' + (t._tempStartText ? ' mbsc-range-value-nonempty' : ''),
                        },
                        je(
                          'div',
                          { className: 'mbsc-range-control-label' + c + l + ('start' === o ? ' active' : '') },
                          e.rangeStartLabel,
                        ),
                        je(
                          'div',
                          {
                            className:
                              'mbsc-range-control-value' +
                              c +
                              l +
                              ('start' === o ? ' active' : '') +
                              (t._tempStartText ? '' : ' mbsc-range-control-text-empty'),
                          },
                          t._tempStartText || e.rangeStartHelp,
                        ),
                        'start' === o &&
                          t._tempStartText &&
                          je(Ja, {
                            className: 'mbsc-range-label-clear' + l,
                            onClick: t._clearStart,
                            svg: e.clearIcon,
                            theme: e.theme,
                          }),
                      ),
                      je(
                        Ss,
                        {
                          rtl: e.rtl,
                          theme: e.theme,
                          themeVariant: e.themeVariant,
                          value: 'end',
                          className: 'mbsc-range-end' + (t._tempEndText ? ' mbsc-range-value-nonempty' : ''),
                        },
                        je(
                          'div',
                          { className: 'mbsc-range-control-label' + c + l + ('end' === o ? ' active' : '') },
                          e.rangeEndLabel,
                        ),
                        je(
                          'div',
                          {
                            className:
                              'mbsc-range-control-value' +
                              c +
                              l +
                              ('end' === o ? ' active' : '') +
                              (t._tempEndText ? '' : ' mbsc-range-control-text-empty'),
                          },
                          t._tempEndText || e.rangeEndHelp,
                        ),
                        'end' === o &&
                          t._tempEndText &&
                          je(Ja, {
                            className: 'mbsc-range-label-clear' + l,
                            onClick: t._clearEnd,
                            svg: e.clearIcon,
                            theme: e.theme,
                          }),
                      ),
                    ),
                  ),
                je(
                  'div',
                  { className: 'mbsc-datepicker-tab-wrapper mbsc-flex-1-1' + c, ref: t._setWrapper },
                  r.map(function (e, n) {
                    var o = e.options;
                    return (
                      i &&
                        ((o.renderCalendarHeader = i.header),
                        (o.renderDay = i.day),
                        (o.renderDayContent = i.dayContent)),
                      je(
                        'div',
                        {
                          key: n,
                          className:
                            'mbsc-datepicker-tab mbsc-datepicker-tab-' +
                            e.name +
                            c +
                            ((s && e.name === t._activeTab) || !s ? ' mbsc-datepicker-tab-active' : '') +
                            (s && 'time' === e.name ? ' mbsc-datepicker-time-modal' : '') +
                            (s || 1 === r.length ? ' mbsc-datepicker-tab-expand' : ''),
                        },
                        je(e.Component, a({}, o)),
                      )
                    );
                  }),
                ),
              ),
              n,
            );
          })(e, this, e.children),
        );
      }),
      t
    );
  })(Ua);
  function Os(e) {
    return F(e) ? ie.querySelector(e) : e;
  }
  var Vs = {
      before: function (e, t) {
        var n = t.select,
          a = t.startInput,
          i = t.endInput;
        if ('range' === n && a && i) {
          var s = Os(a),
            r = Os(i),
            o = s && s.value,
            l = r && r.value;
          o && l && (t.defaultValue = o + za + l);
        } else t.defaultValue = e.value;
        t.element = e;
      },
    },
    Ns = 0;
  function Ps(e, t, n) {
    'jsonp' === n
      ? (function (e, t) {
          if (se) {
            var n = ie.createElement('script'),
              a = 'mbscjsonp' + ++Ns;
            (se[a] = function (e) {
              n.parentNode.removeChild(n), delete se[a], e && t(e);
            }),
              (n.src = e + (e.indexOf('?') >= 0 ? '&' : '?') + 'callback=' + a),
              ie.body.appendChild(n);
          }
        })(e, t)
      : (function (e, t) {
          var n = new XMLHttpRequest();
          n.open('GET', e, !0),
            (n.onload = function () {
              n.status >= 200 && n.status < 400 && t(JSON.parse(n.response));
            }),
            (n.onerror = function () {}),
            n.send();
        })(e, t);
  }
  var Ls,
    Hs = { getJson: Ps };
  function Rs(e) {
    return Ls || (Ls = Ys.luxon.DateTime.local().zoneName), e && 'local' !== e ? e : Ls;
  }
  b.http = Hs;
  var zs = (function () {
      function e(e, t) {
        void 0 === t && (t = 'utc'), (this._mbsc = !0), (t = Rs(t));
        var n = Ys.luxon.DateTime,
          i = { zone: t };
        if (((this.zone = t), U(e))) this.dt = n.utc().setZone(t);
        else if ($t(e) || A(e)) this.dt = n.fromMillis(+e, i);
        else if (F(e)) this.dt = n.fromISO(e, i);
        else if (z(e)) {
          for (
            var s = ['year', 'month', 'day', 'hour', 'minute', 'second', 'millisecond'], r = {}, o = 0;
            o < e.length && o < 7;
            o++
          )
            r[s[o]] = e[o] + (1 === o ? 1 : 0);
          (Ys.version =
            Ys.version ||
            (function (e) {
              var t = e.fromObject.toString().trim();
              return /^(function )?\w*\(\w+\)/.test(t) ? 1 : 2;
            })(n)),
            1 === Ys.version ? (this.dt = n.fromObject(a({}, r, i))) : (this.dt = n.fromObject(r, i));
        }
      }
      return (
        (e.prototype.clone = function () {
          return new e(this, this.zone);
        }),
        (e.prototype.createDate = function (e, t, n, a, i, s, r) {
          return Ys.createDate({ displayTimezone: this.zone }, e, t, n, a, i, s, r);
        }),
        (e.prototype[Symbol.toPrimitive] = function (e) {
          return this.dt.toJSDate()[Symbol.toPrimitive](e);
        }),
        (e.prototype.toDateString = function () {
          return this.dt.toFormat('ccc MMM dd yyyy');
        }),
        (e.prototype.toISOString = function () {
          return this.dt.toISO();
        }),
        (e.prototype.toJSON = function () {
          return this.dt.toISO();
        }),
        (e.prototype.valueOf = function () {
          return this.dt.valueOf();
        }),
        (e.prototype.getDate = function () {
          return this.dt.day;
        }),
        (e.prototype.getDay = function () {
          return this.dt.weekday % 7;
        }),
        (e.prototype.getFullYear = function () {
          return this.dt.year;
        }),
        (e.prototype.getHours = function () {
          return this.dt.hour;
        }),
        (e.prototype.getMilliseconds = function () {
          return this.dt.millisecond;
        }),
        (e.prototype.getMinutes = function () {
          return this.dt.minute;
        }),
        (e.prototype.getMonth = function () {
          return this.dt.month - 1;
        }),
        (e.prototype.getSeconds = function () {
          return this.dt.second;
        }),
        (e.prototype.getTime = function () {
          return this.valueOf();
        }),
        (e.prototype.getTimezoneOffset = function () {
          return -this.dt.offset;
        }),
        (e.prototype.getUTCDate = function () {
          return this.dt.toUTC().day;
        }),
        (e.prototype.getUTCDay = function () {
          return this.dt.toUTC().weekday % 7;
        }),
        (e.prototype.getUTCFullYear = function () {
          return this.dt.toUTC().year;
        }),
        (e.prototype.getUTCHours = function () {
          return this.dt.toUTC().hour;
        }),
        (e.prototype.getUTCMilliseconds = function () {
          return this.dt.toUTC().millisecond;
        }),
        (e.prototype.getUTCMinutes = function () {
          return this.dt.toUTC().minute;
        }),
        (e.prototype.getUTCMonth = function () {
          return this.dt.toUTC().month - 1;
        }),
        (e.prototype.getUTCSeconds = function () {
          return this.dt.toUTC().second;
        }),
        (e.prototype.setMilliseconds = function (e) {
          return this.setter({ millisecond: e });
        }),
        (e.prototype.setSeconds = function (e, t) {
          return this.setter({ second: e, millisecond: t });
        }),
        (e.prototype.setMinutes = function (e, t, n) {
          return this.setter({ minute: e, second: t, millisecond: n });
        }),
        (e.prototype.setHours = function (e, t, n, a) {
          return this.setter({ hour: e, minute: t, second: n, millisecond: a });
        }),
        (e.prototype.setDate = function (e) {
          return this.setter({ day: e });
        }),
        (e.prototype.setMonth = function (e, t) {
          return e++, this.setter({ month: e, day: t });
        }),
        (e.prototype.setFullYear = function (e, t, n) {
          return this.setter({ year: e, month: t, day: n });
        }),
        (e.prototype.setTime = function (e) {
          return (this.dt = Ys.luxon.DateTime.fromMillis(e)), this.dt.valueOf();
        }),
        (e.prototype.setTimezone = function (e) {
          (e = Rs(e)), (this.zone = e), (this.dt = this.dt.setZone(e));
        }),
        (e.prototype.setUTCMilliseconds = function (e) {
          return 0;
        }),
        (e.prototype.setUTCSeconds = function (e, t) {
          return 0;
        }),
        (e.prototype.setUTCMinutes = function (e, t, n) {
          return 0;
        }),
        (e.prototype.setUTCHours = function (e, t, n, a) {
          return 0;
        }),
        (e.prototype.setUTCDate = function (e) {
          return 0;
        }),
        (e.prototype.setUTCMonth = function (e, t) {
          return 0;
        }),
        (e.prototype.setUTCFullYear = function (e, t, n) {
          return 0;
        }),
        (e.prototype.toUTCString = function () {
          return '';
        }),
        (e.prototype.toTimeString = function () {
          return '';
        }),
        (e.prototype.toLocaleDateString = function () {
          return '';
        }),
        (e.prototype.toLocaleTimeString = function () {
          return '';
        }),
        (e.prototype.setter = function (e) {
          return (this.dt = this.dt.set(e)), this.dt.valueOf();
        }),
        e
      );
    })(),
    Ys = {
      luxon: N,
      version: N,
      parse: function (e, t) {
        return new zs(e, t.dataTimezone || t.displayTimezone);
      },
      createDate: function (e, t, n, a, i, s, r, o) {
        var l = e.displayTimezone;
        return j(t) || F(t) || U(n)
          ? new zs(t, l)
          : new zs([t || 1970, n || 0, a || 1, i || 0, s || 0, r || 0, o || 0], l);
      },
    };
  function As(e) {
    return e && 'local' !== e ? e : Ws.moment.tz.guess();
  }
  var Fs = (function () {
      function e(e, t) {
        (this._mbsc = !0), (this.timezone = As(t)), this.init(e);
      }
      return (
        (e.prototype.clone = function () {
          return new e(this, this.timezone);
        }),
        (e.prototype.createDate = function (e, t, n, a, i, s, r) {
          return Ws.createDate({ displayTimezone: this.timezone }, e, t, n, a, i, s, r);
        }),
        (e.prototype[Symbol.toPrimitive] = function (e) {
          return this.m.toDate()[Symbol.toPrimitive](e);
        }),
        (e.prototype.toDateString = function () {
          return this.m.format('ddd MMM DD YYYY');
        }),
        (e.prototype.toISOString = function () {
          return this.m.toISOString(!0);
        }),
        (e.prototype.toJSON = function () {
          return this.m.toISOString();
        }),
        (e.prototype.valueOf = function () {
          return this.m.valueOf();
        }),
        (e.prototype.getDate = function () {
          return this.m.date();
        }),
        (e.prototype.getDay = function () {
          return this.m.day();
        }),
        (e.prototype.getFullYear = function () {
          return this.m.year();
        }),
        (e.prototype.getHours = function () {
          return this.m.hours();
        }),
        (e.prototype.getMilliseconds = function () {
          return this.m.milliseconds();
        }),
        (e.prototype.getMinutes = function () {
          return this.m.minutes();
        }),
        (e.prototype.getMonth = function () {
          return this.m.month();
        }),
        (e.prototype.getSeconds = function () {
          return this.m.seconds();
        }),
        (e.prototype.getTime = function () {
          return this.m.valueOf();
        }),
        (e.prototype.getTimezoneOffset = function () {
          return -this.m.utcOffset();
        }),
        (e.prototype.getUTCDate = function () {
          return this.utc().date();
        }),
        (e.prototype.getUTCDay = function () {
          return this.utc().day();
        }),
        (e.prototype.getUTCFullYear = function () {
          return this.utc().year();
        }),
        (e.prototype.getUTCHours = function () {
          return this.utc().hours();
        }),
        (e.prototype.getUTCMilliseconds = function () {
          return this.utc().milliseconds();
        }),
        (e.prototype.getUTCMinutes = function () {
          return this.utc().minutes();
        }),
        (e.prototype.getUTCMonth = function () {
          return this.utc().month();
        }),
        (e.prototype.getUTCSeconds = function () {
          return this.utc().seconds();
        }),
        (e.prototype.setMilliseconds = function (e) {
          return +this.m.set({ millisecond: e });
        }),
        (e.prototype.setSeconds = function (e, t) {
          return +this.m.set({ seconds: e, milliseconds: t });
        }),
        (e.prototype.setMinutes = function (e, t, n) {
          return +this.m.set({ minutes: e, seconds: t, milliseconds: n });
        }),
        (e.prototype.setHours = function (e, t, n, a) {
          return +this.m.set({ hours: e, minutes: t, seconds: n, milliseconds: a });
        }),
        (e.prototype.setDate = function (e) {
          return +this.m.set({ date: e });
        }),
        (e.prototype.setMonth = function (e, t) {
          return +this.m.set({ month: e, date: t });
        }),
        (e.prototype.setFullYear = function (e, t, n) {
          return +this.m.set({ year: e, month: t, date: n });
        }),
        (e.prototype.setTime = function (e) {
          return this.init(e), this.m.valueOf();
        }),
        (e.prototype.setTimezone = function (e) {
          (this.timezone = As(e)), this.m.tz(this.timezone);
        }),
        (e.prototype.setUTCMilliseconds = function (e) {
          return 0;
        }),
        (e.prototype.setUTCSeconds = function (e, t) {
          return 0;
        }),
        (e.prototype.setUTCMinutes = function (e, t, n) {
          return 0;
        }),
        (e.prototype.setUTCHours = function (e, t, n, a) {
          return 0;
        }),
        (e.prototype.setUTCDate = function (e) {
          return 0;
        }),
        (e.prototype.setUTCMonth = function (e, t) {
          return 0;
        }),
        (e.prototype.setUTCFullYear = function (e, t, n) {
          return 0;
        }),
        (e.prototype.toUTCString = function () {
          return '';
        }),
        (e.prototype.toTimeString = function () {
          return '';
        }),
        (e.prototype.toLocaleDateString = function () {
          return '';
        }),
        (e.prototype.toLocaleTimeString = function () {
          return '';
        }),
        (e.prototype.init = function (e) {
          var t = Ws.moment.tz,
            n = U(e) || F(e) || A(e) || z(e) ? e : +e,
            a = F(e) && Yt.test(e);
          this.m = a ? t(n, 'HH:mm:ss', this.timezone) : t(n, this.timezone);
        }),
        (e.prototype.utc = function () {
          return this.m.clone().utc();
        }),
        e
      );
    })(),
    Ws = {
      moment: N,
      parse: function (e, t) {
        return new Fs(e, t.dataTimezone || t.displayTimezone);
      },
      createDate: function (e, t, n, a, i, s, r, o) {
        var l = e.displayTimezone;
        return j(t) || F(t) || U(n)
          ? new Fs(t, l)
          : new Fs([t || 1970, n || 0, a || 1, i || 0, s || 0, r || 0, o || 0], l);
      },
    },
    Us = kt(Es, Vs),
    js = ((mi._selector = '[mbsc-calendar-next]'), vi),
    Bs = ((pi._selector = '[mbsc-calendar-prev]'), mi),
    qs = ((fi._selector = '[mbsc-calendar-today]'), pi),
    Xs = ((vi._selector = '[mbsc-calendar-nav]'), fi);
  wt(js),
    wt(Bs),
    wt(qs),
    wt(Xs),
    (e.CalendarNav = js),
    (e.CalendarNext = Bs),
    (e.CalendarPrev = qs),
    (e.CalendarToday = Xs),
    (e.Datepicker = Es),
    (e.autoDetect = C),
    (e.createCustomTheme = k),
    (e.datepicker = Us),
    (e.enhance = Tt),
    (e.formatDate = sn),
    (e.getAutoTheme = T),
    (e.getInst = function (e, t) {
      return t ? e.__mbscFormInst : e.__mbscInst;
    }),
    (e.getJson = Ps),
    (e.globalChanges = w),
    (e.hijriCalendar = It),
    (e.jalaliCalendar = Vt),
    (e.locale = Pt),
    (e.localeEn = Nt),
    (e.luxonTimezone = Ys),
    (e.momentTimezone = Ws),
    (e.options = y),
    (e.parseDate = on),
    (e.platform = S),
    (e.registerComponent = wt),
    (e.setOptions = function (e) {
      for (var t = 0, n = Object.keys(e); t < n.length; t++) {
        var a = n[t];
        y[a] = e[a];
      }
      w.next(y);
    }),
    (e.themes = x),
    (e.util = b),
    Object.defineProperty(e, '__esModule', { value: !0 });
});
